<template>
  <div class="record-page">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <el-button type="text" @click="goBack" class="back-button">
          <i class="el-icon-arrow-left"></i>
          返回列表
        </el-button>
        <h2 class="page-title">录入原始记录</h2>
      </div>
      <div class="header-right">
        <el-button type="primary" @click="handleSubmit('0')" :loading="loading" :disabled="referenceFilling || loading">保存</el-button>
        <el-button type="primary" @click="handleSubmit('3')" :loading="loading" :disabled="referenceFilling || loading">完成</el-button>
        <el-button type="warning" @click="reference" :disabled="referenceFilling || loading">参照</el-button>
        <el-button type="primary" @click="handlePDF">查看原始记录</el-button>
        <el-button @click="goBack">取 消</el-button>
      </div>
    </div>

    <!-- 页面加载遮罩层（初始加载 / 参照回填） -->
    <div v-loading="pageLoading || referenceFilling" :element-loading-text="referenceFilling ? '正在回填参照数据，请稍候...' : '正在加载原始记录数据...'" element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)" class="loading-overlay" v-if="pageLoading || referenceFilling"></div>

    <!-- 基本信息卡片 -->
    <!-- <el-card class="info-card" shadow="never">
      <div slot="header" class="card-header">
        <span>基本信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="info-item">
            <span class="label">委托编号：</span>
            <span class="value">{{ recordInfo.entrustNumber }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <span class="label">电梯识别码：</span>
            <span class="value">{{ recordInfo.elevatorCode }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <span class="label">使用单位：</span>
            <span class="value">{{ recordInfo.useUnitName }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="info-item">
            <span class="label">产品编号：</span>
            <span class="value">{{ recordInfo.productNumber }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <span class="label">产品名称：</span>
            <span class="value">{{ recordInfo.productName }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <span class="label">设备名称：</span>
            <span class="value">{{ recordInfo.equipmentName }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card> -->

    <!-- 主要内容区域 -->
    <div class="page-content">
      <!-- 封面页 -->
      <el-card class="page-card" shadow="hover">
        <div slot="header" class="card-header">
          <span>封面</span>
        </div>
        <div class="card-content">
          <div class="cover-content">
            <!-- 记录编号和二维码 -->
            <div class="cover-top-row">
              <div class="cover-record-number">
                <span class="cover-label">记录编号：</span>
                <el-input v-model="coverInfo.recordNum" placeholder="请输入记录编号" class="cover-input" size="medium"></el-input>
              </div>
              <div class="cover-qrcode-section">
                <div class="cover-qrcode-upload">
                  <span class="cover-label">二维码：</span>
                  <div class="qrcode-upload-area">
                    <!-- 上传功能已注释，仅作显示用途 -->
                    <!-- <el-upload class="qrcode-uploader" action="#" :show-file-list="false" :before-upload="beforeQrcodeUpload" :http-request="handleQrcodeUpload" accept="image/*">
                      <div v-if="coverInfo.qrcodeImage" class="qrcode-preview">
                        <img :src="coverInfo.qrcodeImage" class="qrcode-image" alt="二维码">
                        <div class="qrcode-overlay">
                          <i class="el-icon-edit-outline"></i>
                          <span>重新上传</span>
                        </div>
                      </div>
                      <div v-else class="qrcode-upload-placeholder">
                        <i class="el-icon-plus qrcode-uploader-icon"></i>
                        <div class="qrcode-uploader-text">上传二维码</div>
                      </div>
                    </el-upload> -->
                    <!-- 仅显示二维码图片 -->
                    <div class="qrcode-display">
                      <img v-if="coverInfo.qrcodeImage" :src="coverInfo.qrcodeImage" class="qrcode-image" alt="二维码">
                      <div v-else class="qrcode-empty-placeholder">
                        <!-- 空白占位框 -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 空白区域 -->
            <div class="cover-spacer"></div>

            <!-- 主标题 -->
            <div class="cover-title-section">
              <h1 class="cover-main-title">{{coverInfo.EQP_VART_NAME}}</h1>
              <h2 class="cover-sub-title">自行检测原始记录</h2>
            </div>

            <!-- 空白区域 -->
            <div class="cover-spacer-large"></div>

            <!-- 基本信息表格 -->
            <div class="cover-info-section">
              <div class="cover-info-row">
                <span class="cover-info-label">使用单位：</span>
                <!-- <el-input v-model="coverInfo.useUnitName" placeholder="请输入使用单位" class="cover-info-input" size="medium"></el-input> -->
                <span class="cover-info-value">{{coverInfo.useUnitName}}</span>
              </div>
              <div class="cover-info-row">
                <span class="cover-info-label">设备代码：</span>
                <!-- <el-input v-model="coverInfo.EQP_STATION_COD" placeholder="请输入设备代码" class="cover-info-input" size="medium"></el-input> -->
                <span class="cover-info-value">{{coverInfo.EQP_STATION_COD}}</span>
              </div>
              <div class="cover-info-row">
                <span class="cover-info-label">设备类别：</span>
                <span class="cover-info-value">{{coverInfo.EQP_SORT_NAME}}</span>
              </div>
              <div class="cover-info-row">
                <span class="cover-info-label">检测日期：</span>
                <!-- <el-date-picker v-model="coverInfo.testDate" type="date" placeholder="请选择检测日期" class="cover-info-input" size="medium" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                </el-date-picker> -->
                <span class="cover-info-value">{{coverInfo.testDate}}</span>
              </div>
            </div>

            <!-- 空白区域 -->
            <div class="cover-spacer-large"></div>

            <!-- 底部公司信息 -->
            <div class="cover-company">
              <p class="cover-company-name">晨宇安全科技集团有限公司 编</p>
            </div>
          </div>
        </div>
      </el-card>

      <!-- 第一页卡片 -->
      <el-card class="page-card" shadow="hover">
        <div slot="header" class="card-header">
          <span>填写说明</span>
          <div class="card-header-qrcode">
            <img v-if="coverInfo.qrcodeImage" :src="coverInfo.qrcodeImage" alt="二维码" class="header-qrcode-image">
          </div>
        </div>
        <div class="card-content">
          <div class="instructions-content">
            <h3 class="instructions-title">填写说明</h3>
            <div class="instructions-list">
              <div class="instruction-item">
                <span class="instruction-number">一、</span>
                <span class="instruction-text">本原始记录适用于曳引驱动消防员电梯的检测。</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">二、</span>
                <span class="instruction-text">本原始记录的检测基本内容、要求和方法等均依据《电梯自行检测规则》(TSG T7008-2023)制定。</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">三、</span>
                <span class="instruction-text">检测项目分为关键检测项目和一般检测项目两个类别，其中标有"*"的为关键检测项目。</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">四、</span>
                <span class="instruction-text">检测所用仪器、设备应完好且在计量检定/校准有效期内。</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">五、</span>
                <span class="instruction-text">检测过程中，检测人员应当使用检测信息化管理系统，按照要求如实、规范地记录检测情况，不得漏检、漏记。</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">六、</span>
                <span class="instruction-text">原始记录中，检测项目的"检测结果"应当按照如下要求进行填写：<br />
                  1、对于要求测试数据的项目，在"检测结果"栏填写实测数据；<br />
                  2、对于未要求测试数据的项目，如果经检测符合要求，在"检测结果"栏填写"符合"；如果经检测不符合要求，在"检测结果"栏填写"不符合"，并在"检测问题汇总"栏填写具体的不符合情形描述；<br />
                  3、对于受检电梯不适用的项目，在"检测结果"栏填写"无此项"。</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">七、</span>
                <span class="instruction-text">原始记录一律使用移动终端或电脑终端填写，手写填写或修改无效；</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">八、</span>
                <span class="instruction-text">原始记录应当有检测人员、校核人员签字及检测日期，并对检测结果的真实性、准确性、可靠性、正确性、公正性负责；</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">九、</span>
                <span
                      class="instruction-text">现场全部检测项目经检测后，检测人员应当向使用单位出具与检测记录内容一致的《电梯自行检测备忘录》，使用单位对《电梯自行检测备忘录》上所列出的检测结果为不符合的检测项目及时整改，整改后检测人员对整改进行确认，整改确认情况应记入原始记录中，《电梯自行检测备忘录》及《电梯检测报告》与本原始记录一并存档；</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">十、</span>
                <span class="instruction-text">检测工作必须在满足检测环境条件的前提下进行。检测人员确认现场满足检测条件后方可实施现场检测；</span>
              </div>
              <div class="instruction-item">
                <span class="instruction-number">十一、</span>
                <span class="instruction-text">本原始记录是对设备进行检测当时现场情况的如实记录，仅对当时现场设备状况负责。</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>

      <!-- 设备信息卡片 -->
      <el-card class="page-card" shadow="hover">
        <div slot="header" class="card-header">
          <span>设备信息</span>
          <div class="card-header-qrcode">
            <img v-if="coverInfo.qrcodeImage" :src="coverInfo.qrcodeImage" alt="二维码" class="header-qrcode-image">
          </div>
        </div>
        <div class="card-content">
          <div class="equipment-info-content">
            <!-- 基本设备信息表格 -->
            <div class="equipment-basic-info">
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">使用单位名称</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.useUnitName" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">单位内编号</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.unitInternalNumber" size="small" readonly></el-input>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">统一信用代码</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.USE_UNT_COD" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">设备品种</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.equipmentType" size="small" readonly></el-input>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">设备安装地点</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.installLocation" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">产品型号</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.productModel" size="small" readonly></el-input>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">使用登记证号</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.registrationNumber" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">产品编号</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.productNumber" size="small" readonly></el-input>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">制造单位名称</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.manufacturerName" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">制造日期</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-date-picker v-model="equipmentInfo.manufactureDate" type="date" size="small" style="width: 100%" format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled></el-date-picker>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">改造单位名称</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.renovationUnitName" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">改造日期</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-date-picker v-model="equipmentInfo.renovationDate" type="date" size="small" style="width: 100%" format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled></el-date-picker>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="6" class="info-label-col">维护保养单位</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.maintenanceUnit" size="small" readonly></el-input>
                </el-col>
                <el-col :span="6" class="info-label-col">安管人员</el-col>
                <el-col :span="6" class="info-input-col">
                  <el-input v-model="equipmentInfo.safetyManager" size="small" readonly></el-input>
                </el-col>
              </el-row>
            </div>

            <!-- 设备技术参数 -->
            <div class="equipment-params">
              <div class="equipment-params-header">
                <div class="params-title-wrapper">
                  <div class="params-title-text">设备技术参数</div>
                </div>
                <div class="params-qrcode">
                  <img v-if="coverInfo.qrcodeImage" :src="coverInfo.qrcodeImage" alt="二维码" class="params-qrcode-image">
                </div>
              </div>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="3" class="info-label-col-vertical" style="visibility: hidden;">占位</el-col>
                <el-col :span="5" class="info-label-col">额定载重量(kg)</el-col>
                <el-col :span="4" class="info-input-col">
                  <el-input v-model="equipmentInfo.ratedLoad" size="small" readonly></el-input>
                </el-col>
                <el-col :span="4" class="info-label-col">层/站/门</el-col>
                <el-col :span="8" class="info-input-col">
                  <el-input v-model="equipmentInfo.floorStationDoor" size="small" readonly></el-input>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="3" class="info-label-col-empty"></el-col>
                <el-col :span="5" class="info-label-col">额定速度(m/s)</el-col>
                <el-col :span="4" class="info-input-col">
                  <el-input v-model="equipmentInfo.ratedSpeed" size="small" readonly></el-input>
                </el-col>
                <el-col :span="4" class="info-label-col">控制方式</el-col>
                <el-col :span="8" class="info-input-col">
                  <el-input v-model="equipmentInfo.controlMethod" size="small" readonly></el-input>
                </el-col>
              </el-row>
            </div>

            <!-- 主要检测仪器设备一览表 -->
            <div class="instrument-table-section">
              <div class="section-title-row">
                <div class="section-title">主要检测仪器设备一览表</div>
                <div class="toolbox-selector">
                  <el-button type="default" size="small" style="margin-right: 10px;" :loading="toolboxRestoreLoading" @click="handleRestoreDefaultToolbox">默认配置</el-button>
                  <span style="margin-right: 10px;">工具箱：</span>
                  <el-input v-model="selectedToolboxNum" size="small" readonly style="width: 200px;"></el-input>
                </div>
              </div>
              <el-table :data="instrumentTableData" border size="mini" :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" row-key="id" style="width: 100%">
                <!-- 删除按钮：在“序号”前一列 -->
                <el-table-column label="操作" width="90" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" icon="el-icon-delete" @click="handleInstrumentDelete(scope.row, 'left')">删除</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="serialNumber" label="序号" min-width="60" align="center"></el-table-column>
                <el-table-column prop="name" label="名称" min-width="150" align="center">
                  <template slot-scope="scope">
                    <el-input :value="getEquipmentNameById(scope.row.name)" size="mini" readonly></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="managementNumber" label="管理编号" min-width="120" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.managementNumber" size="mini" readonly></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="usageRecord" label="使用记录" min-width="100" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.usageRecord" size="mini" readonly></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="90" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" icon="el-icon-delete" @click="handleInstrumentDelete(scope.row, 'right')">删除</el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="serialNumber2" label="序号" min-width="60" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.serialNumber2">{{ scope.row.serialNumber2 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="name2" label="名称" min-width="150" align="center">
                  <template slot-scope="scope">
                    <el-input :value="getEquipmentNameById(scope.row.name2)" size="mini" readonly v-if="scope.row.serialNumber2"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="managementNumber2" label="管理编号" min-width="120" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.managementNumber2" size="mini" v-if="scope.row.serialNumber2" readonly></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="usageRecord2" label="使用记录" min-width="100" align="center">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.usageRecord2" size="mini" v-if="scope.row.serialNumber2" readonly></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 检测依据 -->
            <div class="detection-basis">
              <el-row :gutter="0" class="info-table-row">
                <el-col :span="3" class="info-label-col">检测依据</el-col>
                <el-col :span="21" class="info-input-col">
                  <el-input v-model="equipmentInfo.standardData" type="textarea" :rows="3" size="small"></el-input>
                </el-col>
              </el-row>
            </div>

            <!-- 检测环境条件确认 -->
            <div class="environment-conditions-section">
              <div class="section-title">检测环境条件确认</div>
              <el-row :gutter="0" class="info-table-row" style="margin-bottom: 10px;">
                <el-col :span="4" class="info-label-col">供电电压(V)</el-col>
                <el-col :span="4" class="info-input-col">
                  <el-input v-model="equipmentInfo.powerSupply" size="small"></el-input>
                </el-col>
                <el-col :span="4" class="info-label-col">温度(℃)</el-col>
                <el-col :span="4" class="info-input-col">
                  <el-input v-model="equipmentInfo.temperature" size="small"></el-input>
                </el-col>
                <el-col :span="4" class="info-label-col">湿度(%)</el-col>
                <el-col :span="4" class="info-input-col">
                  <el-input v-model="equipmentInfo.humidity" size="small"></el-input>
                </el-col>
              </el-row>
              <el-table :data="environmentConditionsData" border size="mini" :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="environmentConditionsSpanMethod"
                        row-key="id">
                <el-table-column prop="serialNumber" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="requirement" label="检测环境条件要求" align="left" min-width="400"></el-table-column>
                <el-table-column prop="confirmResult" label="确认结果" width="120" align="center">
                  <template slot-scope="scope">
                    <!-- 第1-7条均独立选择确认结果 -->
                    <el-select v-if="scope.$index <= 6" v-model="scope.row.confirmResult" placeholder="请选择" size="mini" style="width: 100%">
                      <el-option label="是" value="qualified"></el-option>
                      <el-option label="否" value="unqualified"></el-option>
                    </el-select>
                    <!-- 第8条“其他：无”仅展示，不需要确认结果 -->
                    <span v-else>-</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 检测问题汇总和备注 -->
            <div class="summary-section">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="summary-item">
                    <div class="summary-label">检测问题汇总</div>
                    <el-input v-model="equipmentInfo.problemSummary" type="textarea" :rows="4" placeholder="无" size="small"></el-input>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="summary-item">
                    <div class="summary-label">备注</div>
                    <el-input v-model="equipmentInfo.remarks" type="textarea" :rows="4" placeholder="无" size="small"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <!-- 日期和签名 -->
            <div class="signature-section">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="signature-item">
                    <span class="signature-label">下次检测日期：</span>
                    <span>{{ equipmentInfo.nextTestDate || '无' }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="signature-item">
                    <span class="signature-label">下次检验日期：</span>
                    <span>{{ equipmentInfo.nextCheckDate || '无' }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top: 20px;">
                <el-col :span="12">
                  <div class="signature-item">
                    <span class="signature-label">检测人员：</span>
                    <div class="personnel-select-area">
                      <el-select v-model="equipmentInfo.detectionPersonnel" placeholder="请选择检测人员" style="width: 100%">
                        <el-option v-for="item in detectionPersonnelOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="signature-item">
                    <span class="signature-label">检测日期：</span>
                    <el-date-picker v-model="equipmentInfo.detectionDate" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin-top: 20px;">
                <el-col :span="24">
                  <div class="signature-item">
                    <span class="signature-label">校核人员：</span>
                    <div class="personnel-select-area">
                      <el-select v-model="equipmentInfo.reviewPersonnel" placeholder="请选择校核人员" style="width: 100%">
                        <el-option v-for="item in reviewPersonnelOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-card>

      <!-- 第一页卡片 - 检测项目编号及名称 -->
      <el-card class="page-card" shadow="hover">
        <div slot="header" class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <span style="padding-right: 10px;">检测项目编号及名称</span>
          <el-button type="primary" size="small" @click="handleFloorSetting">层站设置</el-button>
        </div>
        <div class="card-content" :style="{ height: `${pageOneLayoutHeight}px` }">
          <!-- 左右两栏布局 -->
          <div class="page-one-layout" :style="{ height: `${pageOneLayoutHeight}px` }">
            <!-- 左侧导航区域 -->
            <div class="navigation-panel">
              <div class="nav-title">快速导航</div>
              <div class="nav-list">
                <div v-for="navItem in navigationList" :key="navItem.id" class="nav-item" :class="{ 'active': activeNavId === navItem.id, 'nav-item-level-2': navItem.level === 2 }" @click="scrollToItem(navItem.id)">
                  <span class="nav-number">{{ navItem.itemNumber }}</span>
                  <span class="nav-description">{{ navItem.description }}</span>
                </div>
              </div>
            </div>

            <!-- 右侧表格区域 -->
            <div class="table-panel">
              <el-table ref="pageOneTable" :data="pageOneData" border style="width: 100%; height: 100%;" :header-cell-style="{ background: '#f5f7fa', textAlign: 'left' }"
                        :cell-style="pageOneTableCellStyle" :span-method="pageOneTableSpanMethod" row-key="id" :row-class-name="getRowClassName" :height="pageOneLayoutHeight">
                <el-table-column prop="itemNumber" label="检测项目编号及名称" align="left" min-width="400">
                  <template slot-scope="scope">
                    <!-- 默认行布局（无配图） -->
                    <div v-if="!isItemWithImage(scope.row)" class="item-content" :class="'level-' + scope.row.level">
                      <span v-if="scope.row.itemNumber" class="item-number" :class="'level-' + scope.row.level + '-number'">
                        {{ scope.row.itemNumber }}
                      </span>
                      <span class="item-description" :class="'level-' + scope.row.level + '-desc'" v-html="scope.row.description"></span>
                    </div>
                    <!-- 带配图布局：A1.2.5.1.2 断丝数对照表 / A1.3.14.1 噪声限值表 -->
                    <div v-else class="item-content item-content-a13141" :class="'level-' + scope.row.level">
                      <span class="item-number" :class="'level-' + scope.row.level + '-number'">
                        {{ scope.row.itemNumber }}
                      </span>
                      <div class="item-a13141-right">
                        <div class="item-description" :class="'level-' + scope.row.level + '-desc'" v-html="scope.row.description"></div>
                        <div class="item-image-wrapper">
                          <img :src="getItemImageSrc(scope.row)" :alt="scope.row.itemNumber + '示意图'" class="item-image" />
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="result" label="检验结果" :width="resultColumnWidth || 240" align="center">
                  <template slot-scope="scope">
                    <!-- Level 3 项目：左(颜色按钮) + 右(已勾选详情文本) -->
                    <div v-if="scope.row.level === 3" class="result-cell">
                      <div class="result-cell-left">
                        <div class="result-color-block" :class="getResultColorClass(scope.row)" @click="openResultDialog(scope.row)" :title="getResultTitle(scope.row)">
                          <div class="result-content">
                            <div class="result-text">{{ getResultText(scope.row.result) }}</div>
                            <!-- 如果有附表，显示第二行 -->
                            <div v-if="scope.row.attachmentTable" class="attachment-info">
                              *详情见:{{ getAttachmentInfoText(scope.row.attachmentTable) }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="result-cell-right">
                        <div v-for="(txt, idx) in getRowSelectedDetailTexts(scope.row)" :key="`${scope.row.id || scope.row.itemNumber}-detail-${idx}`" class="result-detail-line">
                          {{ txt }}
                        </div>
                      </div>
                    </div>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <!-- 新增综合检验结果列 -->
                <!-- <el-table-column prop="autoResult" label="综合检验结果" width="120" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.hasChildren && (scope.row.level === 1 || scope.row.level === 2) && scope.row.autoResult" class="result-color-block"
                         :class="getAutoResultColorClass(scope.row.autoResult)" style="cursor: default;">
                      <span class="result-text">{{ getResultText(scope.row.autoResult) }}</span>
                    </div>
                    <span v-else>-</span>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
          </div>
        </div>
      </el-card>

      <!-- 第二页卡片 - 已隐藏，现在附表通过弹窗显示 -->
      <el-card v-if="false" class="page-card" shadow="hover">
        <div slot="header" class="card-header">
          <span></span>
        </div>
        <div class="card-content page-two-content">
          <!-- 附表 A1.2.7.1(1)：层门间隙检测记录表 -->
          <div class="table-section">
            <div class="table-title">附表 A1.2.7.1(1)：层门间隙检测不符合记录表(现场检测不符合时填写。每格左上方填写层站数，右下方填写检测结果，检测结果为实测值的，单位为 mm)</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable1DisplayData" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge" size="mini">
                <!-- 第一列：项目名称 -->
                <el-table-column label="检测层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <!-- 13列数据列 -->
                <el-table-column v-for="(col, index) in pageTwoTable1.columns" :key="col.id || `table1-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <!-- 第一行：抽查层站输入框（会被合并） -->
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable1.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <!-- 第二行：层站/检测结果标题 -->
                    <div v-else-if="scope.$index === 1" class="header-cell">层站/检测结果</div>
                    <!-- 第3-6行：分割单元格 -->
                    <div v-else-if="scope.$index > 1" class="split-cell">
                      <div class="cell-top-left">
                        <el-input v-model="col.data[scope.row.key].floor" placeholder="层站" size="small"></el-input>
                      </div>
                      <div class="cell-bottom-right">
                        <el-input v-model="col.data[scope.row.key].result" placeholder="结果" size="small"></el-input>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 附表 A1.2.7.1(2)：层门间隙检测记录表 -->
          <div class="table-section">
            <div class="table-title">附表 A1.2.7.1(1)：层门间隙检测不符合记录表(现场检测不符合时填写。每格左上方填写层站数，右下方填写检测结果，检测结果为实测值的，单位为 mm)</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable2Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge2" size="mini">
                <!-- 第一列：项目名称 -->
                <el-table-column label="检测层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <!-- 13列数据列 -->
                <el-table-column v-for="(col, index) in pageTwoTable2.columns" :key="col.id || `table2-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <!-- 第一行：抽查层站输入框（会被合并） -->
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable2.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <!-- 第二行：层站/检测结果标题 -->
                    <div v-else-if="scope.$index === 1" class="header-cell">层站/检测结果</div>
                    <!-- 第3-6行：分割单元格 -->
                    <div v-else-if="scope.$index > 1" class="split-cell">
                      <div class="cell-top-left">
                        <el-input v-model="col.data[scope.row.key].floor" placeholder="层站" size="small"></el-input>
                      </div>
                      <div class="cell-bottom-right">
                        <el-input v-model="col.data[scope.row.key].result" placeholder="结果" size="small"></el-input>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- A1.2.7.2 玻璃门防拖曳措施检查记录表 -->
          <div class="table-section">
            <div class="table-title">A1.2.7.2 玻璃门防拖曳措施检查记录表（填写对应的层站）</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable3Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge3" size="mini">
                <!-- 第一列：项目名称 -->
                <el-table-column label="抽查层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <!-- 13列数据列 -->
                <el-table-column v-for="(col, index) in pageTwoTable3.columns" :key="col.id || `table3-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <!-- 第一行：抽查层站输入框（会被合并） -->
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable3.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <!-- 第二行：检测结果标题 -->
                    <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                    <!-- 第3-4行：普通输入框 -->
                    <div v-else-if="scope.$index > 1">
                      <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- A1.2.7.4(1)门的运行与导向检查记录表 -->
          <div class="table-section">
            <div class="table-title">A1.2.7.4(1)门的运行与导向检查记录表（填写对应的层站）</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable4Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge4" size="mini">
                <!-- 第一列：项目名称 -->
                <el-table-column label="抽查层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <!-- 13列数据列 -->
                <el-table-column v-for="(col, index) in pageTwoTable4.columns" :key="col.id || `table4-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <!-- 第一行：抽查层站输入框（会被合并） -->
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable4.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <!-- 第二行：检测结果标题 -->
                    <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                    <!-- 第3-5行：普通输入框 -->
                    <div v-else-if="scope.$index > 1">
                      <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- A1.2.7.4(2)门的运行与导向检查记录表 -->
          <div class="table-section">
            <div class="table-title">A1.2.7.4(2)门的运行与导向检查记录表（填写对应的层站）</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable5Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge5" size="mini">
                <el-table-column label="抽查层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <el-table-column v-for="(col, index) in pageTwoTable5.columns" :key="col.id || `table5-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable5.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                    <div v-else-if="scope.$index > 1">
                      <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- A1.2.7.4(3)门的运行与导向检查记录表 -->
          <div class="table-section">
            <div class="table-title">A1.2.7.4(3)门的运行与导向检查记录表（填写对应的层站）</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable6Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge6" size="mini">
                <el-table-column label="抽查层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <el-table-column v-for="(col, index) in pageTwoTable6.columns" :key="col.id || `table6-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable6.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                    <div v-else-if="scope.$index > 1">
                      <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- A1.2.7.5(1)自动关闭层门装置检查记录表 -->
          <div class="table-section">
            <div class="table-title">A1.2.7.5(1)自动关闭层门装置检查记录表(填写对应的层站)</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable7Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge7" size="mini">
                <el-table-column label="抽查层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <el-table-column v-for="(col, index) in pageTwoTable7.columns" :key="col.id || `table7-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable7.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                    <div v-else-if="scope.$index > 1">
                      <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- A1.2.7.5(2)自动关闭层门装置检查记录表 -->
          <div class="table-section">
            <div class="table-title">A1.2.7.5(2)自动关闭层门装置检查记录表（填写对应的层站）</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable8Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge8" size="mini">
                <el-table-column label="抽查层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <el-table-column v-for="(col, index) in pageTwoTable8.columns" :key="col.id || `table8-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable8.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                    <div v-else-if="scope.$index > 1">
                      <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 附表 A1.2.7.6(1)紧急开锁检查记录表 -->
          <div class="table-section">
            <div class="table-title">附表 A1.2.7.6(1)紧急开锁检查记录表(填写对应的层站)</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable9Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge9" size="mini">
                <el-table-column label="抽查层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <el-table-column v-for="(col, index) in pageTwoTable9.columns" :key="col.id || `table9-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable9.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                    <div v-else-if="scope.$index > 1">
                      <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 附表 A1.2.7.7(1) 门的锁紧与闭合检查记录表 -->
          <div class="table-section">
            <div class="table-title">附表 A1.2.7.7(1) 门的锁紧与闭合检查记录表(填写对应的层站)</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable10Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge10" size="mini">
                <el-table-column label="抽查层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <el-table-column v-for="(col, index) in pageTwoTable10.columns" :key="col.id || `table10-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable10.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                    <div v-else-if="scope.$index > 1">
                      <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 附表 A1.2.7.7(2) 门锁啮合长度检测记录表 -->
          <div class="table-section">
            <div class="table-title">附表 A1.2.7.7(2) 门锁啮合长度检测记录表(每格左上方填写层站，右下方填写检测结果，单位为 mm)</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable11Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" size="mini">
                <!-- 第一列：项目名称 -->
                <el-table-column label="项目" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <!-- 13列数据列 -->
                <el-table-column v-for="(col, index) in pageTwoTable11.columns" :key="col.id || `table11-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <!-- 第一行：层站/检测结果标题 -->
                    <div v-if="scope.$index === 0" class="header-cell">层站/检测结果</div>
                    <!-- 第2-5行：分割单元格 -->
                    <div v-else class="split-cell">
                      <div class="cell-top-left">
                        <el-input v-model="col.data[scope.row.key].floor" placeholder="层站" size="small"></el-input>
                      </div>
                      <div class="cell-bottom-right">
                        <el-input v-model="col.data[scope.row.key].result" placeholder="结果" size="small"></el-input>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 附表 A1.2.7.7(3)层门锁紧状态的电气安全装置检查记录表 -->
          <div class="table-section">
            <div class="table-title">附表 A1.2.7.7(3)层门锁紧状态的电气安全装置检查记录表(填写对应的层站)</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable12Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge12" size="mini">
                <el-table-column label="抽查层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <el-table-column v-for="(col, index) in pageTwoTable12.columns" :key="col.id || `table12-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable12.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                    <div v-else-if="scope.$index > 1">
                      <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 附表 A1.2.7.7(4) 验证层门闭合的电气安全装置检查记录表 -->
          <div class="table-section">
            <div class="table-title">附表 A1.2.7.7(4) 验证层门闭合的电气安全装置检查记录表(填写对应的层站)</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable13Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge13" size="mini">
                <el-table-column label="抽查层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <el-table-column v-for="(col, index) in pageTwoTable13.columns" :key="col.id || `table13-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable13.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                    <div v-else-if="scope.$index > 1">
                      <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 附表 A1.2.7.8 轿门门刀与层门地坎，层门锁滚轮与轿厢地坎的间隙检测记录表 -->
          <div class="table-section">
            <div class="table-title">附表 A1.2.7.8 轿门门刀与层门地坎，层门锁滚轮与轿厢地坎的间隙检测记录表(每格左上方填写层站，右下方填写检测结果，单位为 mm)</div>
            <div class="table-scroll-wrapper">
              <el-table :data="pageTwoTable14Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge14" size="mini">
                <!-- 第一列：项目名称 -->
                <el-table-column label="抽查层站" align="center" width="120" fixed>
                  <template slot-scope="scope">
                    <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                    <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                    <div v-else class="row-label">{{ scope.row.label }}</div>
                  </template>
                </el-table-column>
                <!-- 13列数据列 -->
                <el-table-column v-for="(col, index) in pageTwoTable14.columns" :key="col.id || `table14-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                  <template slot-scope="scope">
                    <!-- 第一行：抽查层站输入框（会被合并） -->
                    <div v-if="scope.$index === 0 && index === 0">
                      <el-input v-model="pageTwoTable14.samplingFloors" placeholder="请输入抽查层站" size="small"></el-input>
                    </div>
                    <!-- 第二行：层站/检测结果标题 -->
                    <div v-else-if="scope.$index === 1" class="header-cell">层站/检测结果</div>
                    <!-- 第3-4行：分割单元格 -->
                    <div v-else-if="scope.$index > 1" class="split-cell">
                      <div class="cell-top-left">
                        <el-input v-model="col.data[scope.row.key].floor" placeholder="层站" size="small"></el-input>
                      </div>
                      <div class="cell-bottom-right">
                        <el-input v-model="col.data[scope.row.key].result" placeholder="结果" size="small"></el-input>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 附表 A1.3.2 电梯平衡系数测试记录表 -->
          <div class="table-section">
            <div class="table-title">附表 A1.3.2 电梯平衡系数测试记录表(检查资料及现场有质疑并进行现场检测时填写)使用电流—负荷法进行检测</div>
            <el-table :data="pageTwoTable15Data" border style="width: 100%" :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" size="mini">
              <!-- 第一列：项目名称 -->
              <el-table-column label="载荷(%)\项目" align="center" width="150">
                <template slot-scope="scope">
                  <div class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <!-- 5列负荷百分比 -->
              <el-table-column label="30%" align="center" width="150">
                <template slot-scope="scope">
                  <el-input v-model="pageTwoTable15[scope.row.key].load30" placeholder="请输入" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="40%" align="center" width="150">
                <template slot-scope="scope">
                  <el-input v-model="pageTwoTable15[scope.row.key].load40" placeholder="请输入" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="45%" align="center" width="150">
                <template slot-scope="scope">
                  <el-input v-model="pageTwoTable15[scope.row.key].load45" placeholder="请输入" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="50%" align="center" width="150">
                <template slot-scope="scope">
                  <el-input v-model="pageTwoTable15[scope.row.key].load50" placeholder="请输入" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="60%" align="center" width="150">
                <template slot-scope="scope">
                  <el-input v-model="pageTwoTable15[scope.row.key].load60" placeholder="请输入" size="small"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 附表 A1.3.4(1) 限速器校验记录表 -->
          <div class="table-section">
            <div class="table-title">附表 A1.3.4(1) 限速器校验记录表(进行现场校验时填写)</div>

            <!-- 基本信息表格 -->
            <el-table :data="pageTwoTable16InfoData" border style="width: 100%" :span-method="tableCellMerge16Info" size="mini" :show-header="false">
              <el-table-column align="center" width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.label }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.key === 'manufacturer'" v-model="pageTwoTable16.manufacturer" placeholder="请输入" size="small"></el-input>
                  <el-input v-else-if="scope.row.key === 'productNumber'" v-model="pageTwoTable16.productNumber" placeholder="请输入" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" width="120">
              </el-table-column>
              <el-table-column align="center" width="120">
              </el-table-column>
              <el-table-column align="center" width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.key === 'productNumber'">规格型号</span>
                </template>
              </el-table-column>
              <el-table-column align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.key === 'productNumber'" v-model="pageTwoTable16.model" placeholder="请输入" size="small"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" width="120">
              </el-table-column>
              <el-table-column align="center" width="120">
              </el-table-column>
              <el-table-column align="center" width="120">
              </el-table-column>
            </el-table>

            <!-- 数据表格 -->
            <el-table :data="pageTwoTable16Data" border style="width: 100%" :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" size="mini">
              <!-- 第一列：标签列 -->
              <el-table-column label="实测项目(m/s)" align="center" width="150">
                <template slot-scope="scope">
                  <div class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <!-- 上行组 -->
              <el-table-column label="上行" align="center">
                <el-table-column label="1" align="center" width="120">
                  <template slot-scope="scope">
                    <el-input v-model="pageTwoTable16[scope.row.key].up1" placeholder="请输入" size="small" @input="updatePageTwoTable16Avg(scope.row.key, 'up')"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="2" align="center" width="120">
                  <template slot-scope="scope">
                    <el-input v-model="pageTwoTable16[scope.row.key].up2" placeholder="请输入" size="small" @input="updatePageTwoTable16Avg(scope.row.key, 'up')"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="3" align="center" width="120">
                  <template slot-scope="scope">
                    <el-input v-model="pageTwoTable16[scope.row.key].up3" placeholder="请输入" size="small" @input="updatePageTwoTable16Avg(scope.row.key, 'up')"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="平均" align="center" width="120">
                  <template slot-scope="scope">
                    <el-input v-model="pageTwoTable16[scope.row.key].upAvg" placeholder="自动计算" size="small" readonly></el-input>
                  </template>
                </el-table-column>
              </el-table-column>
              <!-- 下行组 -->
              <el-table-column label="下行" align="center">
                <el-table-column label="1" align="center" width="120">
                  <template slot-scope="scope">
                    <el-input v-model="pageTwoTable16[scope.row.key].down1" placeholder="请输入" size="small" @input="updatePageTwoTable16Avg(scope.row.key, 'down')"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="2" align="center" width="120">
                  <template slot-scope="scope">
                    <el-input v-model="pageTwoTable16[scope.row.key].down2" placeholder="请输入" size="small" @input="updatePageTwoTable16Avg(scope.row.key, 'down')"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="3" align="center" width="120">
                  <template slot-scope="scope">
                    <el-input v-model="pageTwoTable16[scope.row.key].down3" placeholder="请输入" size="small" @input="updatePageTwoTable16Avg(scope.row.key, 'down')"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="平均" align="center" width="120">
                  <template slot-scope="scope">
                    <el-input v-model="pageTwoTable16[scope.row.key].downAvg" placeholder="自动计算" size="small" readonly></el-input>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>

          <!-- 附表 A1.3.14 噪声测试记录表 -->
          <div class="table-section">
            <div class="table-title">附表 A1.3.14 噪声测试记录表(噪声单位为 dB(A))</div>
            <el-table :data="pageTwoTable17Data" border style="width: 100%" :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="pageTwoTable17SpanMethod" size="mini">
              <!-- 第1列：噪声测试项目 -->
              <el-table-column label="噪声测试项目" align="center" width="80">
                <template slot-scope="scope">
                  <span>{{ scope.row.label }}</span>
                </template>
              </el-table-column>

              <!-- 第2列：背景 -->
              <el-table-column label="背景" align="center" width="160">
                <template slot-scope="scope">
                  <span v-if="scope.row.type === 'header'">{{ scope.row.col2 }}</span>
                  <el-input v-else-if="scope.row.type === 'input'" v-model="pageTwoTable17[scope.row.key].background" placeholder="请输入" size="small"></el-input>
                </template>
              </el-table-column>

              <!-- 第3列：测试点或测试工况1 -->
              <el-table-column label="测试点或测试工况1" align="center" width="180">
                <template slot-scope="scope">
                  <span v-if="scope.row.type === 'header'">{{ scope.row.col3 }}</span>
                  <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'machineRoom'" v-model="pageTwoTable17[scope.row.key].point1" placeholder="请输入" size="small"
                            @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                  <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'twoColumn' && scope.row.key === 'carInside'" v-model="pageTwoTable17.carInside.up" placeholder="请输入"
                            size="small" @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                  <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'twoColumn' && scope.row.key === 'doorNoise'" v-model="pageTwoTable17.doorNoise.open" placeholder="请输入"
                            size="small" @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                  <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'twoColumn' && scope.row.key === 'noMachineRoom'" v-model="pageTwoTable17.noMachineRoom.up" placeholder="请输入"
                            size="small" @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                </template>
              </el-table-column>

              <!-- 第4列：测试点或测试工况2 -->
              <el-table-column label="测试点或测试工况2" align="center" width="180">
                <template slot-scope="scope">
                  <span v-if="scope.row.type === 'header'">{{ scope.row.col4 }}</span>
                  <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'machineRoom'" v-model="pageTwoTable17[scope.row.key].point2" placeholder="请输入" size="small"
                            @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                </template>
              </el-table-column>

              <!-- 第5列：测试点或测试工况3 -->
              <el-table-column label="测试点或测试工况3" align="center" width="180">
                <template slot-scope="scope">
                  <span v-if="scope.row.type === 'header'">{{ scope.row.col5 }}</span>
                  <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'machineRoom'" v-model="pageTwoTable17[scope.row.key].point3" placeholder="请输入" size="small"
                            @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                  <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'twoColumn' && scope.row.key === 'carInside'" v-model="pageTwoTable17.carInside.down" placeholder="请输入"
                            size="small" @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                  <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'twoColumn' && scope.row.key === 'doorNoise'" v-model="pageTwoTable17.doorNoise.close" placeholder="请输入"
                            size="small" @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                  <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'twoColumn' && scope.row.key === 'noMachineRoom'" v-model="pageTwoTable17.noMachineRoom.down"
                            placeholder="请输入" size="small" @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                </template>
              </el-table-column>

              <!-- 第6列：测试结果 -->
              <el-table-column label="测试结果" align="center" width="150">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.type === 'header'" v-model="pageTwoTable17[scope.row.key].result" placeholder="自动计算" size="small" readonly></el-input>
                  <span v-else></span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 检验结果编辑弹窗 -->
    <el-dialog title="编辑检验结果" :visible.sync="resultDialogVisible" width="600px" :close-on-click-modal="false" :before-close="onResultDialogClose">
      <div v-if="currentEditRow" class="result-dialog-content">
        <div class="result-item-info">
          <div class="info-label">检测项目：</div>
          <div class="info-value">{{ currentEditRow.itemNumber }} {{ currentEditRow.description }}</div>
        </div>

        <div class="result-selection">
          <div class="selection-label">检验结果：</div>
          <el-radio-group v-model="tempResult" size="medium" @change="handleResultChange">
            <el-radio label="qualified" border>符合</el-radio>
            <el-radio label="unqualified" border>不符合</el-radio>
            <el-radio label="notApplicable" border>无此项</el-radio>
          </el-radio-group>
        </div>

        <!-- 详情列表 -->
        <div v-if="detailList.length > 0" class="detail-list-section" style="margin-top: 20px; max-height: 300px; overflow-y: auto;">
          <div class="detail-list-label" style="margin-bottom: 10px; font-weight: bold;">详情列表：</div>
          <div v-for="item in detailList" :key="item.contentDetailPid" class="detail-item" @click="toggleDetailSelection(item)"
               style="display: flex; align-items: center; margin-bottom: 10px; padding: 8px; border: 1px solid #e4e7ed; border-radius: 4px;">
            <el-checkbox v-model="selectedDetailPids" :label="item.contentDetailPid" @click.native.stop></el-checkbox>
            <div style="flex: 1;">
              <template v-if="item.detailContent && hasDetailPlaceholders(item.detailContent)">
                <span v-for="(seg, segIndex) in getDetailContentSegments(item)" :key="`${item.contentDetailPid}-${segIndex}`">
                  <span v-if="seg.type === 'text'">{{ seg.value }}</span>
                  <el-input v-else v-model="detailInputValues[item.contentDetailPid][seg.inputIndex]" size="small" style="width: 120px; display: inline-block; margin: 0 5px;" placeholder="请输入"
                            @click.native.stop></el-input>
                </span>
              </template>
              <span v-else>{{ item.detailContent }}</span>
            </div>
          </div>
        </div>
        <div v-if="detailListLoading" style="text-align: center; padding: 20px;">
          <i class="el-icon-loading"></i> 加载中...
        </div>

        <div v-if="currentEditRow.attachmentTable" class="attachment-section" style="margin-top: 20px;">
          <div class="attachment-label">{{ getAttachmentTitle(currentEditRow.attachmentTable) }}</div>
          <el-button type="primary" size="small" @click="openAttachmentDialog(currentEditRow.attachmentTable)">
            <i class="el-icon-document"></i> 打开附表
          </el-button>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onResultDialogClose()">取 消</el-button>
        <el-button type="primary" @click="saveResult(tempResult)">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 附表查看弹窗 -->
    <el-dialog :title="getAttachmentTitle()" :visible.sync="attachmentDialogVisible" width="90%" top="5vh" :close-on-click-modal="false" :destroy-on-close="true"
               :before-close="handleAttachmentDialogClose">
      <div class="attachment-dialog-content" :key="currentAttachmentTable">

        <!-- 附表 A1.2.7.1(1) -->
        <div v-if="currentAttachmentTable === 'table1'" class="table-section">
          <div class="table-title">附表 A1.2.7.1(1)：层门间隙检测不符合记录表(现场检测不符合时填写。每格左上方填写层站数，右下方填写检测结果，检测结果为实测值的，单位为 mm)</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable1DisplayData" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge" size="mini">
              <el-table-column label="检测层站" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                  <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                  <div v-else class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable1.columns" :key="col.id || `table1-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                  <div v-else-if="scope.$index > 1">
                    <el-input v-model="col.data[scope.row.key].result" placeholder="结果" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 附表 A1.2.7.1(2) -->
        <div v-else-if="currentAttachmentTable === 'table2'" class="table-section">
          <div class="table-title">附表 A1.2.7.1(1)：层门间隙检测不符合记录表(现场检测不符合时填写。每格左上方填写层站数，右下方填写检测结果，检测结果为实测值的，单位为 mm)</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable2Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge2" size="mini">
              <el-table-column label="检测层站" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                  <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                  <div v-else class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable2.columns" :key="col.id || `table2-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                  <div v-else-if="scope.$index > 1">
                    <el-input v-model="col.data[scope.row.key].result" placeholder="结果" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 附表 A1.2.7.2 玻璃门防拖曳措施检查记录表 -->
        <div v-else-if="currentAttachmentTable === 'table3'" class="table-section">
          <div class="table-title">附表 A1.2.7.2 玻璃门防拖曳措施检查记录表（填写对应的层站）</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable3Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge3" size="mini">
              <el-table-column label="抽查层站" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                  <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                  <div v-else class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable3.columns" :key="col.id || `table3-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                  <div v-else-if="scope.$index > 1">
                    <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 附表 A1.2.7.4(1-3) 门的运行与导向检查记录表 -->
        <div v-else-if="currentAttachmentTable === 'table4'" class="table-section">
          <div class="table-title">附表 A1.2.7.4(1) 门的运行与导向检查记录表（填写对应的层站）</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable4Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge4" size="mini">
              <el-table-column label="抽查层站" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                  <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                  <div v-else class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable4.columns" :key="col.id || `table4-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                  <div v-else-if="scope.$index > 1">
                    <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-else-if="currentAttachmentTable === 'table5'" class="table-section">
          <div class="table-title">附表 A1.2.7.4(2) 门的运行与导向检查记录表（填写对应的层站）</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable5Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge5" size="mini">
              <el-table-column label="抽查层站" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                  <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                  <div v-else class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable5.columns" :key="col.id || `table5-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                  <div v-else-if="scope.$index > 1">
                    <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-else-if="currentAttachmentTable === 'table6'" class="table-section">
          <div class="table-title">附表 A1.2.7.4(3) 门的运行与导向检查记录表（填写对应的层站）</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable6Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge6" size="mini">
              <el-table-column label="抽查层站" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                  <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                  <div v-else class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable6.columns" :key="col.id || `table6-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                  <div v-else-if="scope.$index > 1">
                    <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 附表 A1.2.7.5(1-2) 自动关闭层门装置检查记录表 -->
        <div v-else-if="currentAttachmentTable === 'table7'" class="table-section">
          <div class="table-title">附表 A1.2.7.5(1) 自动关闭层门装置检查记录表（填写对应的层站）</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable7Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge7" size="mini">
              <el-table-column label="抽查层站" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                  <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                  <div v-else class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable7.columns" :key="col.id || `table7-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                  <div v-else-if="scope.$index > 1">
                    <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-else-if="currentAttachmentTable === 'table8'" class="table-section">
          <div class="table-title">附表 A1.2.7.5(2) 自动关闭层门装置检查记录表（填写对应的层站）</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable8Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge8" size="mini">
              <el-table-column label="抽查层站" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                  <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                  <div v-else class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable8.columns" :key="col.id || `table8-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                  <div v-else-if="scope.$index > 1">
                    <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 附表 A1.2.7.6(1) 紧急开锁检查记录表 -->
        <div v-else-if="currentAttachmentTable === 'table9'" class="table-section">
          <div class="table-title">附表 A1.2.7.6(1) 紧急开锁检查记录表（填写对应的层站）</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable9Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge9" size="mini">
              <el-table-column label="抽查层站" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                  <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                  <div v-else class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable9.columns" :key="col.id || `table9-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                  <div v-else-if="scope.$index > 1">
                    <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 附表 A1.2.7.7(1-4) 门的锁紧与闭合相关检查记录表 -->
        <div v-else-if="currentAttachmentTable === 'table10'" class="table-section">
          <div class="table-title">附表 A1.2.7.7(1) 门的锁紧与闭合检查记录表（填写对应的层站）</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable10Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge10" size="mini">
              <el-table-column label="抽查层站" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                  <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                  <div v-else class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable10.columns" :key="col.id || `table10-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                  <div v-else-if="scope.$index > 1">
                    <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-else-if="currentAttachmentTable === 'table11'" class="table-section">
          <div class="table-title">附表 A1.2.7.7(2) 门锁啮合长度检测记录表（填写检测结果，单位为 mm）</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable11Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge11" size="mini">
              <el-table-column label="项目" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable11.columns" :key="col.id || `table11-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else>
                    <el-input v-model="col.data[scope.row.key].result" placeholder="结果" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-else-if="currentAttachmentTable === 'table12'" class="table-section">
          <div class="table-title">附表 A1.2.7.7(3) 层门锁紧状态的电气安全装置检查记录表（填写对应的层站）</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable12Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge12" size="mini">
              <el-table-column label="抽查层站" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                  <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                  <div v-else class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable12.columns" :key="col.id || `table12-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                  <div v-else-if="scope.$index > 1">
                    <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-else-if="currentAttachmentTable === 'table13'" class="table-section">
          <div class="table-title">附表 A1.2.7.7(4) 验证层门闭合的电气安全装置检查记录表（填写对应的层站）</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable13Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge13" size="mini">
              <el-table-column label="抽查层站" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                  <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                  <div v-else class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable13.columns" :key="col.id || `table13-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                  <div v-else-if="scope.$index > 1">
                    <el-input v-model="col.data[scope.row.key]" placeholder="请输入" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 附表 A1.2.7.8 轿门门刀与层门地坎，层门锁滚轮与轿厢地坎的间隙检测记录表 -->
        <div v-else-if="currentAttachmentTable === 'table14'" class="table-section">
          <div class="table-title">附表 A1.2.7.8 轿门门刀与层门地坎，层门锁滚轮与轿厢地坎的间隙检测记录表（填写检测结果，单位为 mm）</div>
          <div class="table-scroll-wrapper">
            <el-table :data="pageTwoTable14Data" border :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="tableCellMerge14" size="mini">
              <el-table-column label="抽查层站" align="center" width="120" fixed>
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="row-label">抽查层站</div>
                  <div v-else-if="scope.$index === 1" class="row-label">项目</div>
                  <div v-else class="row-label">{{ scope.row.label }}</div>
                </template>
              </el-table-column>
              <el-table-column v-for="(col, index) in pageTwoTable14.columns" :key="col.id || `table14-col-${index}`" :label="index === 12 ? '检测结果' : ''" align="center" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.$index === 0" class="header-cell">{{ col.station || '' }}</div>
                  <div v-else-if="scope.$index === 1" class="header-cell">检测结果</div>
                  <div v-else-if="scope.$index > 1">
                    <el-input v-model="col.data[scope.row.key].result" placeholder="结果" size="small"></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 附表 A1.3.2 电梯平衡系数测试记录表 -->
        <div v-else-if="currentAttachmentTable === 'table15'" class="table-section">
          <div class="table-title">附表 A1.3.2 电梯平衡系数测试记录表（检查资料及现场有质疑并进行现场检测时填写）使用电流—负荷法进行检测</div>
          <el-table :data="pageTwoTable15Data" border style="width: 100%" :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" size="mini">
            <el-table-column label="载荷(%)\项目" align="center" width="150">
              <template slot-scope="scope">
                <div class="row-label">{{ scope.row.label }}</div>
              </template>
            </el-table-column>
            <el-table-column label="30%" align="center" width="150">
              <template slot-scope="scope">
                <el-input v-model="pageTwoTable15[scope.row.key].load30" placeholder="请输入" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="40%" align="center" width="150">
              <template slot-scope="scope">
                <el-input v-model="pageTwoTable15[scope.row.key].load40" placeholder="请输入" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="45%" align="center" width="150">
              <template slot-scope="scope">
                <el-input v-model="pageTwoTable15[scope.row.key].load45" placeholder="请输入" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="50%" align="center" width="150">
              <template slot-scope="scope">
                <el-input v-model="pageTwoTable15[scope.row.key].load50" placeholder="请输入" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="60%" align="center" width="150">
              <template slot-scope="scope">
                <el-input v-model="pageTwoTable15[scope.row.key].load60" placeholder="请输入" size="small"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 附表 A1.3.4(1) 限速器校验记录表 -->
        <div v-else-if="currentAttachmentTable === 'table16'" class="table-section">
          <div class="table-title">附表 A1.3.4(1) 限速器校验记录表（进行现场校验时填写）</div>
          <!-- 基本信息表格 -->
          <el-table :data="pageTwoTable16InfoData" border style="width: 100%" :span-method="tableCellMerge16Info" size="mini" :show-header="false">
            <el-table-column align="center" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.label }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="120">
              <template slot-scope="scope">
                <el-input v-if="scope.row.key === 'manufacturer'" v-model="pageTwoTable16.manufacturer" placeholder="请输入" size="small"></el-input>
                <el-input v-else-if="scope.row.key === 'productNumber'" v-model="pageTwoTable16.productNumber" placeholder="请输入" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" width="120"></el-table-column>
            <el-table-column align="center" width="120"></el-table-column>
            <el-table-column align="center" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.key === 'productNumber'">规格型号</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="120">
              <template slot-scope="scope">
                <el-input v-if="scope.row.key === 'productNumber'" v-model="pageTwoTable16.model" placeholder="请输入" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" width="120"></el-table-column>
            <el-table-column align="center" width="120"></el-table-column>
            <el-table-column align="center" width="120"></el-table-column>
          </el-table>
          <!-- 数据表格 -->
          <el-table :data="pageTwoTable16Data" border style="width: 100%" :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" size="mini">
            <el-table-column label="实测项目(m/s)" align="center" width="150">
              <template slot-scope="scope">
                <div class="row-label">{{ scope.row.label }}</div>
              </template>
            </el-table-column>
            <el-table-column label="上行" align="center">
              <el-table-column label="1" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="pageTwoTable16[scope.row.key].up1" placeholder="请输入" size="small" @input="updatePageTwoTable16Avg(scope.row.key, 'up')"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="2" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="pageTwoTable16[scope.row.key].up2" placeholder="请输入" size="small" @input="updatePageTwoTable16Avg(scope.row.key, 'up')"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="3" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="pageTwoTable16[scope.row.key].up3" placeholder="请输入" size="small" @input="updatePageTwoTable16Avg(scope.row.key, 'up')"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="平均" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="pageTwoTable16[scope.row.key].upAvg" placeholder="自动计算" size="small" readonly></el-input>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="下行" align="center">
              <el-table-column label="1" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="pageTwoTable16[scope.row.key].down1" placeholder="请输入" size="small" @input="updatePageTwoTable16Avg(scope.row.key, 'down')"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="2" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="pageTwoTable16[scope.row.key].down2" placeholder="请输入" size="small" @input="updatePageTwoTable16Avg(scope.row.key, 'down')"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="3" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="pageTwoTable16[scope.row.key].down3" placeholder="请输入" size="small" @input="updatePageTwoTable16Avg(scope.row.key, 'down')"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="平均" align="center" width="120">
                <template slot-scope="scope">
                  <el-input v-model="pageTwoTable16[scope.row.key].downAvg" placeholder="自动计算" size="small" readonly></el-input>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>

        <!-- 附表 A1.3.14 噪声测试记录表 -->
        <div v-else-if="currentAttachmentTable === 'table17'" class="table-section">
          <div class="table-title">附表 A1.3.14 噪声测试记录表（噪声单位为 dB(A)）</div>
          <el-table :data="pageTwoTable17Data" border style="width: 100%" :header-cell-style="{ background: '#f5f7fa', textAlign: 'center' }" :span-method="pageTwoTable17SpanMethod" size="mini">
            <el-table-column label="噪声测试项目" align="center" width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.label }}</span>
              </template>
            </el-table-column>
            <el-table-column label="背景" align="center" width="160">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 'header'">{{ scope.row.col2 }}</span>
                <el-input v-else-if="scope.row.type === 'input'" v-model="pageTwoTable17[scope.row.key].background" placeholder="请输入" size="small"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="测试点或测试工况1" align="center" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 'header'">{{ scope.row.col3 }}</span>
                <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'machineRoom'" v-model="pageTwoTable17[scope.row.key].point1" placeholder="请输入" size="small"
                          @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'twoColumn' && scope.row.key === 'carInside'" v-model="pageTwoTable17.carInside.up" placeholder="请输入"
                          size="small" @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'twoColumn' && scope.row.key === 'doorNoise'" v-model="pageTwoTable17.doorNoise.open" placeholder="请输入"
                          size="small" @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'twoColumn' && scope.row.key === 'noMachineRoom'" v-model="pageTwoTable17.noMachineRoom.up" placeholder="请输入"
                          size="small" @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="测试点或测试工况2" align="center" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 'header'">{{ scope.row.col4 }}</span>
                <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'machineRoom'" v-model="pageTwoTable17[scope.row.key].point2" placeholder="请输入" size="small"
                          @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="测试点或测试工况3" align="center" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 'header'">{{ scope.row.col5 }}</span>
                <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'machineRoom'" v-model="pageTwoTable17[scope.row.key].point3" placeholder="请输入" size="small"
                          @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'twoColumn' && scope.row.key === 'carInside'" v-model="pageTwoTable17.carInside.down" placeholder="请输入"
                          size="small" @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'twoColumn' && scope.row.key === 'doorNoise'" v-model="pageTwoTable17.doorNoise.close" placeholder="请输入"
                          size="small" @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
                <el-input v-else-if="scope.row.type === 'input' && scope.row.rowType === 'twoColumn' && scope.row.key === 'noMachineRoom'" v-model="pageTwoTable17.noMachineRoom.down" placeholder="请输入"
                          size="small" @input="updatePageTwoTable17Result(scope.row.key)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="测试结果" align="center" width="150">
              <template slot-scope="scope">
                <el-input v-if="scope.row.type === 'header'" v-model="pageTwoTable17[scope.row.key].result" placeholder="自动计算" size="small" readonly></el-input>
                <span v-else></span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 其他附表或找不到对应附表时显示 -->
        <div v-else class="no-attachment">
          <p>附表内容正在加载...</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleAttachmentDialogClose()">关 闭</el-button>
        <el-button type="primary" @click="handleAttachmentDialogSave">保 存</el-button>
      </div>
    </el-dialog>

    <!-- PDF预览弹窗 -->
    <el-dialog title="PDF预览" :visible.sync="pdfPreviewVisible" width="90%" :close-on-click-modal="false">
      <PdfImgViewer v-if="pdfPreviewVisible && pdfFileName" :fileName="pdfFileName" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="pdfPreviewVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 层站设置弹窗 -->
    <floor-setting-dialog :visible.sync="floorSettingDialogVisible" :initial-data="floorSettingData" @confirm="handleFloorSettingSave" />

    <!-- 参照弹窗 -->
    <reference-dialog :visible.sync="referenceDialogVisible" :default-use-unt-name="equipmentInfo.useUnitName" :default-eqp-name="equipmentInfo.eqpTempName"
                      @referenceConfirm="handleReferenceConfirm" />
  </div>
</template>

<script>
import { saveTestData, queryEmployeeDropdown, queryTestDataInfo, queryTestDataTest, queryEqptList, queryToolboxEqptInfos, queryDetailListByContentCode, saveElevatorSetting, updateElevatorSetting, getElevatorSetting, previewTestDataPdf } from '@/api/contract/contract';
import { pageOneTreeData4 as pageOneTreeDataDefault } from './pageOneTreeData4';
import PdfImgViewer from '@/components/pdfview/PdfImgViewer.vue';

// 重要：必须为每次进入页面/重置生成“全新”的默认树数据副本
// 否则组件内对 pageOneTreeData 的修改会污染 import 的模块单例，造成下次进入仍然是脏数据
function createDefaultPageOneTreeData () {
  return JSON.parse(JSON.stringify(pageOneTreeDataDefault || []));
}

// 检测项配图（断丝数表 / 噪声限值表），图片放到 src/assets/images/ 后即可显示
const ITEM_IMAGE_MAP = {
  'A1.2.5.1.2': 'A1.2.5.1.png',
  'A1.3.14.1': 'A1.3.14-firefighter.png'
};
import ReferenceDialog from './reference.vue';
import FloorSettingDialog from './FloorSettingDialog.vue';

export default {
  components: {
    ReferenceDialog,
    FloorSettingDialog,
    PdfImgViewer
  },
  name: 'FirefighterElevatorRecordPage',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    const today = new Date();
    const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    return {
      additionalDataList: {},
      loading: false,
      pageLoading: false, // 页面加载状态
      referenceFilling: false, // 参照数据回填中（阻塞页面操作）
      // PDF预览相关
      pdfPreviewVisible: false, // PDF预览弹窗显示状态
      pdfFileName: '', // PDF文件名
      recordInfo: {},
      // 封面信息
      coverInfo: {
        EQP_VART_NAME: '', // 原始记录名称 - «EQP_VART_NAME»
        EQP_SORT_NAME: '', // 设备类别 - «EQP_SORT_NAME»
        recordNum: '', // 记录编号 - «recordNum»
        useUnitName: '', // 使用单位 - «USE_UNT_NAME»
        EQP_STATION_COD: '', // 设备代码 - «EQP_STATION_COD»
        testDate: todayString, // 检测日期 - «testDate»
        qrcodeImage: '', // 二维码图片预览 - «IMG_recordNumQrcode»
        qrcodeBase64: '' // 二维码图片base64数据
      },
      // 设备信息
      equipmentInfo: {
        useUnitName: '', // 使用单位名称 - «USE_UNT_NAME»
        unitInternalNumber: '', // 单位内编号 - «EQP_INNER_COD»
        USE_UNT_COD: '', // 统一信用代码 - «USE_UNT_COD»
        equipmentType: '', // 设备品种 - «EQP_VART_NAME»
        installLocation: '', // 设备安装地点 - «EQP_AREA_NAME»
        productModel: '', // 产品型号 - «EQP_MOD»
        registrationNumber: '', // 使用登记证号 - «EQP_USECERT_COD»
        productNumber: '', // 产品编号 - «FACTORY_COD»
        powerSupply: '', // 供电电压(V)
        humidity: '', // 湿度
        temperature: '', // 温度
        manufacturerName: '', // 制造单位名称 - «MAKE_UNT_NAME»
        manufactureDate: '', // 制造日期 - «MAKE_DATE»
        renovationUnitName: '', // 改造单位名称 - «renovation_unt_name»
        renovationDate: '', // 改造日期 - «renovation_date»
        maintenanceUnit: '', // 维护保养单位 - «service_unt_name»
        safetyManager: '', // 安管人员 - «SAFE_MEN»
        ratedLoad: '', // 额定载重量 - «RATEDLOAD»
        floorStationDoor: '', // 层/站/门 - «FLOOR_STADE_DOOR»
        ratedSpeed: '', // 额定速度 - «RATEDVELOCITY»
        runVelocity: '', // 额定运行速度 - «RUNVELOCITY»（与 RATEDVELOCITY 区分）
        controlMethod: '', // 控制方式 - «CONTROL_TYPE»
        // 以下字段与接口 additionalData 根字段对应，用于回填后原样提交
        equipmentName: '', // «EQP_NAME»
        eqpSortName: '', // «EQP_SORT_NAME»（与封面 coverInfo.EQP_SORT_NAME 同步）
        oidNo: '', // «OIDNO»
        eqpTempName: '', // «EQP_TEMP_NAME»
        eqpUseAddr: '', // «EQP_USE_ADDR»（与安装地点 EQP_AREA_NAME 区分）
        eleFloorNumber: null, // «ELEFLOORNUMBER»
        eleStadeNumber: null, // «ELESTADENUMBER»
        eleDoorNumber: null, // «ELEDOORNUMBER»
        eleHeight: '', // «ELEHEIGHT»
        slidwayUseLeng: '', // «SLIDWAY_USE_LENG»
        firstYear: '', // «FIRST_YEAR»
        standardData: '', // 检测依据
        problemSummary: '无', // 检测问题汇总 - «reportConclusion»
        remarks: '无', // 备注 - «reportConclusionDesc»（与检测问题汇总一致，展示/编辑后提交）
        nextTestDate: '', // 下次检测日期 - «nextTestDate» (用于提交)
        nextCheckDate: '', // 下次检验日期 - «nextCheckDate» (用于提交)
        nextTestYear: '', // 下次检测年份（历史字段，兼容保留）
        nextTestMonth: '', // 下次检测月份（历史字段，兼容保留）
        nextCheckYear: '', // 下次检验年份（历史字段，兼容保留）
        nextCheckMonth: '', // 下次检验月份（历史字段，兼容保留）
        detectionPersonnel: '', // 检测人员图片预览
        detectionPersonnelBase64: '', // 检测人员图片base64 - «IMG_test»
        reviewPersonnel: '', // 校核人员图片预览
        reviewPersonnelBase64: '', // 校核人员图片base64 - «IMG_audit»
        detectionDate: '' // 检测日期 - «testEmployeeDate»
      },
      // 人员选项数据
      detectionPersonnelOptions: [], // 检测人员选项
      reviewPersonnelOptions: [], // 校核人员选项
      // 设备选项数据
      equipmentOptions: [], // 设备选项列表
      selectedEquipmentIds: [], // 已选择的设备ID列表，用于过滤
      // 工具箱相关数据
      selectedToolboxNum: '', // 自动获取的工具箱号
      toolboxRestoreLoading: false, // 恢复默认工具箱 API 请求中
      // 检测仪器设备表格数据 - 对应 «EquipmentName01-20» 和 «MgmtNo01-20»
      instrumentTableData: [
        { id: 'instrument-1', serialNumber: 1, name: '', managementNumber: '', usageRecord: '', serialNumber2: 11, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName01», «MgmtNo01»
        { id: 'instrument-2', serialNumber: 2, name: '', managementNumber: '', usageRecord: '', serialNumber2: 12, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName02», «MgmtNo02»
        { id: 'instrument-3', serialNumber: 3, name: '', managementNumber: '', usageRecord: '', serialNumber2: 13, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName03», «MgmtNo03»
        { id: 'instrument-4', serialNumber: 4, name: '', managementNumber: '', usageRecord: '', serialNumber2: 14, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName04», «MgmtNo04»
        { id: 'instrument-5', serialNumber: 5, name: '', managementNumber: '', usageRecord: '', serialNumber2: 15, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName05», «MgmtNo05»
        { id: 'instrument-6', serialNumber: 6, name: '', managementNumber: '', usageRecord: '', serialNumber2: 16, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName06», «MgmtNo06»
        { id: 'instrument-7', serialNumber: 7, name: '', managementNumber: '', usageRecord: '', serialNumber2: 17, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName07», «MgmtNo07»
        { id: 'instrument-8', serialNumber: 8, name: '', managementNumber: '', usageRecord: '', serialNumber2: 18, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName08», «MgmtNo08»
        { id: 'instrument-9', serialNumber: 9, name: '', managementNumber: '', usageRecord: '', serialNumber2: 19, name2: '', managementNumber2: '', usageRecord2: '' }, // «EquipmentName09», «MgmtNo09»
        { id: 'instrument-10', serialNumber: 10, name: '', managementNumber: '', usageRecord: '', serialNumber2: 20, name2: '', managementNumber2: '', usageRecord2: '' } // «EquipmentName10», «MgmtNo10»
      ],
      // 检测环境条件数据
      environmentConditionsData: [
        { id: 'env-1', serialNumber: 1, requirement: '机房或者机器设备间的空气温度保持在 5～40℃之间；', confirmResult: 'qualified' },
        { id: 'env-2', serialNumber: 2, requirement: '电网输入正常，电压波动在额定电压值±7％的范围内；', confirmResult: 'qualified' },
        { id: 'env-3', serialNumber: 3, requirement: '环境空气中没有腐蚀性和易燃性气体及导电尘埃；', confirmResult: 'qualified' },
        { id: 'env-4', serialNumber: 4, requirement: '检测现场(主要指机房或者机器设备间、井道、轿顶、底坑)清洁，没有与电梯运行无关的物品和设备，基站、相关层站等非检测人员可能进入的区域进行了必要的封闭和防护，且放置了表明正在进行检测的警示标志；', confirmResult: 'qualified' },
        { id: 'env-5', serialNumber: 5, requirement: '特殊情况下，电梯设计文件对温度、湿度、电压、环境空气条件等进行了专门规定的，检测现场的温度、湿度、电压、环境空气条件等符合电梯设计文件的规定；', confirmResult: 'qualified' },
        { id: 'env-6', serialNumber: 6, requirement: '继续实施检测可能造成危险', confirmResult: 'unqualified' },
        { id: 'env-7', serialNumber: 7, requirement: '进行整机检测时，电梯不能正常运行', confirmResult: 'unqualified' },
        { id: 'env-8', serialNumber: 8, requirement: '其他：无' }
      ],
      pageOneTreeData: createDefaultPageOneTreeData(),
      pageOneData: [],
      pageOneLayoutHeight: 700,
      // 导航相关数据
      navigationList: [], // 导航列表（两级结构）
      activeNavId: '', // 当前激活的导航项ID
      // 检验结果编辑弹窗
      resultDialogVisible: false, // 检验结果编辑弹窗显示状态
      currentEditRow: null, // 当前编辑的行数据
      initialEditRowResult: null, // 记录打开弹窗时的初始状态（用于判断状态是否变化）
      tempResult: null, // 弹窗内的临时检验结果，未点击“确定”不落库
      detailList: [], // 检验结果详情列表
      selectedDetailPids: [], // 选中的详情PID列表
      detailInputValues: {}, // 详情输入框的值（用于处理"其他:${var1}"类型）
      detailListLoading: false, // 详情列表加载状态
      initialSelectedDetailPids: {}, // 记录页面加载时每个检验项已保存的详情PID列表（初始状态），用于判断新勾选的项
      previousSelectedDetailPids: {}, // 记录每个检验项上一次保存的详情PID列表（用于判断新勾选的项）
      detailSelectedCache: {}, // 详情已勾选缓存：key=itemNumber__checkResult -> parsed detail array（用于反选/回填）
      unqualifiedCustomInfoList: [], // “不符合且未勾选详情”时，提交到 infoList 的自定义记录
      resultColumnWidth: 0, // 检验结果列宽（按表格宽度的 35% 动态计算）
      // 附表查看弹窗
      attachmentDialogVisible: false, // 附表查看弹窗显示状态
      currentAttachmentTable: '', // 当前查看的附表ID
      attachmentDialogBackup: null, // 附表弹窗打开时的快照（用于关闭不保存时回滚）
      // 参照弹窗
      referenceDialogVisible: false, // 参照弹窗显示状态
      // 第二页表格1数据
      pageTwoTable1: {
        samplingFloors: '', // 抽查层站
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table1-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            // 与客梯一致：含施外力门扇与门扇（门扇与门扇间隙）
            doorToDoor: { result: '' },
            doorToColumn: { result: '' },
            doorToLintel: { result: '' },
            doorToSill: { result: '' },
            externalForceDoorToDoor: { result: '' } // 施外力门扇与门扇
          }
        }))
      },
      pageTwoTable1Data: [
        { label: '抽查层站', key: 'samplingFloors' },
        { label: '项目', key: 'project' },
        { label: '门扇与门扇', key: 'doorToDoor' },
        { label: '门扇与立柱', key: 'doorToColumn' },
        { label: '门扇与门楣', key: 'doorToLintel' },
        { label: '门扇与门坎', key: 'doorToSill' },
        { label: '施外力门扇与门扇', key: 'externalForceDoorToDoor' }
      ],
      // 第二页表格2数据 — 附表 A1.2.7.1(2)
      pageTwoTable2: {
        samplingFloors: '', // 抽查层站
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table2-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            doorToDoor: { result: '' },
            doorToColumn: { result: '' },
            doorToLintel: { result: '' },
            doorToSill: { result: '' },
            externalForceDoorToDoor: { result: '' } // 施外力门扇与门扇
          }
        }))
      },
      pageTwoTable2Data: [
        { label: '抽查层站', key: 'samplingFloors' },
        { label: '项目', key: 'project' },
        { label: '门扇与门扇', key: 'doorToDoor' },
        { label: '门扇与立柱', key: 'doorToColumn' },
        { label: '门扇与门楣', key: 'doorToLintel' },
        { label: '门扇与门坎', key: 'doorToSill' },
        { label: '施外力门扇与门扇', key: 'externalForceDoorToDoor' }
      ],
      // 第二页表格3数据
      pageTwoTable3: {
        samplingFloors: '', // 抽查层站
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table3-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            noMeasure: '', // 无防止儿童的手被拖曳的措施
            invalidMeasure: '' // 防止儿童的手被拖曳的措施无效
          }
        }))
      },
      pageTwoTable3Data: [
        { label: '抽查层站', key: 'samplingFloors' },
        { label: '项目', key: 'project' },
        { label: '无防止儿童的手被拖曳的措施', key: 'noMeasure' },
        { label: '防止儿童的手被拖曳的措施无效', key: 'invalidMeasure' }
      ],
      // 第二页表格4数据
      pageTwoTable4: {
        samplingFloors: '', // 抽查层站
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table4-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            derailment: '', // 层门运行时有脱轨现象
            jamming: '', // 层门运行时有机械卡阻现象
            misalignment: '' // 层门运行到终端时有错位现象
          }
        }))
      },
      pageTwoTable4Data: [
        { label: '抽查层站', key: 'samplingFloors' },
        { label: '项目', key: 'project' },
        { label: '层门运行时有脱轨现象', key: 'derailment' },
        { label: '层门运行时有机械卡阻现象', key: 'jamming' },
        { label: '层门运行到终端时有错位现象', key: 'misalignment' }
      ],
      // 第二页表格5数据
      pageTwoTable5: {
        samplingFloors: '',
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table5-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            noDevice: '', // 层门导向装置失效时无层门保持装置
            deviceInvalid: '' // 层门导向装置失效时层门保持装置无法使层门保持在原位置
          }
        }))
      },
      pageTwoTable5Data: [
        { label: '抽查层站', key: 'samplingFloors' },
        { label: '项目', key: 'project' },
        { label: '层门导向装置失效时无层门保持装置', key: 'noDevice' },
        { label: '层门导向装置失效时层门保持装置无法使层门保持在原位置', key: 'deviceInvalid' }
      ],
      // 第二页表格6数据
      pageTwoTable6: {
        samplingFloors: '',
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table6-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            noMark: '', // 底部的层门保持装置无最小啮合深度的标记
            lessThanMark: '' // 底部的层门保持装置啮合深度小于标记值
          }
        }))
      },
      pageTwoTable6Data: [
        { label: '抽查层站', key: 'samplingFloors' },
        { label: '项目', key: 'project' },
        { label: '底部的层门保持装置无最小啮合深度的标记', key: 'noMark' },
        { label: '底部的层门保持装置啮合深度小于标记值', key: 'lessThanMark' }
      ],
      // 第二页表格7数据
      pageTwoTable7: {
        samplingFloors: '',
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table7-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            noAutoClose: '', // 层门无自动关闭装置
            autoCloseInvalid: '' // 层门自动关闭装置失效
          }
        }))
      },
      pageTwoTable7Data: [
        { label: '抽查层站', key: 'samplingFloors' },
        { label: '项目', key: 'project' },
        { label: '层门无自动关闭装置', key: 'noAutoClose' },
        { label: '层门自动关闭装置失效', key: 'autoCloseInvalid' }
      ],
      // 第二页表格8数据
      pageTwoTable8: {
        samplingFloors: '',
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table8-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            noPreventFall: '', // 重块式自动关闭层门装置无防止重块坠落措施
            preventFallUnreliable: '' // 重块式自动关闭层门装置防止重块坠落措施不可靠
          }
        }))
      },
      pageTwoTable8Data: [
        { label: '抽查层站', key: 'samplingFloors' },
        { label: '项目', key: 'project' },
        { label: '重块式自动关闭层门装置无防止重块坠落措施', key: 'noPreventFall' },
        { label: '重块式自动关闭层门装置防止重块坠落措施不可靠', key: 'preventFallUnreliable' }
      ],
      // 第二页表格9数据
      pageTwoTable9: {
        samplingFloors: '',
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table9-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            noEmergencyUnlock: '', // 层门无紧急开锁装置
            emergencyUnlockUnreliable: '', // 层门紧急开锁装置不能可靠开启
            unlockStillOpen: '' // 层门闭合时紧急开锁装置仍保持开锁位置
          }
        }))
      },
      pageTwoTable9Data: [
        { label: '抽查层站', key: 'samplingFloors' },
        { label: '项目', key: 'project' },
        { label: '层门无紧急开锁装置', key: 'noEmergencyUnlock' },
        { label: '层门紧急开锁装置不能可靠开启', key: 'emergencyUnlockUnreliable' },
        { label: '层门闭合时紧急开锁装置仍保持开锁位置', key: 'unlockStillOpen' }
      ],
      // 第二页表格10数据
      pageTwoTable10: {
        samplingFloors: '',
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table10-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            noLockDevice: '', // 未设置门锁装置
            lockNotByGravity: '', // 锁紧动作不由重力、永久磁铁或弹簧产生和保持
            lockNotMaintain: '', // 锁紧动作不能保持
            gravityCanUnlock: '', // 保持锁紧的元件失效后重力可导致开锁
            doorLockInvalid: '' // 层门门锁装置失效
          }
        }))
      },
      pageTwoTable10Data: [
        { label: '抽查层站', key: 'samplingFloors' },
        { label: '项目', key: 'project' },
        { label: '未设置门锁装置', key: 'noLockDevice' },
        { label: '锁紧动作不由重力、永久磁铁或弹簧产生和保持', key: 'lockNotByGravity' },
        { label: '锁紧动作不能保持', key: 'lockNotMaintain' },
        { label: '保持锁紧的元件失效后重力可导致开锁', key: 'gravityCanUnlock' },
        { label: '层门门锁装置失效', key: 'doorLockInvalid' }
      ],
      // 第二页表格11数据
      pageTwoTable11: {
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table11-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            // 新需求：该附表不再填写/传递层站，只保留检测结果
            project: { result: '' },
            lockLength1: { result: '' },
            lockLength2: { result: '' },
            lockLength3: { result: '' },
            lockLength4: { result: '' }
          }
        }))
      },
      pageTwoTable11Data: [
        { label: '项目', key: 'project' },
        { label: '层门锁啮合长度', key: 'lockLength1' },
        // { label: '层门锁啮合长度', key: 'lockLength2' },
        // { label: '层门锁啮合长度', key: 'lockLength3' },
        // { label: '层门锁啮合长度', key: 'lockLength4' }
      ],
      // 第二页表格12数据
      pageTwoTable12: {
        samplingFloors: '',
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table12-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            noElectricDevice: '', // 未设检查层门锁紧状态的电气安全装置
            electricDeviceInvalid: '' // 检查层门锁紧状态的电气安全装置失效
          }
        }))
      },
      pageTwoTable12Data: [
        { label: '抽查层站', key: 'samplingFloors' },
        { label: '项目', key: 'project' },
        { label: '未设检查层门锁紧状态的电气安全装置', key: 'noElectricDevice' },
        { label: '检查层门锁紧状态的电气安全装置失效', key: 'electricDeviceInvalid' }
      ],
      // 第二页表格13数据
      pageTwoTable13: {
        samplingFloors: '',
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table13-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            noVerifyDevice: '', // 无验证层门(间接门扇)的电气安全装置
            verifyDeviceInvalid: '' // 验证层门(间接门扇)的电气安全装置失效
          }
        }))
      },
      pageTwoTable13Data: [
        { label: '抽查层站', key: 'samplingFloors' },
        { label: '项目', key: 'project' },
        { label: '无验证层门(间接门扇)的电气安全装置', key: 'noVerifyDevice' },
        { label: '验证层门(间接门扇)的电气安全装置失效', key: 'verifyDeviceInvalid' }
      ],
      // 第二页表格14数据
      pageTwoTable14: {
        samplingFloors: '',
        columns: Array.from({ length: 13 }, (_, i) => ({
          id: `table14-col-${i}`, // 添加唯一ID
          label: `第${i + 1}列`,
          data: {
            // 新需求：该附表不再填写/传递层站，只保留检测结果
            doorKnifeGap: { result: '' }, // 轿门门刀与层门地坎的间隙
            rollerGap: { result: '' } // 层门滚轮与轿厢地坎的间隙
          }
        }))
      },
      pageTwoTable14Data: [
        { label: '抽查层站', key: 'samplingFloors' },
        { label: '项目', key: 'project' },
        { label: '轿门门刀与层门地坎的间隙', key: 'doorKnifeGap' },
        { label: '层门滚轮与轿厢地坎的间隙', key: 'rollerGap' }
      ],
      // 第二页表格15数据
      pageTwoTable15: {
        currentUp: { load30: '', load40: '', load45: '', load50: '', load60: '' }, // 电流，上行
        currentDown: { load30: '', load40: '', load45: '', load50: '', load60: '' } // 电流，下行
      },
      pageTwoTable15Data: [
        { label: '电流，上行', key: 'currentUp' },
        { label: '电流，下行', key: 'currentDown' }
      ],
      // 第二页表格16数据
      pageTwoTable16: {
        manufacturer: '', // 制造单位
        productNumber: '', // 产品编号
        model: '', // 规格型号
        mechanicalSpeed: { up1: '', up2: '', up3: '', upAvg: '', down1: '', down2: '', down3: '', downAvg: '' }, // 机械动作速度
        electricSpeed: { up1: '', up2: '', up3: '', upAvg: '', down1: '', down2: '', down3: '', downAvg: '' } // 电气动作速度
      },
      pageTwoTable16InfoData: [
        { label: '制造单位', key: 'manufacturer' },
        { label: '产品编号', key: 'productNumber' }
      ],
      pageTwoTable16Data: [
        { label: '机械动作速度', key: 'mechanicalSpeed' },
        { label: '电气动作速度', key: 'electricSpeed' }
      ],
      // 第二页表格17数据 - 噪声测试记录表
      pageTwoTable17: {
        machineRoom: { background: '', point1: '', point2: '', point3: '', result: '' }, // 机房噪声
        carInside: { background: '', up: '', down: '', result: '' }, // 轿厢内噪声
        doorNoise: { background: '', open: '', close: '', result: '' }, // 开关门噪声
        noMachineRoom: { background: '', up: '', down: '', result: '' } // 无机房电梯层门处噪声
      },
      pageTwoTable17Data: [
        { label: '机房噪声', type: 'header', key: 'machineRoom', rowType: 'machineRoom', col2: '背景', col3: '测试点1', col4: '测试点2', col5: '测试点3' },
        { label: '', type: 'input', key: 'machineRoom', rowType: 'machineRoom' },
        { label: '轿厢内噪声', type: 'header', key: 'carInside', rowType: 'twoColumn', col2: '背景', col3: '全程额定速度上行', col5: '全程额定速度下行' },
        { label: '', type: 'input', key: 'carInside', rowType: 'twoColumn' },
        { label: '开关门噪声', type: 'header', key: 'doorNoise', rowType: 'twoColumn', col2: '背景', col3: '开门', col5: '关门' },
        { label: '', type: 'input', key: 'doorNoise', rowType: 'twoColumn' },
        { label: '无机房电梯层门处噪声', type: 'header', key: 'noMachineRoom', rowType: 'twoColumn', col2: '背景', col3: '全程额定速度上行', col5: '全程额定速度下行' },
        { label: '', type: 'input', key: 'noMachineRoom', rowType: 'twoColumn' }
      ],
      // 层站设置弹窗状态与数据
      floorSettingDialogVisible: false,
      floorSettingData: {
        id: undefined,
        minFloor: '1',
        totalDoors: '',
        doorType: 'normal',
        openType: 'center',
        carDoorLock: 'no',
        floorDoorNumbers: '',
        checkStations: [],
        floorOptions: []
      },
      // 参照弹窗状态
      referenceDialogVisible: false
    };
  },
  created () {
    // 生成唯一的组件ID，避免重复键问题
    this.componentId = 'record-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    this.initializePageOneData();
    // 从路由参数获取数据并初始化页面
    this.initPageFromRoute();
  },
  mounted () {
    // 确保表格渲染完成后设置滚动
    setTimeout(() => {
      this.ensureTableScrollable();
      this.updateResultColumnWidth();
    }, 500);
    window.addEventListener('resize', this.updateResultColumnWidth);
  },
  // 组件关闭时清理缓存与页面数据
  beforeDestroy () {
    // 清理与当前原始记录相关的本地缓存
    this.clearRecordCache();
    window.removeEventListener('resize', this.updateResultColumnWidth);
  },
  computed: {
    pageTwoTable1DisplayData () {
      // 与客梯一致：旁开门显示「施外力门扇与门柱」，中分门显示「施外力门扇与门扇」
      const openType = this.floorSettingData && this.floorSettingData.openType;
      const externalForceLabel = openType === 'side'
        ? '施外力门扇与门柱'
        : '施外力门扇与门扇';

      return (this.pageTwoTable1Data || []).map(item => {
        if (item && item.key === 'externalForceDoorToDoor') {
          return {
            ...item,
            label: externalForceLabel
          };
        }
        return item;
      });
    }
  },
  methods: {
    // 是否带配图的检测项（断丝数表 / 噪声限值表）
    isItemWithImage (row) {
      if (!row) return false;
      if (row.hasImage) return true;
      return !!ITEM_IMAGE_MAP[row.itemNumber];
    },
    // 配图地址：图片请放到 src/assets/images/ 对应文件名
    getItemImageSrc (row) {
      const itemNumber = row && row.itemNumber;
      if (itemNumber === 'A1.2.5.1.2') {
        // 占位：src/assets/images/A1.2.5.1.jpg
        return require('@/assets/images/A1.2.5.1.png');
      }
      if (itemNumber === 'A1.3.14.1') {
        // 占位：src/assets/images/A1.3.14-firefighter.jpg（也可先复用客梯 1.3.14.jpg）
        return require('@/assets/images/A1.3.14-firefighter.png');
      }
      return '';
    },
    updateResultColumnWidth () {
      this.$nextTick(() => {
        const table = this.$refs.pageOneTable;
        const el = table && table.$el ? table.$el : null;
        if (!el) return;
        const w = el.clientWidth || 0;
        if (!w) return;
        // Element-UI 的 column width 本质是 px，这里按表格可视宽度的 35% 换算
        const next = Math.max(220, Math.floor(w * 0.25));
        if (next !== this.resultColumnWidth) {
          this.resultColumnWidth = next;
          if (this.$refs.pageOneTable) {
            this.$refs.pageOneTable.doLayout();
          }
        }
      });
    },

    // 查看PDF按钮
    handlePDF () {
      // console.log(row.status == '1');
      // if (row.status != '9') {
      //   // 弹出选择框让用户选择打印类型
      //   this.$confirm('请选择要查看的内容：', '选择打印类型', {
      //     distinguishCancelAndClose: true,
      //     confirmButtonText: '原始记录',
      //     cancelButtonText: '报告',
      //     type: 'info'
      //   }).then(() => {
      //     // 用户选择了原始记录 (type: 1)
      //     this.callPreviewAPI(row.entrustNum, 1);
      //   }).catch(action => {
      //     if (action === 'cancel') {
      //       // 用户选择了报告 (type: 0)
      //       this.callPreviewAPI(row.entrustNum, 0);
      //     }
      //     // 如果是 close，则不执行任何操作
      //   });
      // } else {
      //   this.$message.error('该原始记录未录入，无法查看PDF');
      //   return false;
      // }
      // 用户选择了原始记录 (type: 1)
      this.callPreviewAPI(this.coverInfo.entrustNum, 1);
    },

    // 调用预览PDF的API
    callPreviewAPI (entrustNum, type) {
      // 显示全屏遮罩层
      const loading = this.$loading({
        lock: true,
        text: '正在生成PDF，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      previewTestDataPdf({ entrustNums: [entrustNum], type: type }).then(response => {
        console.log(response);
        loading.close();

        if (response && response.retCode === 'ok' && response.additionalData) {
          // 设置PDF文件名并打开预览弹窗
          this.pdfFileName = response.additionalData + '.pdf';
          this.pdfPreviewVisible = true;
          this.$message.success('PDF生成成功');
        } else {
          this.$message.error(response.retMsg || 'PDF生成失败');
        }
      }).catch(error => {
        console.error('查看PDF失败:', error);
        loading.close();
        this.$message.error('查看PDF失败');
      });
    },

    // 将结果转换为检查结果
    resultToCheckResult (result) {
      if (result === 'qualified') return 1;
      if (result === 'notApplicable') return -1;
      return 0;
    },

    // 获取某一行“已勾选的检验结果详情文本”，每条换行展示
    getRowSelectedDetailTexts (row) {
      if (!row || !row.itemNumber) return [];
      if (!this.additionalDataList || !Array.isArray(this.additionalDataList.datas)) return [];

      const code = row.itemNumber;
      const targetCheckResult = this.resultToCheckResult(row.result);

      const match = (strictByCheckResult) => this.additionalDataList.datas.find(d => {
        if (!d || !d.dataValue) return false;
        try {
          const parsed = JSON.parse(d.dataValue);
          if (!(Array.isArray(parsed) && parsed.length > 0 && parsed[0] && parsed[0].contentDetailPid)) return false;
          if (parsed[0].configTestItemsContentCode !== code) return false;
          if (!strictByCheckResult) return true;
          return parsed[0].checkResult == null || parsed[0].checkResult === targetCheckResult;
        } catch (e) {
          return false;
        }
      });

      const found = match(true) || match(false);
      if (!found || !found.dataValue) return [];

      try {
        const parsed = JSON.parse(found.dataValue);
        if (!Array.isArray(parsed)) return [];
        return parsed
          .map(item => this.formatDetailContent(item))
          .map(t => (t == null ? '' : String(t)).trim())
          .filter(Boolean);
      } catch (e) {
        return [];
      }
    },
    // 工具箱 dataKey（提交到 datas，并用于回填）
    getToolboxDataKey () {
      return 'ToolboxNum';
    },

    // 是否为工具箱/仪器设备相关 dataKey（参照时不回填）
    isToolboxRelatedDataKey (dataKey) {
      if (!dataKey || typeof dataKey !== 'string') return false;
      const key = dataKey.startsWith('*') ? dataKey.substring(1) : dataKey;
      if (key === this.getToolboxDataKey()) return true;
      if (key.startsWith('EquipmentName') || key.startsWith('MgmtNo')) return true;
      if (/^V\d{2}$/.test(key)) return true;
      return false;
    },

    // 从参照 payload 中剔除工具箱与仪器设备项，避免覆盖当前页工具箱配置
    stripToolboxFromReferenceData (source) {
      if (!source || typeof source !== 'object') return source;
      const data = { ...source };
      Object.keys(data).forEach((key) => {
        if (this.isToolboxRelatedDataKey(key)) {
          delete data[key];
        }
      });
      if (Array.isArray(data.datas)) {
        data.datas = data.datas.filter(item => !item || !this.isToolboxRelatedDataKey(item.dataKey));
      }
      return data;
    },

    getPageTwoTableColumnCount (tableNum) {
      const table = this[`pageTwoTable${tableNum}`];
      return table && Array.isArray(table.columns) ? table.columns.length : 0;
    },

    // 解析层站设置，供附表列渲染与提交校验共用
    getFloorSettingStationContext () {
      const allStations = Array.isArray(this.floorSettingData.checkStations)
        ? this.floorSettingData.checkStations.slice()
        : [];
      const hasConfig = allStations.length > 0;
      const floorDoorStations = String((this.floorSettingData && this.floorSettingData.floorDoorNumbers) || '')
        .split('/')
        .map(s => String(s || '').trim())
        .filter(s => s);

      const isCarDoorStation = (s) => /^轿门/.test(String(s || '').trim());
      const withoutLock = allStations.filter(s => !isCarDoorStation(s));
      const withLock = allStations.slice();
      const requiredCarDoorTables = ['table1', 'table2'];
      const getRequiredCarDoorsByType = () => (this.floorSettingData && this.floorSettingData.doorType) === 'through'
        ? ['轿门A', '轿门B']
        : ['轿门'];
      const ensureCarDoorStations = (stations, tableId) => {
        if (!requiredCarDoorTables.includes(tableId)) return stations;
        const baseStations = Array.isArray(stations) ? stations.slice() : [];
        const nonCarDoorStations = baseStations.filter(s => !isCarDoorStation(s));
        const requiredCarDoors = getRequiredCarDoorsByType();
        const result = requiredCarDoors.slice();
        nonCarDoorStations.forEach(s => {
          if (!result.includes(s)) {
            result.push(s);
          }
        });
        return result;
      };
      const excludeLockTables = ['table5', 'table6', 'table7', 'table8', 'table9', 'table10', 'table14'];
      const excludeCarDoorStations = (stations, tableId) => {
        if (!excludeLockTables.includes(tableId)) return stations;
        const baseStations = Array.isArray(stations) ? stations.slice() : [];
        return baseStations.filter(s => !isCarDoorStation(s));
      };
      const getTableStations = (stations, tableId) => {
        const baseStations = Array.isArray(stations) ? stations.slice() : [];
        return excludeCarDoorStations(ensureCarDoorStations(baseStations, tableId), tableId);
      };
      const uniqueStations = (stations) => {
        const baseStations = Array.isArray(stations) ? stations : [];
        return Array.from(new Set(baseStations));
      };
      const buildTable11Stations = (stations) => {
        const baseStations = Array.isArray(stations) ? stations.slice() : [];
        const hasCarDoorLock = this.floorSettingData && this.floorSettingData.carDoorLock === 'yes';
        if (!hasCarDoorLock) {
          return uniqueStations(baseStations);
        }
        const requiredCarDoors = getRequiredCarDoorsByType();
        const existingCarDoors = baseStations.filter(s => isCarDoorStation(s));
        const nonCarDoorStations = baseStations.filter(s => !isCarDoorStation(s));
        const matchedCarDoors = requiredCarDoors.filter(s => existingCarDoors.includes(s));
        const carDoorStations = matchedCarDoors.length > 0 ? matchedCarDoors : requiredCarDoors.slice();
        return uniqueStations(carDoorStations.concat(nonCarDoorStations));
      };

      return {
        hasConfig,
        allStations,
        floorDoorStations,
        withoutLock,
        withLock,
        getTableStations,
        buildTable11Stations
      };
    },

    // 按层门编号 / 检查层站规则，计算各附表允许的抽查层站（无配置时返回 null）
    getExpectedAttachmentTableStations (tableNum) {
      const ctx = this.getFloorSettingStationContext();
      if (!ctx.hasConfig) return null;

      const n = Number(tableNum);
      if (!Number.isFinite(n)) return null;

      switch (n) {
        case 1:
        case 2:
          return ctx.getTableStations(ctx.withLock, `table${n}`);
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
          return ctx.withoutLock;
        case 10:
          return ctx.getTableStations(ctx.withLock, 'table10');
        case 11:
          return ctx.buildTable11Stations(ctx.floorDoorStations);
        case 12:
        case 13:
          return ctx.withLock;
        case 14:
          return ctx.getTableStations(ctx.withLock, 'table14');
        default:
          return null;
      }
    },

    // 提交/裁剪时优先使用层站规则列数，避免 UI 仍保留参照时的多余列
    getExpectedPageTwoTableColumnCount (tableNum) {
      const expectedStations = this.getExpectedAttachmentTableStations(tableNum);
      if (expectedStations && expectedStations.length > 0) {
        return expectedStations.length;
      }
      return this.getPageTwoTableColumnCount(tableNum);
    },

    getTableColumnsForSubmit (tableNum) {
      const table = this[`pageTwoTable${tableNum}`];
      if (!table || !Array.isArray(table.columns)) return [];
      const expectedCount = this.getExpectedPageTwoTableColumnCount(tableNum);
      if (expectedCount > 0 && table.columns.length > expectedCount) {
        return table.columns.slice(0, expectedCount);
      }
      return table.columns;
    },

    getSubmitCheckFloorValue (tableNum, tableObj, getTableSamplingFloors) {
      const expectedStations = this.getExpectedAttachmentTableStations(tableNum);
      if (expectedStations && expectedStations.length > 0) {
        return expectedStations.join('/');
      }
      return getTableSamplingFloors(tableObj);
    },

    // 解析附表11 SR 键对应的列号（与 fillPageTwoData 规则一致，供裁剪/回填共用）
    parseTable11SrKeyMeta (rest, maxCols) {
      if (!/^\d+$/.test(String(rest || ''))) return null;
      const max = Number(maxCols);
      if (!Number.isFinite(max) || max < 1) return null;

      const directColNum = parseInt(rest, 10);
      if (!isNaN(directColNum) && directColNum >= 1 && directColNum <= max) {
        return { tableNum: 11, colNum: directColNum };
      }
      if (rest.length >= 2) {
        const rowNum = parseInt(rest.slice(-1), 10);
        const colNum = parseInt(rest.slice(0, -1), 10);
        if (
          !isNaN(colNum) && colNum >= 1 && colNum <= max &&
          !isNaN(rowNum) && rowNum >= 1 && rowNum <= 4
        ) {
          return { tableNum: 11, colNum };
        }
      }
      return null;
    },

    // 解析附表 dataKey 对应的表格序号与列号（用于参照回填裁剪）
    parsePageTwoReferenceColumnKey (dataKey) {
      const key = String(dataKey || '').startsWith('*')
        ? String(dataKey).substring(1)
        : String(dataKey || '');
      if (!key || !this.isPageTwoDataKey(key)) return null;

      const parseIndexed = (prefix, tableNum) => {
        if (!key.startsWith(prefix)) return null;
        const rest = key.slice(prefix.length);
        if (!/^\d+$/.test(rest)) return null;
        const colNum = parseInt(rest, 10);
        return Number.isFinite(colNum) && colNum >= 1 ? { tableNum, colNum } : null;
      };

      const rules = [
        () => parseIndexed('WFZZ', 8),
        () => parseIndexed('FZZl', 8),
        () => parseIndexed('ZDSX', 7),
        () => parseIndexed('WJJ', 9),
        () => parseIndexed('BNKQ', 9),
        () => parseIndexed('BCKS', 9),
        () => parseIndexed('SJSX', 10),
        () => parseIndexed('WCM', 5),
        () => parseIndexed('WBC', 5),
        () => parseIndexed('WZX', 6),
        () => parseIndexed('NXY', 6),
        () => parseIndexed('MDR', 14),
        () => parseIndexed('MZR', 14),
        () => parseIndexed('MMR', 2),
        () => parseIndexed('MKR', 2),
        () => parseIndexed('MWR', 2),
        () => parseIndexed('MZF', 2),
        () => parseIndexed('MDF', 2),
        () => parseIndexed('MMF', 2),
        () => parseIndexed('MKF', 2),
        () => parseIndexed('WR', 1),
        () => parseIndexed('DR', 1),
        () => parseIndexed('ZR', 1),
        () => parseIndexed('MR', 1),
        () => parseIndexed('KR', 1),
        () => (key.startsWith('WF') && !key.startsWith('WFZZ') ? parseIndexed('WF', 3) : null),
        () => (key.startsWith('FZ') && !key.startsWith('FZZl') ? parseIndexed('FZ', 3) : null),
        () => parseIndexed('CW', 4),
        () => (key.startsWith('T') && !key.startsWith('TestResult') ? parseIndexed('T', 4) : null),
        () => (key.startsWith('K') && !key.startsWith('KF') && !key.startsWith('KR') ? parseIndexed('K', 4) : null),
        () => {
          if (
            key === 'W' ||
            (key.startsWith('W') &&
              !key.startsWith('WF') &&
              !key.startsWith('WCM') &&
              !key.startsWith('WBC') &&
              !key.startsWith('WZX') &&
              !key.startsWith('WJJ') &&
              !key.startsWith('WDQ') &&
              !key.startsWith('WZJZS'))
          ) {
            return parseIndexed('W', 7);
          }
          return null;
        },
        () => (key.startsWith('SJ') && !key.startsWith('SJSX') ? parseIndexed('SJ', 10) : null),
        () => (
          key === 'S' ||
          (key.startsWith('S') &&
            !key.startsWith('SJ') &&
            !key.startsWith('SF') &&
            !key.startsWith('SR') &&
            !key.startsWith('Specification'))
        ) ? parseIndexed('S', 10) : null,
        () => (
          key === 'B' ||
          (key.startsWith('B') &&
            !key.startsWith('BNKQ') &&
            !key.startsWith('BCKS') &&
            !key.startsWith('BJS'))
        ) ? parseIndexed('B', 10) : null,
        () => (key === 'C' || (key.startsWith('C') && !key.startsWith('CW') && !key.startsWith('CJXF') && !key.startsWith('CJXR'))
          ? parseIndexed('C', 10) : null),
        () => (key === 'D' || (key.startsWith('D') && !key.startsWith('DQDZ') && !key.startsWith('Download'))
          ? parseIndexed('D', 12) : null),
        () => (key === 'Q' || (key.startsWith('Q') && !key.startsWith('QF')) ? parseIndexed('Q', 12) : null),
        () => parseIndexed('WDQ', 13),
        () => (key === 'Y' || (key.startsWith('Y') && !key.startsWith('YF')) ? parseIndexed('Y', 13) : null),
        () => {
          if (!key.startsWith('SR')) return null;
          // 解析时不限制列数，提交/裁剪阶段再按层站规则过滤
          return this.parseTable11SrKeyMeta(key.slice(2), Number.MAX_SAFE_INTEGER);
        }
      ];

      for (let i = 0; i < rules.length; i++) {
        const parsed = rules[i]();
        if (parsed) return parsed;
      }
      return null;
    },

    // 参照回填：按当前单层站列数裁剪附表 datas，避免多出的层站数据被提交
    trimReferenceDatasToCurrentFloorSetting (datas) {
      if (!Array.isArray(datas)) return [];

      return datas.map((item) => {
        if (!item || !item.dataKey) return item;
        const key = item.dataKey.startsWith('*') ? item.dataKey.substring(1) : item.dataKey;

        const checkFloorMatch = key.match(/^CheckFloor(\d+)$/);
        if (checkFloorMatch) {
          const tableNum = parseInt(checkFloorMatch[1], 10);
          const expectedStations = this.getExpectedAttachmentTableStations(tableNum);
          if (expectedStations && expectedStations.length > 0) {
            return { ...item, dataValue: expectedStations.join('/') };
          }
          const maxCol = this.getExpectedPageTwoTableColumnCount(tableNum);
          if (maxCol > 0 && item.dataValue != null && item.dataValue !== '') {
            const parts = String(item.dataValue).split('/').map(s => s.trim()).filter(Boolean);
            if (parts.length > maxCol) {
              return { ...item, dataValue: parts.slice(0, maxCol).join('/') };
            }
          }
          return item;
        }

        if (!this.isPageTwoDataKey(key)) return item;

        const meta = this.parsePageTwoReferenceColumnKey(key);
        if (!meta || !meta.tableNum || !meta.colNum) return item;

        const maxCol = this.getExpectedPageTwoTableColumnCount(meta.tableNum);
        if (maxCol > 0 && meta.colNum > maxCol) return null;
        return item;
      }).filter(Boolean);
    },

    // 参照回填后，用当前页面附表状态覆盖 additionalDataList 中的附表项，确保提交与 UI 一致
    syncAdditionalDataListPageTwoFromUI () {
      if (!this.additionalDataList) {
        this.additionalDataList = {};
      }
      if (!Array.isArray(this.additionalDataList.datas)) {
        this.additionalDataList.datas = [];
      }
      const pageTwoDatas = this.savePageTwoData();
      const nonPageTwoDatas = this.additionalDataList.datas.filter((item) => {
        if (!item || !item.dataKey) return false;
        const key = item.dataKey.startsWith('*') ? item.dataKey.substring(1) : item.dataKey;
        return !this.isPageTwoDataKey(key);
      });
      this.additionalDataList.datas = [...nonPageTwoDatas, ...pageTwoDatas];
    },

    // 从 additionalData.datas 回填工具箱号
    fillToolboxNum (additionalData) {
      if (!additionalData || !Array.isArray(additionalData.datas)) return;
      const key = this.getToolboxDataKey();
      const found = additionalData.datas.find(d => d && d.dataKey === key);
      if (found && found.dataValue !== undefined && found.dataValue !== null) {
        this.selectedToolboxNum = String(found.dataValue);
      }
    },

    parseNumberForAvg (value) {
      if (value === null || value === undefined) return null;
      const strValue = String(value).trim();
      if (strValue === '') return null;
      const numberValue = Number(strValue);
      return Number.isFinite(numberValue) ? numberValue : null;
    },
    formatAvgValue (value) {
      // 计算结果保留整数：若有小数则四舍五入取整
      const n = Number(value);
      if (!Number.isFinite(n)) return '';
      return String(Math.round(n));
    },
    updatePageTwoTable16Avg (speedType, direction) {
      const speedGroup = this.pageTwoTable16 && this.pageTwoTable16[speedType];
      if (!speedGroup) return;
      const avgKey = direction === 'up' ? 'upAvg' : 'downAvg';
      const keyPrefix = direction === 'up' ? 'up' : 'down';
      const values = [
        this.parseNumberForAvg(speedGroup[`${keyPrefix}1`]),
        this.parseNumberForAvg(speedGroup[`${keyPrefix}2`]),
        this.parseNumberForAvg(speedGroup[`${keyPrefix}3`])
      ];
      if (values.some(item => item === null)) {
        speedGroup[avgKey] = '';
        return;
      }
      const avg = (values[0] + values[1] + values[2]) / 3;
      speedGroup[avgKey] = this.formatAvgValue(avg);
    },
    refreshPageTwoTable16AllAvg () {
      ['mechanicalSpeed', 'electricSpeed'].forEach(speedType => {
        this.updatePageTwoTable16Avg(speedType, 'up');
        this.updatePageTwoTable16Avg(speedType, 'down');
      });
    },
    updatePageTwoTable17Result (rowKey) {
      if (!this.pageTwoTable17 || !this.pageTwoTable17[rowKey]) return;
      const rowData = this.pageTwoTable17[rowKey];

      if (rowKey === 'machineRoom') {
        const values = [
          this.parseNumberForAvg(rowData.point1),
          this.parseNumberForAvg(rowData.point2),
          this.parseNumberForAvg(rowData.point3)
        ];
        if (values.some(item => item === null)) {
          rowData.result = '';
          return;
        }
        rowData.result = this.formatAvgValue((values[0] + values[1] + values[2]) / 3);
        return;
      }

      const pairKeyMap = {
        carInside: ['up', 'down'],
        doorNoise: ['open', 'close'],
        noMachineRoom: ['up', 'down']
      };
      const pairKeys = pairKeyMap[rowKey];
      if (!pairKeys) return;

      const values = pairKeys.map(key => this.parseNumberForAvg(rowData[key]));
      if (values.some(item => item === null)) {
        rowData.result = '';
        return;
      }
      rowData.result = Math.max(...values);
    },
    refreshPageTwoTable17AllResult () {
      ['machineRoom', 'carInside', 'doorNoise', 'noMachineRoom'].forEach(rowKey => {
        this.updatePageTwoTable17Result(rowKey);
      });
    },
    // 将页面数据恢复到 data() 定义的初始状态
    resetPageData () {
      // 只重置 data 内的数据，不影响 props（如 url）
      const initialData = this.$options.data.call(this);
      Object.keys(initialData).forEach(key => {
        this.$data[key] = initialData[key];
      });
    },

    // 清理与原始记录页面相关的本地缓存
    clearRecordCache () {
      try {
        // 清理以 recordData_ 开头的 sessionStorage 项（由列表页写入）
        Object.keys(sessionStorage).forEach(key => {
          if (key.indexOf('recordData_') === 0) {
            sessionStorage.removeItem(key);
          }
        });
      } catch (e) {
        console.error('清理原始记录缓存失败：', e);
      }
    },
    // 规范化占位符输入框的“内部值”
    // 目标：无论传入是 "999"、"${999}"、"${${999}}"、"${999"、"999}"，都尽量归一为 "999"
    normalizePlaceholderInnerValue (raw) {
      let s = raw == null ? '' : String(raw);
      // 先处理完整包裹的 ${...}（可能多层）
      while (s.startsWith('${') && s.endsWith('}')) {
        s = s.slice(2, -1);
      }
      // 再兜底处理不完整的壳（历史坏数据可能出现）
      while (s.startsWith('${')) {
        s = s.slice(2);
      }
      while (s.endsWith('}')) {
        s = s.slice(0, -1);
      }
      return s;
    },
    // 从 additionalDataList.datas 初始化“已勾选详情缓存”
    // 缓存结构：key = `${configTestItemsContentCode}__${checkResult}`，value = parsed detail array
    // 用于：每次打开弹窗/切换结果后（接口拉到 detailList），按 contentDetailPid 反选 & 回填输入框
    initDetailSelectedCacheFromDatas () {
      this.detailSelectedCache = {};
      if (!this.additionalDataList || !Array.isArray(this.additionalDataList.datas)) return;

      this.additionalDataList.datas.forEach(d => {
        if (!d || !d.dataValue) return;
        try {
          const parsed = JSON.parse(d.dataValue);
          if (!Array.isArray(parsed) || parsed.length === 0) return;
          const first = parsed[0] || {};
          if (!first.configTestItemsContentCode) return;
          // 后台数据里 checkResult 一定有（你示例里有），没有就按 0 兜底
          const cr = (first.checkResult === undefined || first.checkResult === null) ? 0 : first.checkResult;
          const key = `${first.configTestItemsContentCode}__${cr}`;
          this.$set(this.detailSelectedCache, key, parsed);
        } catch (e) {
          // ignore
        }
      });
    },
    // 判断详情内容是否包含占位符输入框（形如 ${...}，支持多个）
    hasDetailPlaceholders (content) {
      return typeof content === 'string' && /\$\{[^}]*\}/.test(content);
    },
    // 点击整条详情时切换选中状态，提升可点击区域
    toggleDetailSelection (item) {
      if (!item || !item.contentDetailPid) return;
      const pid = item.contentDetailPid;
      const index = this.selectedDetailPids.indexOf(pid);
      if (index > -1) {
        this.selectedDetailPids.splice(index, 1);
      } else {
        this.selectedDetailPids.push(pid);
      }
    },

    // 将详情内容切分为文本段与输入框段，并确保输入数组是响应式的
    // 例如：'允许值${var1}mm,实测值${var2}mm' =>
    // ['允许值', input0, 'mm,实测值', input1, 'mm']
    getDetailContentSegments (item) {
      const content = item && item.detailContent ? String(item.detailContent) : '';
      const pid = item && item.contentDetailPid ? item.contentDetailPid : '';
      const segments = [];
      if (!content) return segments;

      const reg = /\$\{[^}]*\}/g;
      let lastIndex = 0;
      let inputIndex = 0;
      let m;
      while ((m = reg.exec(content)) !== null) {
        if (m.index > lastIndex) {
          segments.push({ type: 'text', value: content.slice(lastIndex, m.index) });
        }
        segments.push({ type: 'input', inputIndex });
        inputIndex++;
        lastIndex = reg.lastIndex;
      }
      if (lastIndex < content.length) {
        segments.push({ type: 'text', value: content.slice(lastIndex) });
      }

      // 初始化/补齐输入数组，确保 v-model 可以正常工作
      if (pid) {
        const existing = this.detailInputValues[pid];
        if (!Array.isArray(existing)) {
          this.$set(this.detailInputValues, pid, Array(inputIndex).fill(''));
        } else if (existing.length < inputIndex) {
          const next = existing.slice();
          while (next.length < inputIndex) next.push('');
          this.$set(this.detailInputValues, pid, next);
        }
      }

      return segments;
    },

    // 校验已勾选的详情项中，包含占位符输入框的必须全部填写
    validateDetailInputs () {
      // 没有详情或没有勾选就不需要校验
      if (!Array.isArray(this.detailList) || this.detailList.length === 0) return true;
      if (!Array.isArray(this.selectedDetailPids) || this.selectedDetailPids.length === 0) return true;

      const invalidItems = this.detailList.filter(item => {
        if (!item || !item.contentDetailPid) return false;
        // 只校验“已勾选且包含占位符”的项
        if (!this.selectedDetailPids.includes(item.contentDetailPid)) return false;
        if (!item.detailContent || !this.hasDetailPlaceholders(item.detailContent)) return false;

        const values = this.detailInputValues[item.contentDetailPid];
        if (!Array.isArray(values) || values.length === 0) return true;
        // 只要有一个是空/全空格，就算不合法
        return values.some(v => v == null || String(v).trim() === '');
      });

      if (invalidItems.length > 0) {
        this.$message.error('请填写勾选详情项中的所有输入值');
        return false;
      }
      return true;
    },

    // 获取检验结果的颜色类
    getResultColorClass (row) {
      if (!row.result) {
        return 'result-none'; // 未选择
      }
      // 无此项：蓝色
      if (row.result === 'notApplicable') {
        return 'result-blue';
      }
      // 只要有附表就是黄色（无论合格/不合格）
      if (row.attachmentTable) {
        return 'result-yellow'; // 有附表：黄色
      }
      // 没有附表时根据结果显示
      if (row.result === 'unqualified') {
        return 'result-gray'; // 不合格：灰色
      }
      return 'result-green'; // 合格：绿色
    },

    // 获取综合检验结果的颜色类
    getAutoResultColorClass (autoResult) {
      if (!autoResult) {
        return 'result-none';
      }
      if (autoResult === 'unqualified') {
        return 'result-gray'; // 不合格：灰色
      }
      if (autoResult === 'notApplicable') {
        return 'result-blue'; // 无此项：蓝色
      }
      return 'result-green'; // 合格：绿色
    },

    // 获取结果显示文本
    getResultText (result) {
      // 调试：输出 result 的值
      if (result && result !== 'qualified' && result !== 'unqualified' && result !== 'notApplicable') {
        console.warn('异常的 result 值:', result, '类型:', typeof result);
      }
      if (!result) return '未选择';
      if (result === 'qualified') return '符合';
      if (result === 'notApplicable') return '无此项';
      return '不符合';
    },

    // 获取结果标题提示
    getResultTitle (row) {
      if (!row.result) return '点击选择检验结果';
      const resultText = this.getResultText(row.result);
      if (row.attachmentTable) {
        return `${resultText}（有附表）- 点击编辑`;
      }
      return `${resultText} - 点击编辑`;
    },

    // 判断是否为最小项（叶子节点）
    isLeafItem (row) {
      return !!row && (!Array.isArray(row.children) || row.children.length === 0);
    },
    pageOneTableCellStyle ({ row, columnIndex }) {
      const style = { textAlign: 'left' };
      if (columnIndex === 0 && this.isLeafItem(row) && !!row.hasOpenedResultDialog) {
        style.backgroundColor = '#aed5ff';
      }
      return style;
    },

    // 打开检验结果编辑弹窗
    openResultDialog (row) {
      if (row) {
        this.$set(row, 'hasOpenedResultDialog', true);
        this.setTreeNodeVisited(row.originalId || row.id);
      }
      this.currentEditRow = row;
      // 每次打开都先清理一次该检验项的“未勾选详情自定义占位数据”，避免历史残留影响后续判断
      this.removeUnqualifiedCustomDetailMarker(row && row.itemNumber);
      // 记录打开弹窗时的初始状态
      this.initialEditRowResult = row.result || null;
      // 使用临时变量承接用户切换，不直接改动原数据
      this.tempResult = row.result || null;
      console.log(this.currentEditRow);
      this.resultDialogVisible = true;
      // 初始化详情列表相关数据
      this.detailList = [];
      this.selectedDetailPids = [];
      this.detailInputValues = {};
      // 打开弹窗时调用接口获取详情列表（加载完成后会自动调用 restoreDetailData）
      this.loadDetailList();
    },

    // 加载详情列表
    async loadDetailList () {
      if (!this.currentEditRow || !this.currentEditRow.itemNumber) {
        return;
      }

      // 弹窗内优先使用临时结果，避免未保存时写回原数据
      const currentResult = this.tempResult != null ? this.tempResult : this.currentEditRow.result;

      // 转换result为checkResult (1=符合, 0=不符合, -1=无此项)
      let checkResult = 0;
      if (currentResult === 'qualified') {
        checkResult = 1;
      } else if (currentResult === 'notApplicable') {
        checkResult = -1;
      } else {
        checkResult = 0;
      }

      this.detailListLoading = true;
      try {
        const response = await queryDetailListByContentCode({
          configReportPid: this.recordData.configReportPid,
          configTestItemsContentCode: this.currentEditRow.itemNumber,
          checkResult: checkResult
        });

        if (response && response.additionalData && Array.isArray(response.additionalData)) {
          this.detailList = response.additionalData;
        } else {
          this.detailList = [];
        }

        // 加载完列表后，尝试从本地存储或反填数据中恢复
        this.restoreDetailData();
      } catch (error) {
        console.error('加载详情列表失败:', error);
        this.$message.error('加载详情列表失败');
        this.detailList = [];
      } finally {
        this.detailListLoading = false;
      }
    },

    // 监听检验结果变化
    handleResultChange (value) {
      // 当结果变化时，重新加载详情列表
      this.loadDetailList();
    },

    // 从本地存储或反填数据中恢复详情数据
    restoreDetailData () {
      if (!this.currentEditRow || !this.currentEditRow.itemNumber) {
        return;
      }

      // 弹窗内优先使用临时结果，避免未保存时写回原数据
      const currentResult = this.tempResult != null ? this.tempResult : this.currentEditRow.result;

      const originalId = this.currentEditRow.itemNumber;
      // 转换result为checkResult (1=符合, 0=不符合, -1=无此项)
      // 注意：result 为空时默认按“不符合(0)”处理，和 loadDetailList 保持一致
      let currentCheckResult = 0;
      if (currentResult === 'qualified') {
        currentCheckResult = 1;
      } else if (currentResult === 'notApplicable') {
        currentCheckResult = -1;
      } else {
        currentCheckResult = 0;
      }

      // 先从additionalDataList的datas中查找
      if (this.additionalDataList && this.additionalDataList.datas && Array.isArray(this.additionalDataList.datas)) {
        // 详情数据的 dataKey 可能是 itemNumber（旧逻辑）或 detailCode（如 A1.1.1.1.1-4，新逻辑）
        // 所以这里通过解析 dataValue，匹配 configTestItemsContentCode 来定位
        // 同一检验项在“符合/不符合/无此项”下会有不同详情数据，必须优先按 checkResult 精确匹配
        const findSavedData = (strictByCheckResult) => this.additionalDataList.datas.find(d => {
          if (!d || !d.dataValue) return false;
          try {
            const parsed = JSON.parse(d.dataValue);
            if (!(Array.isArray(parsed) && parsed.length > 0 && parsed[0].contentDetailPid)) return false;
            if (parsed[0].configTestItemsContentCode !== originalId) return false;
            if (!strictByCheckResult) return true;
            // 兼容老数据可能没有 checkResult 字段：没有就认为可匹配
            return parsed[0].checkResult == null || parsed[0].checkResult === currentCheckResult;
          } catch (e) {
            return false;
          }
        });
        const savedData = findSavedData(true) || findSavedData(false);
        if (savedData && savedData.dataValue) {
          try {
            const parsedData = JSON.parse(savedData.dataValue);
            if (Array.isArray(parsedData) && parsedData.length > 0) {
              // 记录之前保存的详情PID列表，用于判断新勾选的项
              this.$set(this.previousSelectedDetailPids, originalId, parsedData.map(item => item.contentDetailPid));
              // 记录打开弹窗时的初始详情PID列表（每次打开弹窗时都更新，用于判断取消勾选的项）
              // 注意：这里应该每次打开弹窗时都更新，而不是只在不存在时设置，以确保记录的是当前打开弹窗时的状态
              this.$set(this.initialSelectedDetailPids, originalId, parsedData.map(item => item.contentDetailPid));

              // 恢复选中状态
              const nextSelected = parsedData.map(item => item.contentDetailPid).filter(pid => pid);
              // 先清空再 nextTick 赋值，避免某些情况下（异步渲染/快速切换）勾选态不刷新
              this.selectedDetailPids = [];
              this.$nextTick(() => {
                this.selectedDetailPids = nextSelected;
              });

              // 恢复输入框的值 - 使用 $set 确保响应式更新
              parsedData.forEach(item => {
                if (item.detailContent && item.contentDetailPid) {
                  // 处理保存的格式：其他:333
                  if (item.detailContent.startsWith('其他:')) {
                    const inputValueRaw = item.detailContent.substring(3); // 去掉"其他:"前缀
                    const inputValue = this.normalizePlaceholderInnerValue(inputValueRaw);
                    // 使用 $set 确保 Vue 能检测到变化
                    this.$set(this.detailInputValues, item.contentDetailPid, [inputValue]);
                  } else if (item.detailContent.includes('${')) {
                    // 处理反填数据格式：...${333}...${444}...
                    const values = [];
                    const reg = /\$\{([^}]*)\}/g;
                    let m;
                    while ((m = reg.exec(item.detailContent)) !== null) {
                      const inner = m[1] != null ? m[1] : '';
                      values.push(this.normalizePlaceholderInnerValue(inner));
                    }
                    if (values.length > 0) {
                      this.$set(this.detailInputValues, item.contentDetailPid, values);
                    }
                  }
                }
              });
            }
          } catch (e) {
            console.error('解析保存的数据失败:', e);
          }
        } else {
          // 如果没有保存的数据，记录为空数组（打开弹窗时的初始状态）
          // 注意：每次打开弹窗时都更新，以确保记录的是当前打开弹窗时的状态
          this.$set(this.initialSelectedDetailPids, originalId, []);
        }
      } else {
        // 如果没有additionalDataList，记录为空数组（打开弹窗时的初始状态）
        // 注意：每次打开弹窗时都更新，以确保记录的是当前打开弹窗时的状态
        this.$set(this.initialSelectedDetailPids, originalId, []);
      }
    },

    // 打开附表查看弹窗
    openAttachmentDialog (tableId) {
      const hasCheckStations = Array.isArray(this.floorSettingData && this.floorSettingData.checkStations) &&
        this.floorSettingData.checkStations.length > 0;
      if (!hasCheckStations) {
        this.$message.warning('请先完成层站设置并选择检查层站后，再打开附表');
        return;
      }
      // 打开时记录快照，关闭不保存则回滚
      this.attachmentDialogBackup = this.getAttachmentTableSnapshot(tableId);
      this.currentAttachmentTable = tableId;
      this.attachmentDialogVisible = true;
    },

    getAttachmentTableSnapshot (tableId) {
      const tableNum = String(tableId || '').replace('table', '');
      const tableKey = `pageTwoTable${tableNum}`;
      const tableData = this[tableKey];
      return {
        tableId,
        tableKey,
        data: tableData ? JSON.parse(JSON.stringify(tableData)) : null
      };
    },

    // 关闭附表弹窗：不保存，恢复到打开时快照
    handleAttachmentDialogClose (done) {
      const backup = this.attachmentDialogBackup;
      if (backup && backup.tableId === this.currentAttachmentTable && backup.tableKey && backup.data !== null) {
        this[backup.tableKey] = JSON.parse(JSON.stringify(backup.data));
      }
      this.attachmentDialogBackup = null;
      this.attachmentDialogVisible = false;
      if (typeof done === 'function') {
        done();
      }
    },

    // 保存附表弹窗：保留当前填写值并关闭
    handleAttachmentDialogSave () {
      this.sanitizeAttachmentFloorResultData(this.currentAttachmentTable);
      this.attachmentDialogBackup = null;
      this.attachmentDialogVisible = false;
      this.$message.success('附表数据已保存');
    },

    // 新需求兼容：这 4 个附表不再使用 floor 字段，此方法仅兜底清理历史数据中的 floor
    sanitizeAttachmentFloorResultData (tableId) {
      // 仅处理这 4 个特殊附表
      if (!['table1', 'table2', 'table11', 'table14'].includes(tableId)) {
        return;
      }
      const tableNum = String(tableId || '').replace('table', '');
      const tableKey = `pageTwoTable${tableNum}`;
      const table = this[tableKey];
      if (!table || !Array.isArray(table.columns)) {
        return;
      }

      table.columns.forEach(col => {
        const colData = col && col.data;
        if (!colData || typeof colData !== 'object') return;

        Object.keys(colData).forEach(key => {
          const cell = colData[key];
          // 仅处理历史数据里仍存在 floor 的结构
          if (!cell || typeof cell !== 'object' || !Object.prototype.hasOwnProperty.call(cell, 'floor')) {
            return;
          }
          cell.floor = '';
        });
      });
    },

    // 关闭/取消检验结果弹窗：恢复未保存的修改
    onResultDialogClose (done) {
      // 恢复临时选择为打开时的初始值
      this.tempResult = this.initialEditRowResult;

      // 恢复勾选的详情（若存在初始记录）
      const originalId = this.currentEditRow && this.currentEditRow.itemNumber;
      if (originalId) {
        const initialPids = (this.initialSelectedDetailPids && this.initialSelectedDetailPids[originalId]) || [];
        this.selectedDetailPids = [...initialPids];
      } else {
        this.selectedDetailPids = [];
      }

      // 关闭弹窗
      this.resultDialogVisible = false;
      // 清空初始状态记录，避免下次误用
      this.initialEditRowResult = null;
      if (typeof done === 'function') {
        done();
      }
    },

    // 保存检验结果
    saveResult (result) {
      if (this.currentEditRow) {
        // 先校验勾选项中的输入框是否已全部填写
        if (!this.validateDetailInputs()) {
          return;
        }

        const originalId = this.currentEditRow.itemNumber;
        // 如果未显式传入，使用临时结果
        const finalResult = result != null ? result : (this.tempResult != null ? this.tempResult : this.currentEditRow.result);
        const hasSelectedDetails = Array.isArray(this.selectedDetailPids) && this.selectedDetailPids.length > 0;

        // 保存前校验详情勾选规则：
        // 1) 默认仅“不符合”必须勾选至少一条详情
        // 2) A1.3.12.1 的“符合/不符合”都必须勾选至少一条详情
        const isSpecialItem = originalId === 'A1.3.12.1';
        const needSelectedDetails = isSpecialItem
          ? (finalResult === 'qualified' || finalResult === 'unqualified')
          : finalResult === 'unqualified';
        if (needSelectedDetails && !hasSelectedDetails) {
          const message = isSpecialItem
            ? 'A1.3.12.1 在“符合/不符合”状态下必须勾选至少一条详情'
            : '不符合状态下必须勾选至少一条详情';
          this.$message.error(message);
          return;
        }

        // 每次点击“确定”先清理旧占位，随后按最新勾选状态决定是否重建
        this.removeUnqualifiedCustomDetailMarker(originalId);
        // “不符合且未勾选任何详情”不再写入 datas 占位，改为在 infoList 中补充一条自定义记录
        this.syncUnqualifiedCustomInfoList(originalId, finalResult);

        // 在切换状态前，先删除之前不同状态下的数据
        const previousResult = this.initialEditRowResult; // 使用打开弹窗时的初始状态

        // 如果状态发生了变化，需要删除之前状态下的数据
        if (previousResult && previousResult !== finalResult) {
          // [已停用] 备注改由后台计算，不再在状态切换时清空 equipmentInfo.remarks
          // // 针对 A1.3.12.1：三种状态（符合/不符合/无此项）之间切换时，备注可能包含初始化自带文本且很难精准匹配删除
          // // 这里直接清空备注，再按当前勾选重建，避免任何残留/重复
          // if (originalId === 'A1.3.12.1' && this.equipmentInfo) {
          //   this.equipmentInfo.remarks = '';
          // }
          this.removePreviousStateData(originalId, previousResult);
        }
        this.currentEditRow.result = finalResult;
        this.updateTreeDataResult(this.currentEditRow.id, finalResult);
        // 保存详情数据到本地存储
        this.saveDetailDataToLocal();
        // [已停用] 原「A1.3.12.1 ↔ 备注」联动：备注由后台计算，保存检验结果时不再改写 equipmentInfo.remarks
        // // 备注联动只针对编号为 "A1.3.12.1" 的检验项
        // if (originalId === 'A1.3.12.1') {
        //   // 非状态切换时（仅勾选变化），先清空该检验项在备注中的历史文本，再重建
        //   if (!(previousResult && previousResult !== finalResult)) {
        //     this.clearItemDetailTextsFromRemarks(originalId);
        //   }
        //   this.rebuildCurrentItemDetailTextsInRemarks(originalId, finalResult);
        // }
      }
      this.resultDialogVisible = false;
      // 清空初始状态记录
      this.initialEditRowResult = null;
      this.tempResult = null;
    },

    // 同步“不符合且未勾选详情”的 infoList 自定义记录
    syncUnqualifiedCustomInfoList (originalId, finalResult) {
      if (!originalId) return;
      if (!Array.isArray(this.unqualifiedCustomInfoList)) {
        this.unqualifiedCustomInfoList = [];
      }

      // 先清理该检验项的旧记录，再按当前状态决定是否新增
      this.unqualifiedCustomInfoList = this.unqualifiedCustomInfoList.filter(
        item => item && item.configTestItemsContentCode !== originalId
      );

      const hasSelectedDetails = Array.isArray(this.selectedDetailPids) && this.selectedDetailPids.length > 0;
      if (finalResult !== 'unqualified' || hasSelectedDetails) return;

      const queryLikePayload = [{
        configReportPid: this.recordData ? this.recordData.configReportPid : null,
        configTestItemsContentCode: originalId,
        checkResult: 0,
        detailContent: ' '
      }];

      this.unqualifiedCustomInfoList.push({
        testItemChildName: this.getTestItemChildName(originalId),
        configTestItemsContentCode: originalId,
        unqualifiedDetail: JSON.stringify(queryLikePayload)
      });
    },
    // 从后端 additionalData.infoList 恢复“空详情占位”记录
    // 只恢复：
    // - checkResult = 0
    // - detailContent 为空/空白
    // - 且没有 contentDetailPid（非真实详情）
    // “详见附表xxx”不在这里恢复，仍由 buildInfoList 根据 CheckFloorX 动态生成。
    restoreUnqualifiedCustomInfoList (additionalData) {
      this.unqualifiedCustomInfoList = [];
      if (!additionalData) return;

      const source = additionalData.infoList;
      if (!source) return;

      let list = [];
      if (Array.isArray(source)) {
        list = source;
      } else if (typeof source === 'string') {
        try {
          const parsed = JSON.parse(source);
          if (Array.isArray(parsed)) {
            list = parsed;
          }
        } catch (e) {
          list = [];
        }
      }
      if (!Array.isArray(list) || list.length === 0) return;

      const isBlankPlaceholder = (detail) => {
        if (!detail || Number(detail.checkResult) !== 0) return false;
        if (detail.contentDetailPid) return false;
        const text = detail.detailContent == null ? '' : String(detail.detailContent).trim();
        if (text.startsWith('详见附表')) return false;
        return text === '';
      };

      const picked = [];
      list.forEach(item => {
        if (!item || !item.configTestItemsContentCode || !item.unqualifiedDetail) return;
        try {
          const details = JSON.parse(item.unqualifiedDetail);
          if (!Array.isArray(details) || details.length === 0) return;
          const hasBlankPlaceholder = details.some(isBlankPlaceholder);
          if (!hasBlankPlaceholder) return;

          picked.push({
            testItemChildName: item.testItemChildName || this.getTestItemChildName(item.configTestItemsContentCode),
            configTestItemsContentCode: item.configTestItemsContentCode,
            unqualifiedDetail: JSON.stringify([{
              configReportPid: (this.recordData && this.recordData.configReportPid) || null,
              configTestItemsContentCode: item.configTestItemsContentCode,
              checkResult: 0,
              detailContent: ' '
            }])
          });
        } catch (e) {
          // ignore invalid unqualifiedDetail json
        }
      });

      if (picked.length === 0) return;
      const uniqueMap = new Map();
      picked.forEach(item => {
        uniqueMap.set(item.configTestItemsContentCode, item);
      });
      this.unqualifiedCustomInfoList = Array.from(uniqueMap.values());
    },

    // 删除“不符合且未勾选详情”场景下的自定义占位数据
    removeUnqualifiedCustomDetailMarker (originalId) {
      if (!originalId || !this.additionalDataList || !Array.isArray(this.additionalDataList.datas)) return;
      const markerKey = `__UNQUALIFIED_CUSTOM__${originalId}`;
      for (let i = this.additionalDataList.datas.length - 1; i >= 0; i--) {
        const d = this.additionalDataList.datas[i];
        if (d && d.dataKey === markerKey) {
          this.additionalDataList.datas.splice(i, 1);
        }
      }
    },

    // 保存详情数据到本地存储（存储在additionalDataList.datas中）
    saveDetailDataToLocal () {
      if (!this.currentEditRow || !this.currentEditRow.itemNumber) {
        return;
      }

      const originalId = this.currentEditRow.itemNumber;

      // 转换result为checkResult (1=符合, 0=不符合, -1=无此项)
      let currentCheckResult = 0;
      if (this.currentEditRow.result === 'qualified') {
        currentCheckResult = 1;
      } else if (this.currentEditRow.result === 'notApplicable') {
        currentCheckResult = -1;
      } else {
        currentCheckResult = 0;
      }

      // 构建要保存的数据
      const savedData = this.detailList
        .filter(item => this.selectedDetailPids.includes(item.contentDetailPid))
        .map(item => {
          const dataItem = { ...item };

          // 确保添加checkResult字段，用于区分不同状态下的数据
          dataItem.checkResult = currentCheckResult;

          // 处理包含占位符的内容：把输入框的值回填为 ${值}，以便下次打开能识别输入框及其值
          if (item.detailContent && this.hasDetailPlaceholders(item.detailContent)) {
            const values = Array.isArray(this.detailInputValues[item.contentDetailPid])
              ? this.detailInputValues[item.contentDetailPid]
              : [];
            let valueIndex = 0;
            dataItem.detailContent = item.detailContent.replace(/\$\{[^}]*\}/g, () => {
              const vRaw = values[valueIndex] != null ? values[valueIndex] : '';
              const v = this.normalizePlaceholderInnerValue(vRaw);
              valueIndex++;
              return `\$\{${v}\}`;
            });
          }

          return dataItem;
        });

      // 若本次保存已勾选了详情，则清理“不符合未勾选详情”的占位数据，避免同一检验项出现两份含义冲突的数据
      if (savedData.length > 0) {
        const markerKey = `__UNQUALIFIED_CUSTOM__${originalId}`;
        const markerIndex = this.additionalDataList && Array.isArray(this.additionalDataList.datas)
          ? this.additionalDataList.datas.findIndex(d => d && d.dataKey === markerKey)
          : -1;
        if (markerIndex >= 0) {
          this.additionalDataList.datas.splice(markerIndex, 1);
        }
      }

      // 确保additionalDataList存在
      if (!this.additionalDataList) {
        this.additionalDataList = {};
      }
      if (!this.additionalDataList.datas) {
        this.additionalDataList.datas = [];
      }

      // 详情数据提交时的 dataKey 应为 detailCode（比 itemNumber 小一级），避免覆盖子项结果
      // 但历史数据可能仍以 itemNumber 作为 dataKey；如果不做兼容，会出现“新保存一条、旧的还在”，
      // 下次打开弹窗 restoreDetailData 用 find() 可能命中旧数据（你遇到的 2026 不更新就是这种情况）。
      const detailDataKey = savedData && savedData.length > 0 && savedData[0].detailCode ? savedData[0].detailCode : originalId;

      // 找出“同一检验项 + 同一状态(checkResult)”的旧记录（无论 dataKey 是 itemNumber 还是 detailCode）
      const matchIndices = [];
      for (let i = 0; i < this.additionalDataList.datas.length; i++) {
        const d = this.additionalDataList.datas[i];
        if (!d || !d.dataValue) continue;
        try {
          const parsed = JSON.parse(d.dataValue);
          if (!(Array.isArray(parsed) && parsed.length > 0 && parsed[0] && parsed[0].contentDetailPid)) continue;
          if (parsed[0].configTestItemsContentCode !== originalId) continue;
          // 兼容老数据可能没有 checkResult：没有则认为可匹配当前状态
          const cr = (parsed[0].checkResult === undefined || parsed[0].checkResult === null) ? currentCheckResult : parsed[0].checkResult;
          if (cr === currentCheckResult) {
            matchIndices.push(i);
          }
        } catch (e) {
          // ignore
        }
      }

      // 默认优先覆盖第一条匹配记录，其它重复的删除，避免下次 restore 命中旧值
      const primaryIndex = matchIndices.length > 0 ? matchIndices[0] : -1;

      if (savedData.length > 0) {
        const dataItem = {
          dataKey: detailDataKey,
          dataValue: JSON.stringify(savedData)
        };

        if (primaryIndex >= 0) {
          // 覆盖旧记录（无论旧 dataKey 是什么）
          this.additionalDataList.datas[primaryIndex] = dataItem;
          // 删除其它重复记录（从后往前删避免索引错乱）
          for (let k = matchIndices.length - 1; k >= 1; k--) {
            this.additionalDataList.datas.splice(matchIndices[k], 1);
          }
        } else {
          // 没有旧记录才新增
          this.additionalDataList.datas.push(dataItem);
        }

        // 注意：这里不更新 initialSelectedDetailPids，因为它应该保持页面加载时的初始状态
        // initialSelectedDetailPids 只在页面加载时初始化一次，用于判断新勾选的项
      } else if (primaryIndex >= 0) {
        // 如果没有选中任何数据，删除当前状态下已保存的数据（包括重复的）
        for (let k = matchIndices.length - 1; k >= 0; k--) {
          this.additionalDataList.datas.splice(matchIndices[k], 1);
        }
        // 注意：不更新 initialSelectedDetailPids，保持初始状态
      }
    },

    // 删除之前状态下的数据（当状态从"不符合"切换到"符合"等情况时）
    removePreviousStateData (originalId, previousResult) {
      if (!this.additionalDataList || !this.additionalDataList.datas || !Array.isArray(this.additionalDataList.datas)) {
        return;
      }

      // 转换previousResult为checkResult (1=符合, 0=不符合, -1=无此项)
      let previousCheckResult = 0;
      if (previousResult === 'qualified') {
        previousCheckResult = 1;
      } else if (previousResult === 'notApplicable') {
        previousCheckResult = -1;
      } else {
        previousCheckResult = 0;
      }

      // 查找之前状态下保存的数据（可能有多个，需要全部删除）
      const indicesToRemove = [];
      const textsToRemove = [];

      // 从后往前遍历，避免删除时索引变化的问题
      for (let i = this.additionalDataList.datas.length - 1; i >= 0; i--) {
        const d = this.additionalDataList.datas[i];
        if (!d || !d.dataValue) continue;

        try {
          const parsed = JSON.parse(d.dataValue);
          if (!(Array.isArray(parsed) && parsed.length > 0 && parsed[0].contentDetailPid)) continue;
          if (parsed[0].configTestItemsContentCode !== originalId) continue;
          // 匹配之前的状态
          const matchesPreviousState = parsed[0].checkResult == null || parsed[0].checkResult === previousCheckResult;

          if (matchesPreviousState) {
            indicesToRemove.push(i);

            // 收集要删除的文本
            parsed.forEach(detail => {
              if (detail && detail.detailContent) {
                const formattedText = this.formatDetailContent(detail);
                if (formattedText) {
                  textsToRemove.push(formattedText);
                }
              }
            });
          }
        } catch (e) {
          console.error('解析数据失败:', e);
        }
      }

      // [已停用] 原逻辑：从备注中删除与上一状态详情对应的文本（备注改由后台维护）
      // // 从备注中删除这些文本
      // if (textsToRemove.length > 0) {
      //   // 使用子串删除，避免因为是否换行/是否同一行导致删除失败
      //   this.removeTextsFromRemarks(textsToRemove);
      //   console.log('已从备注中删除之前状态下的数据文本:', textsToRemove);
      // }

      // 从additionalDataList.datas中删除之前状态下的数据（从后往前删除，避免索引变化）
      indicesToRemove.forEach(index => {
        this.additionalDataList.datas.splice(index, 1);
      });

      if (indicesToRemove.length > 0) {
        console.log(`已删除之前状态下的数据，共${indicesToRemove.length}条`);
      }
    },

    // 清空指定检验项在备注中的所有关联文本（不影响其它检验项的备注）
    clearItemDetailTextsFromRemarks (configTestItemsContentCode) {
      // 仅“曳引式客梯”才进行备注联动，其它设备不处理
      if (this.recordInfo.equipmentName !== '曳引式客梯') {
        return;
      }

      // 目前只对检验项 "A1.3.12.1" 生效
      if (configTestItemsContentCode !== 'A1.3.12.1') {
        return;
      }

      if (!this.additionalDataList || !this.additionalDataList.datas || !Array.isArray(this.additionalDataList.datas)) {
        return;
      }

      const textsToRemove = [];

      // 遍历所有已保存的详情数据，收集属于该检验项的文本
      for (const detailDataItem of this.additionalDataList.datas) {
        if (!detailDataItem || !detailDataItem.dataValue) continue;

        try {
          const parsed = JSON.parse(detailDataItem.dataValue);
          if (!(Array.isArray(parsed) && parsed.length > 0 && parsed[0].contentDetailPid)) continue;

          if (parsed[0].configTestItemsContentCode === configTestItemsContentCode) {
            parsed.forEach(detail => {
              if (detail && detail.detailContent) {
                const formattedText = this.formatDetailContent(detail);
                if (formattedText) {
                  textsToRemove.push(formattedText);
                }
              }
            });
          }
        } catch (e) {
          console.error('解析详情数据失败:', e);
        }
      }

      if (textsToRemove.length > 0) {
        this.removeTextsFromRemarks(textsToRemove);
        console.log(`已清空检验项 ${configTestItemsContentCode} 在备注中的历史文本:`, textsToRemove);
      }

      // 兜底：有些场景备注文本不是由 additionalDataList 生成（例如进入页面已有备注，或占位符值不同），
      // 这里按“模板”再删除一遍，确保切换符合/不符合时不会残留旧文本
      this.removeItemDetailTemplatesFromRemarks(configTestItemsContentCode);
    },

    // 按详情模板删除备注中的文本（占位符用通配符匹配），用于兜底清理
    removeItemDetailTemplatesFromRemarks (configTestItemsContentCode) {
      // 仅“曳引式客梯”才进行备注联动，其它设备不处理
      if (this.recordInfo.equipmentName !== '曳引式客梯') {
        return;
      }
      if (configTestItemsContentCode !== 'A1.3.12.1') {
        return;
      }
      if (!this.equipmentInfo || !this.equipmentInfo.remarks) {
        return;
      }
      if (!Array.isArray(this.detailList) || this.detailList.length === 0) {
        return;
      }

      const regexSources = [];
      for (const d of this.detailList) {
        if (!d || !d.detailContent) continue;
        const tpl = String(d.detailContent);
        // 1) 删除完整模板（带前缀，例如：下次试验年度：${var1}(当前试验日期：${var2})）
        regexSources.push(this.buildDetailTemplateRegexSource(tpl));
        // 2) 删除“模板尾巴”（去掉第一个占位符前的静态前缀），兜底处理残留片段
        //    例如备注里只残留：2028(当前试验日期：2026-03-11)
        const tailTpl = this.getDetailTemplateTail(tpl);
        if (tailTpl && tailTpl !== tpl) {
          regexSources.push(this.buildDetailTemplateRegexSource(tailTpl));
        }
      }

      this.removeRegexesFromRemarks(regexSources);
    },

    // 获取模板“尾巴”：去掉第一个占位符之前的静态前缀（含占位符本身之前的文字）
    // 例如：'下次试验年度：${var1}(当前试验日期：${var2})' -> '${var1}(当前试验日期：${var2})'
    getDetailTemplateTail (rawTemplate) {
      const raw = String(rawTemplate || '');
      const idx = raw.search(/\$\{[^}]*\}/);
      if (idx < 0) return '';
      return raw.slice(idx);
    },

    // 把带 ${} 占位符的详情文本构造成可匹配“任意填写值”的正则 source（不带 flags）
    buildDetailTemplateRegexSource (rawTemplate) {
      const raw = String(rawTemplate || '');
      const placeholderReg = /\$\{[^}]*\}/g;
      let lastIndex = 0;
      let src = '';

      let m;
      while ((m = placeholderReg.exec(raw)) != null) {
        const before = raw.slice(lastIndex, m.index);
        src += this.escapeRegExp(before);
        // 占位符内容：匹配任意非换行字符（尽量少吃），避免跨段落
        src += '[^\\n]*?';
        lastIndex = m.index + m[0].length;
      }
      src += this.escapeRegExp(raw.slice(lastIndex));

      return src;
    },

    // 按正则模板从备注中删除文本（含常见分隔符/项目符号兜底），并做清理
    removeRegexesFromRemarks (regexSources) {
      if (!regexSources || regexSources.length === 0 || !this.equipmentInfo || !this.equipmentInfo.remarks) {
        return;
      }

      let remarksText = String(this.equipmentInfo.remarks);

      for (const srcRaw of regexSources) {
        const src = (srcRaw || '').trim();
        if (!src) continue;

        const regs = [
          // 项目符号开头（你现有备注常见：●xxx）
          new RegExp(`●\\s*${src}`, 'g'),
          // 分隔符前后
          new RegExp(`[，、,;；]\\s*${src}`, 'g'),
          new RegExp(`${src}\\s*[，、,;；]`, 'g'),
          // 直接命中
          new RegExp(src, 'g')
        ];

        regs.forEach(reg => {
          remarksText = remarksText.replace(reg, '');
        });
      }

      // 复用同样的清理规则
      this.equipmentInfo.remarks = remarksText;
      // 触发一次清理：用 removeTextsFromRemarks 的“空输入不变”机制不行，所以这里传一个不会命中的空白占位
      // 通过执行其清理逻辑来统一格式
      this.removeTextsFromRemarks(['']);
    },

    // 根据当前勾选的详情，整体重建指定检验项在备注中的文本
    rebuildCurrentItemDetailTextsInRemarks (configTestItemsContentCode, result) {
      // 仅“曳引式客梯”才进行备注联动，其它设备不处理
      if (this.recordInfo.equipmentName !== '曳引式客梯') {
        console.log(`设备 ${this.recordInfo.equipmentName}: 不参与备注重建（仅 曳引式客梯 生效）`);
        return;
      }

      // 现在只允许 "A1.3.12.1" 影响备注，其它检验项直接返回
      if (configTestItemsContentCode !== 'A1.3.12.1') {
        console.log(`检验项 ${configTestItemsContentCode}: 不参与备注重建（仅 A1.3.12.1 生效）`);
        return;
      }

      // 仅在三种有效状态下处理（符合/不符合/无此项）
      if (!['qualified', 'unqualified', 'notApplicable'].includes(result)) {
        console.log(`检验项 ${configTestItemsContentCode}: 状态 ${result} 不参与备注重建`);
        return;
      }

      // 依赖当前弹窗中的详情列表与勾选状态
      if (!Array.isArray(this.detailList) || !Array.isArray(this.selectedDetailPids) || this.detailList.length === 0) {
        console.log(`检验项 ${configTestItemsContentCode}: 当前没有可用的详情数据用于重建备注`);
        return;
      }

      // 找出当前勾选的详情
      const selectedDetails = this.detailList.filter(item =>
        item && item.contentDetailPid && this.selectedDetailPids.includes(item.contentDetailPid)
      );

      if (selectedDetails.length === 0) {
        console.log(`检验项 ${configTestItemsContentCode}: 当前未勾选任何详情，备注中将只保留其它检验项的内容`);
        return;
      }

      const detailTexts = [];

      selectedDetails.forEach(detail => {
        if (!detail || !detail.detailContent) return;

        let detailContent = detail.detailContent;

        // 处理包含占位符的内容：把输入框的值回填为 ${值}
        if (this.hasDetailPlaceholders(detailContent)) {
          const values = Array.isArray(this.detailInputValues[detail.contentDetailPid])
            ? this.detailInputValues[detail.contentDetailPid]
            : [];
          let valueIndex = 0;
          detailContent = detailContent.replace(/\$\{[^}]*\}/g, () => {
            const vRaw = values[valueIndex] != null ? values[valueIndex] : '';
            const v = this.normalizePlaceholderInnerValue(vRaw);
            valueIndex++;
            return `\$\{${v}\}`;
          });
        }

        const formattedText = this.formatDetailContent({
          ...detail,
          detailContent
        });

        if (formattedText) {
          detailTexts.push(formattedText);
        }
      });

      if (detailTexts.length === 0) {
        console.log(`检验项 ${configTestItemsContentCode}: 当前勾选的详情格式化后没有可用文本`);
        return;
      }

      // 备注文本拼接方式：
      // 如需每条详情单独换行，请使用下面这一行（当前为备用，默认注释掉）
      // const newText = detailTexts.join('\n');
      // 如需所有详情直接连成一段（不按每条数据换行），使用下面这一行（当前启用）
      const newText = detailTexts.join('');
      console.log(`检验项 ${configTestItemsContentCode}: 重建备注文本为:`, newText);

      // 已在 clearItemDetailTextsFromRemarks 中删除过该检验项的历史文本，这里只做追加
      if (this.equipmentInfo.remarks) {
        this.equipmentInfo.remarks = `${this.equipmentInfo.remarks}\n${newText}`;
      } else {
        this.equipmentInfo.remarks = newText;
      }
    },

    // 实时更新备注：将当前检验项新勾选的详情添加到备注中
    // 备注联动仅对检验项 "A1.3.12.1" 生效
    appendCurrentItemDetailTextsToRemarks (configTestItemsContentCode, result) {
      // 仅“曳引式客梯”才进行备注联动，其它设备（如货梯）不追加
      if (this.recordInfo.equipmentName !== '曳引式客梯') {
        console.log(`设备 ${this.recordInfo.equipmentName}: 不参与备注联动追加（仅 曳引式客梯 生效）`)
        return
      }

      // 现在只允许 "A1.3.12.1" 影响备注，其它检验项直接返回
      if (configTestItemsContentCode !== 'A1.3.12.1') {
        console.log(`检验项 ${configTestItemsContentCode}: 不再参与备注联动（仅 A1.3.12.1 生效）`);
        return;
      }

      // 仅在三种有效状态下处理（符合/不符合/无此项）
      if (!['qualified', 'unqualified', 'notApplicable'].includes(result)) {
        console.log(`检验项 ${configTestItemsContentCode}: 状态 ${result} 不参与备注联动`);
        return;
      }

      // 从additionalDataList.datas中查找当前检验项的详情数据
      if (!this.additionalDataList || !this.additionalDataList.datas || !Array.isArray(this.additionalDataList.datas)) {
        return;
      }

      // 查找当前检验项的详情数据
      // 可能通过 dataKey（可能是 detailCode 或 originalId）或 configTestItemsContentCode 来匹配
      let currentItemDetailData = null;
      for (const detailDataItem of this.additionalDataList.datas) {
        if (!detailDataItem || !detailDataItem.dataValue) continue;

        // 先检查 dataKey 是否匹配（可能是 detailCode 或 originalId）
        if (detailDataItem.dataKey === configTestItemsContentCode) {
          try {
            const parsed = JSON.parse(detailDataItem.dataValue);
            if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].contentDetailPid) {
              currentItemDetailData = parsed;
              break;
            }
          } catch (e) {
            console.error('解析详情数据失败:', e);
          }
        } else {
          // 如果 dataKey 不匹配，再检查 configTestItemsContentCode
          try {
            const parsed = JSON.parse(detailDataItem.dataValue);
            if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].contentDetailPid) {
              if (parsed[0].configTestItemsContentCode === configTestItemsContentCode) {
                currentItemDetailData = parsed;
                break;
              }
            }
          } catch (e) {
            console.error('解析详情数据失败:', e);
          }
        }
      }

      if (!currentItemDetailData || currentItemDetailData.length === 0) {
        console.log(`检验项 ${configTestItemsContentCode}: 没有选中的详情数据`);
        return;
      }

      // 获取页面加载时的初始详情PID列表（用于判断哪些是新勾选的）
      const initialPids = this.initialSelectedDetailPids[configTestItemsContentCode] || [];

      console.log(`检验项 ${configTestItemsContentCode} (${result}): 页面加载时的初始详情PID:`, initialPids);
      console.log(`检验项 ${configTestItemsContentCode}: 当前选中的详情数量:`, currentItemDetailData.length);

      const detailTexts = [];

      // 遍历所有选中的详情项，只处理新勾选的项（不在页面加载时的初始列表中）
      currentItemDetailData.forEach(detail => {
        if (detail && detail.contentDetailPid && detail.detailContent) {
          // 判断是否是新勾选的（不在页面加载时的初始列表中）
          const isNewlySelected = !initialPids.includes(detail.contentDetailPid);

          console.log(`详情 ${detail.contentDetailPid}: 是否新勾选=${isNewlySelected}, 初始PID列表包含=${initialPids.includes(detail.contentDetailPid)}`);

          if (isNewlySelected) {
            const formattedText = this.formatDetailContent(detail);
            console.log(`新勾选的详情: ${detail.contentDetailPid}, 原始内容: ${detail.detailContent}, 格式化后的文本:`, formattedText);
            if (formattedText) {
              // 构建要添加的文本：只添加"问题描述"，不加检验项编号前缀
              const textToAdd = `${formattedText}`;

              // 检查备注中是否已经包含该文本，避免重复添加
              const remarksText = this.equipmentInfo.remarks || '';
              const isAlreadyInRemarks = remarksText.includes(textToAdd);

              console.log(`文本 "${textToAdd}" 是否已在备注中: ${isAlreadyInRemarks}`);

              if (!isAlreadyInRemarks) {
                // 添加详情文本（不含编号前缀）
                detailTexts.push(textToAdd);
              } else {
                console.log(`跳过重复的详情文本: ${textToAdd}`);
              }
            }
          }
        }
      });

      console.log('收集到的详情文本数量:', detailTexts.length);
      console.log('收集到的详情文本:', detailTexts);

      // 如果有新的详情文本，添加到备注中
      if (detailTexts.length > 0) {
        const newText = detailTexts.join('\n');
        console.log('准备添加到备注的文本:', newText);
        console.log('当前备注内容:', this.equipmentInfo.remarks);

        if (this.equipmentInfo.remarks) {
          // 如果备注已有内容，追加新内容
          this.equipmentInfo.remarks = this.equipmentInfo.remarks + '\n' + newText;
        } else {
          // 如果备注为空，直接设置
          this.equipmentInfo.remarks = newText;
        }

        console.log('更新后的备注内容:', this.equipmentInfo.remarks);
      } else {
        console.log('没有新的详情文本需要添加到备注');
      }
    },

    // 处理被取消勾选的详情：从备注中删除对应的文本
    // 备注联动仅对检验项 "A1.3.12.1" 生效
    removeUnselectedDetailTextsFromRemarks (configTestItemsContentCode, result) {
      // 仅“曳引式客梯”才进行备注联动，其它设备不做自动删除
      if (this.recordInfo.equipmentName !== '曳引式客梯') {
        console.log(`设备 ${this.recordInfo.equipmentName}: 不参与备注联动删除（仅 曳引式客梯 生效）`)
        return
      }

      // 现在只允许 "A1.3.12.1" 影响备注，其它检验项直接返回
      if (configTestItemsContentCode !== 'A1.3.12.1') {
        console.log(`检验项 ${configTestItemsContentCode}: 不再参与备注联动删除（仅 A1.3.12.1 生效）`);
        return;
      }

      // 仅在三种有效状态下处理（符合/不符合/无此项）
      if (!['qualified', 'unqualified', 'notApplicable'].includes(result)) {
        console.log(`检验项 ${configTestItemsContentCode}: 状态 ${result} 不参与备注联动删除`);
        return;
      }

      // 获取初始选中的详情PID列表（打开弹窗时的状态）
      const initialPids = this.initialSelectedDetailPids[configTestItemsContentCode] || [];
      // 获取当前选中的详情PID列表
      const currentPids = this.selectedDetailPids || [];

      // 找出被取消勾选的详情PID（在初始列表中但不在当前列表中）
      const unselectedPids = initialPids.filter(pid => !currentPids.includes(pid));

      if (unselectedPids.length === 0) {
        console.log(`检验项 ${configTestItemsContentCode}: 没有取消勾选的详情`);
        return;
      }

      console.log(`检验项 ${configTestItemsContentCode}: 被取消勾选的详情PID:`, unselectedPids);

      // 优先从保存的数据中获取被取消勾选的详情（包含完整的输入框值）
      let unselectedDetails = [];

      // 从additionalDataList.datas中查找当前检验项的详情数据
      if (this.additionalDataList && this.additionalDataList.datas && Array.isArray(this.additionalDataList.datas)) {
        for (const detailDataItem of this.additionalDataList.datas) {
          if (!detailDataItem || !detailDataItem.dataValue) continue;

          // 检查 dataKey 是否匹配
          if (detailDataItem.dataKey === configTestItemsContentCode) {
            try {
              const parsed = JSON.parse(detailDataItem.dataValue);
              if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].contentDetailPid) {
                // 找出被取消勾选的详情（在保存的数据中但不在当前选中列表中）
                const savedUnselected = parsed.filter(item =>
                  item && item.contentDetailPid && unselectedPids.includes(item.contentDetailPid)
                );
                unselectedDetails = savedUnselected;
                break;
              }
            } catch (e) {
              console.error('解析详情数据失败:', e);
            }
          } else {
            // 如果 dataKey 不匹配，再检查 configTestItemsContentCode
            try {
              const parsed = JSON.parse(detailDataItem.dataValue);
              if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].contentDetailPid) {
                if (parsed[0].configTestItemsContentCode === configTestItemsContentCode) {
                  // 找出被取消勾选的详情（在保存的数据中但不在当前选中列表中）
                  const savedUnselected = parsed.filter(item =>
                    item && item.contentDetailPid && unselectedPids.includes(item.contentDetailPid)
                  );
                  unselectedDetails = savedUnselected;
                  break;
                }
              }
            } catch (e) {
              console.error('解析详情数据失败:', e);
            }
          }
        }
      }

      // 如果从保存的数据中没找到，则从detailList中查找（这种情况应该很少见）
      if (unselectedDetails.length === 0) {
        unselectedDetails = this.detailList.filter(item =>
          item && item.contentDetailPid && unselectedPids.includes(item.contentDetailPid)
        );
      }

      if (unselectedDetails.length === 0) {
        console.log(`检验项 ${configTestItemsContentCode}: 未找到被取消勾选的详情`);
        return;
      }

      // 收集要删除的文本
      const textsToRemove = [];

      unselectedDetails.forEach(detail => {
        if (detail && detail.detailContent) {
          // 保存的数据中，如果包含占位符，已经是 ${值} 的格式，可以直接使用formatDetailContent
          // 如果是从detailList中获取的，需要处理占位符
          let detailContent = detail.detailContent;

          // 如果是从detailList中获取的且包含占位符，需要从detailInputValues中获取输入框的值
          if (this.hasDetailPlaceholders(detailContent)) {
            // 检查是否是 ${值} 格式（已保存的格式，例如 ${333}）
            // 如果占位符中不是变量名（不是字母开头的标识符），说明是已保存的格式
            const isSavedFormat = detailContent.match(/\$\{[^}]+\}/) &&
              !detailContent.match(/\$\{[a-zA-Z_][a-zA-Z0-9_]*\}/);

            if (!isSavedFormat) {
              // 如果不是已保存的格式（例如 ${var1}），需要从detailInputValues中获取值
              const values = Array.isArray(this.detailInputValues[detail.contentDetailPid])
                ? this.detailInputValues[detail.contentDetailPid]
                : [];
              let valueIndex = 0;
              // 将占位符替换为 ${值} 的格式
              detailContent = detailContent.replace(/\$\{[^}]*\}/g, () => {
                const vRaw = values[valueIndex] != null ? values[valueIndex] : '';
                const v = this.normalizePlaceholderInnerValue(vRaw);
                valueIndex++;
                return `\$\{${v}\}`;
              });
            }
          }

          // 使用formatDetailContent格式化详情内容
          const formattedText = this.formatDetailContent({
            ...detail,
            detailContent: detailContent
          });

          if (formattedText) {
            textsToRemove.push(formattedText);
            console.log(`被取消勾选的详情: ${detail.contentDetailPid}, 格式化后的文本:`, formattedText);
          }
        }
      });

      // 从备注中删除这些文本（只删除命中的“子串”，不要整行删除；否则同一行里还有其它详情时会被误删）
      if (textsToRemove.length > 0) {
        this.removeTextsFromRemarks(textsToRemove);
        console.log('已从备注中删除被取消勾选的详情文本(子串删除):', textsToRemove);
      }
    },

    // 从备注中删除给定的一组文本（按子串删除，并做必要的标点与空行清理）
    removeTextsFromRemarks (textsToRemove) {
      if (!textsToRemove || textsToRemove.length === 0 || !this.equipmentInfo || !this.equipmentInfo.remarks) {
        return;
      }

      let remarksText = String(this.equipmentInfo.remarks);

      for (const rawText of textsToRemove) {
        const t = (rawText || '').trim();
        if (!t) continue;

        // 优先删除“分隔符 + 文本”，避免留下多余标点
        // 覆盖：中文逗号/顿号、英文逗号、全角分号/分号、空格等
        const patterns = [
          new RegExp(`[，、,;；]\\s*${this.escapeRegExp(t)}`, 'g'),
          new RegExp(`${this.escapeRegExp(t)}\\s*[，、,;；]`, 'g'),
          new RegExp(this.escapeRegExp(t), 'g')
        ];

        patterns.forEach(reg => {
          remarksText = remarksText.replace(reg, '');
        });
      }

      // 清理：多余空格/标点与换行
      remarksText = remarksText
        .replace(/[，、,;；]{2,}/g, '，')
        .replace(/^\s+|\s+$/g, '')
        .replace(/\n{3,}/g, '\n\n')
        .replace(/^\n+|\n+$/g, '')
        // 如果某一行被删空了，去掉空行（但保留单个空行作为段落分隔）
        .split('\n')
        .map(l => l.trim())
        .filter((l, idx, arr) => !(l === '' && (idx === 0 || idx === arr.length - 1)))
        .join('\n');

      // 如果只剩下一个孤立的项目符号，也清掉
      if (remarksText === '●' || remarksText === '•') {
        remarksText = '';
      }

      this.equipmentInfo.remarks = remarksText;
    },

    // 转义正则表达式特殊字符
    escapeRegExp (string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },

    // 获取附表标题
    getAttachmentTitle (tableId) {
      // 如果没有传参，使用当前的附表ID
      const id = tableId || this.currentAttachmentTable;
      const tableMapping = {
        table1: '附表 A1.2.7.1(1)：层门间隙检测不符合记录表',
        table2: '附表 A1.2.7.1(1)：层门间隙检测不符合记录表',
        table3: '附表 A1.2.7.2 玻璃门防拖曳措施检查记录表',
        table4: '附表 A1.2.7.4(1) 门的运行与导向检查记录表',
        table5: '附表 A1.2.7.4(2) 门的运行与导向检查记录表',
        table6: '附表 A1.2.7.4(3) 门的运行与导向检查记录表',
        table7: '附表 A1.2.7.5(1)自动关闭层门装置检查不符合记录表',
        table8: '附表 A1.2.7.5(2)自动关闭层门装置检查记录表',
        table9: '附表 A1.2.7.6(1)紧急开锁检查记录表',
        table10: '附表 A1.2.7.7(1) 门的锁紧与闭合检查不符合记录表',
        table11: '附表 A1.2.7.7(2) 门锁啮合长度检测不符合记录表',
        table12: '附表 A1.2.7.7(3)层门锁紧状态的电气安全装置检查不符合记录表',
        table13: '附表 A1.2.7.7(4) 验证层门闭合的电气安全装置检查不符合记录表',
        table14: '附表 A1.2.7.8 轿门门刀与层门地坎，层门锁滚轮与轿厢地坎的间隙检测不符合记录表',
        table15: '附表 A1.3.2 电梯平衡系数测试记录表',
        table16: '附表 A1.3.4(1) 限速器校验记录表（进行现场校验时填写）',
        table17: '附表 A1.3.14 噪声测试记录表'
      };
      return tableMapping[id] || '附表';
    },

    // 获取附表信息文本（用于显示在颜色块中）
    getAttachmentInfoText (tableId) {
      const tableMapping = {
        table1: '附表 A1.2.7.1(1)',
        table2: '附表 A1.2.7.1(1)',
        table3: '附表 A1.2.7.2',
        table4: '附表 A1.2.7.4(1)',
        table5: '附表 A1.2.7.4(2)',
        table6: '附表 A1.2.7.4(3)',
        table7: '附表 A1.2.7.5(1)',
        table8: '附表 A1.2.7.5(2)',
        table9: '附表 A1.2.7.6(1)',
        table10: '附表 A1.2.7.7(1)',
        table11: '附表 A1.2.7.7(2)',
        table12: '附表 A1.2.7.7(3)',
        table13: '附表 A1.2.7.7(4)',
        table14: '附表 A1.2.7.8',
        table15: '附表 A1.3.2',
        table16: '附表 A1.3.4(1)',
        table17: '附表 A1.3.14'
      };
      return tableMapping[tableId] || '附表';
    },

    // 获取检测人员列表
    async getDetectionPersonnelOptions () {
      try {
        const response = await queryEmployeeDropdown({ sginType: 'Test', configReportPid: this.recordData.configReportPid });
        console.log(response);
        if (response && response.additionalData) {
          this.detectionPersonnelOptions = response.additionalData.map(item => ({
            label: item.employeeName || item.label,
            value: item.employeePid || item.value
          }));
          this.reviewPersonnelOptions = response.additionalData.map(item => ({
            label: item.employeeName || item.label,
            value: item.employeePid || item.value
          }));
        }
      } catch (error) {
        console.error('获取检测人员列表失败:', error);
        this.$message.error('获取检测人员列表失败');
      }
    },

    // 获取校核人员列表
    // async getReviewPersonnelOptions () {
    //   try {
    //     const response = await queryEmployeeDropdown({ sginType: 'Check', configReportPid: this.recordData.configReportPid });
    //     console.log(response);
    //     if (response && response.additionalData) {
    //       this.reviewPersonnelOptions = response.additionalData.map(item => ({
    //         label: item.employeeName || item.label,
    //         value: item.employeePid || item.value
    //       }));
    //       this.detectionPersonnelOptions = response.additionalData.map(item => ({
    //         label: item.employeeName || item.label,
    //         value: item.employeePid || item.value
    //       }));
    //     }
    //   } catch (error) {
    //     console.error('获取校核人员列表失败:', error);
    //     this.$message.error('获取校核人员列表失败');
    //   }
    // },

    // 获取设备列表
    async getEquipmentOptions () {
      try {
        const response = await queryEqptList({
          currPage: 1,
          pageSize: 10000,
          configReportPid: this.recordData.configReportPid,
        });
        console.log('设备列表响应:', response);

        if (response && response.retCode === 'ok' && response.additionalData && response.additionalData.records) {
          this.equipmentOptions = response.additionalData.records.map((item, index) => ({
            label: item.eqptName || item.name, // 设备名称
            value: item.configReportPid || item.id || `equipment-${index}`, // 设备ID，确保唯一性
            managementNumber: item.eqptNum || item.managementNumber || '' // 管理编号
          }));
        }
      } catch (error) {
        console.error('获取设备列表失败:', error);
        this.$message.error('获取设备列表失败');
      }
    },

    // 自动加载工具箱及设备并回填
    async loadToolboxEqptInfos () {
      try {
        const response = await queryToolboxEqptInfos({ usageScenario: '直梯' });
        if (response && response.retCode === 'ok') {
          const toolboxData = (response && response.additionalData) ? response.additionalData : {};
          const deviceList = Array.isArray(toolboxData.eqptInfos) ? toolboxData.eqptInfos : [];
          this.selectedToolboxNum = toolboxData.toolboxName || '';

          if (deviceList.length === 0) {
            this.$message.warning('当前工具箱下没有绑定设备');
            return false;
          }

          // 先清空所有设备数据
          this.instrumentTableData.forEach(row => {
            row.name = '';
            row.managementNumber = '';
            row.usageRecord = '';
            row.name2 = '';
            row.managementNumber2 = '';
            row.usageRecord2 = '';
          });

          let successCount = 0;

          // 直接按输入框模型回填到两列（最多20个，1-10为左列，11-20为右列）
          for (let i = 0; i < Math.min(deviceList.length, 20); i++) {
            const device = deviceList[i] || {};
            const targetRow = i < 10 ? this.instrumentTableData[i] : this.instrumentTableData[i - 10];
            const targetNameField = i < 10 ? 'name' : 'name2';
            const targetManagementNumberField = i < 10 ? 'managementNumber' : 'managementNumber2';
            const usageColumn = i < 10 ? 'first' : 'second';
            const eqptNum = device.eqptNum || '';
            const eqptName = device.eqptName || '';

            // 若不存在对应选项，则为展示创建一个动态选项，保证输入框显示名称
            let equipmentOption = this.equipmentOptions.find(opt => opt.managementNumber === eqptNum);
            if (!equipmentOption && eqptNum) {
              const dynamicValue = `toolbox-${eqptNum}`;
              equipmentOption = {
                label: eqptName || eqptNum,
                value: dynamicValue,
                managementNumber: eqptNum
              };
              this.equipmentOptions.push(equipmentOption);
            }

            if (targetRow) {
              targetRow[targetNameField] = equipmentOption ? equipmentOption.value : '';
              targetRow[targetManagementNumberField] = eqptNum;
              this.autoFillUsageRecord(targetRow, usageColumn);
              successCount++;
            }
          }

          // 仅提示成功数量，不再提示“未找到设备”
          // this.$message.success(`已从工具箱反填 ${successCount} 个设备`);

          this.updateSelectedEquipments();
          return true;
        } else {
          this.$message.error(response.retMsg || '获取工具箱及设备信息失败');
          return false;
        }
      } catch (error) {
        console.error('获取工具箱及设备信息失败:', error);
        this.$message.error('获取工具箱及设备信息失败');
        return false;
      }
    },

    // 默认配置：统一走 queryToolboxEqptInfos（loadToolboxEqptInfos）覆盖仪器表
    async handleRestoreDefaultToolbox () {
      this.toolboxRestoreLoading = true;
      let pendingMsg = null;
      try {
        pendingMsg = this.$message({
          type: 'info',
          message: '正在从服务器恢复工具箱配置，请稍候…',
          duration: 0,
          showClose: true
        });
        const ok = await this.loadToolboxEqptInfos();
        if (ok) {
          this.$message.success('已恢复默认工具箱配置');
        }
      } finally {
        if (pendingMsg && typeof pendingMsg.close === 'function') {
          pendingMsg.close();
        }
        this.toolboxRestoreLoading = false;
      }
    },

    // 设备选择变化处理
    onEquipmentChange (row, fieldName, selectedValue) {
      console.log('设备选择变化:', row, fieldName, selectedValue);

      // 找到选中的设备信息
      const selectedEquipment = this.equipmentOptions.find(item => item.value === selectedValue);
      if (selectedEquipment) {
        // 自动填充管理编号
        if (fieldName === 'name') {
          row.managementNumber = selectedEquipment.managementNumber;
          // 自动填充使用记录
          this.autoFillUsageRecord(row, 'first');
          // 更新已选设备列表
          this.updateSelectedEquipments();
        } else if (fieldName === 'name2') {
          row.managementNumber2 = selectedEquipment.managementNumber;
          // 自动填充使用记录
          this.autoFillUsageRecord(row, 'second');
          // 更新已选设备列表
          this.updateSelectedEquipments();
        }
      }
    },

    // 自动填充使用记录
    autoFillUsageRecord (row, column) {
      if (!row) return;

      if (column === 'first') {
        // 第一列：如果name和managementNumber都有值，则自动填充usageRecord为'✓'
        if (row.name && row.managementNumber) {
          row.usageRecord = '✓';
        } else {
          // 如果任一字段为空，则清空usageRecord
          row.usageRecord = '';
        }
      } else if (column === 'second') {
        // 第二列：如果name2和managementNumber2都有值，则自动填充usageRecord2为'✓'
        if (row.name2 && row.managementNumber2) {
          row.usageRecord2 = '✓';
        } else {
          // 如果任一字段为空，则清空usageRecord2
          row.usageRecord2 = '';
        }
      }
    },

    // 更新已选设备ID列表
    updateSelectedEquipments () {
      this.selectedEquipmentIds = [];
      this.instrumentTableData.forEach(row => {
        if (row.name) {
          this.selectedEquipmentIds.push(row.name);
        }
        if (row.name2) {
          this.selectedEquipmentIds.push(row.name2);
        }
      });
      console.log('已选设备列表:', this.selectedEquipmentIds);
    },

    // 删除仪器设备（逻辑上是 20 条：01-20；UI 用 10 行拆成两列展示）
    // 点击左/右列删除时，仅删除对应的一条，再整体前移并补空，最后重排序号
    handleInstrumentDelete (row, side = 'left') {
      if (!row) return;
      const rowIndex = this.instrumentTableData.findIndex(r => r && r.id === row.id);
      if (rowIndex === -1) return;

      const flat = [];
      for (let i = 0; i < 10; i++) {
        const r = this.instrumentTableData[i] || {};
        flat.push({
          name: r.name || '',
          managementNumber: r.managementNumber || '',
          usageRecord: r.usageRecord || ''
        });
      }
      for (let i = 0; i < 10; i++) {
        const r = this.instrumentTableData[i] || {};
        flat.push({
          name: r.name2 || '',
          managementNumber: r.managementNumber2 || '',
          usageRecord: r.usageRecord2 || ''
        });
      }

      const deleteIndex = side === 'right' ? rowIndex + 10 : rowIndex;
      const isFilled = item => item && (item.name || item.managementNumber || item.usageRecord);
      const filledCount = flat.filter(isFilled).length;
      if (filledCount <= 1 && isFilled(flat[deleteIndex])) {
        this.$message.warning('当前仅剩最后一条仪器设备数据，不允许删除');
        return;
      }

      // 2) 仅删除当前点击侧对应的一条
      if (deleteIndex >= 0 && deleteIndex < flat.length) {
        flat.splice(deleteIndex, 1);
      }

      // 3) 过滤空条目并补齐到 20 条（保持提交时 EquipmentName01-20 下标稳定）
      const compact = flat.filter(item => item && (item.name || item.managementNumber || item.usageRecord));
      while (compact.length < 20) {
        compact.push({ name: '', managementNumber: '', usageRecord: '' });
      }

      // 4) 回写到 10 行两列展示结构（不改变 instrumentTableData 的行数和 row-key）
      for (let i = 0; i < 10; i++) {
        const targetRow = this.instrumentTableData[i];
        if (!targetRow) continue;

        const left = compact[i] || { name: '', managementNumber: '', usageRecord: '' };
        const right = compact[i + 10] || { name: '', managementNumber: '', usageRecord: '' };

        this.$set(targetRow, 'serialNumber', i + 1);
        this.$set(targetRow, 'name', left.name);
        this.$set(targetRow, 'managementNumber', left.managementNumber);
        this.$set(targetRow, 'usageRecord', left.usageRecord);

        this.$set(targetRow, 'serialNumber2', i + 11);
        this.$set(targetRow, 'name2', right.name);
        this.$set(targetRow, 'managementNumber2', right.managementNumber);
        this.$set(targetRow, 'usageRecord2', right.usageRecord);
      }

      // 5) 更新下拉选项过滤状态
      this.updateSelectedEquipments();

      // this.$message.success('删除成功');

      // this.$confirm('确定删除该行数据吗？', '提示', {
      //   type: 'warning',
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消'
      // })
      //   .then(() => {

      //   })
      //   .catch(() => { });
    },

    // 获取可用的设备选项（过滤已选择的设备）
    getAvailableEquipment (currentRow, fieldName) {
      return this.equipmentOptions.filter(item => {
        // 如果是当前行的当前字段，则不过滤（允许重新选择）
        const currentValue = currentRow[fieldName];
        if (currentValue === item.value) {
          return true;
        }

        // 过滤掉已经被其他行选择的设备
        return !this.selectedEquipmentIds.includes(item.value);
      });
    },

    // 根据设备ID获取设备名称
    getEquipmentNameById (equipmentId) {
      if (!equipmentId) return '';
      const equipment = this.equipmentOptions.find(item => item.value === equipmentId);
      return equipment ? equipment.label : equipmentId;
    },

    // 根据设备名称获取设备ID
    getEquipmentIdByName (equipmentName) {
      if (!equipmentName) return '';
      const equipment = this.equipmentOptions.find(item => item.label === equipmentName);
      return equipment ? equipment.value : equipmentName;
    },

    // 加载之前暂存的数据
    async loadSavedData (entrustNum, status, FIRST_YEAR) {
      try {
        const response = status === 9 ? await queryTestDataInfo(entrustNum, FIRST_YEAR) : await queryTestDataTest(entrustNum, FIRST_YEAR);
        console.log('获取到的暂存数据:', response);

        if (response && response.retCode === 'ok' && response.additionalData) {
          // 反填数据到对应的字段
          this.additionalDataList = response.additionalData
          // 初始化 previousSelectedDetailPids，记录所有已保存的详情PID
          this.initPreviousSelectedDetailPids()
          // 从后台返回的 datas 初始化“已勾选详情缓存”，用于弹窗反选/回填
          this.initDetailSelectedCacheFromDatas()
          this.fillFormData(response.additionalData);
        }
      } catch (error) {
        console.error('获取暂存数据失败:', error);
        // 不显示错误消息，因为可能是第一次创建，没有暂存数据
      }
    },

    // 将API返回的数据反填到表单中
    // options.skipToolbox: 参照场景为 true，不覆盖工具箱号与仪器设备表
    fillFormData (additionalData, options = {}) {
      if (!additionalData) return;
      const skipToolbox = !!(options && options.skipToolbox);

      console.log('开始反填数据:', additionalData);

      try {
        // 每次开始根据新的 additionalData 回填前，先重置第一页检验结果与详情相关缓存
        // 这样可以避免上一次打开页面时的“不符合”等状态残留
        this.resetPageOneResultsAndDetails();

        // resetPageOneResultsAndDetails 会清空 detailSelectedCache / previousSelectedDetailPids 等缓存，
        // 但本次回填又需要依赖 additionalData.datas（接口返回/暂存数据）来恢复这些缓存，
        // 否则会出现“接口明明有需要回填的数据，但弹窗详情不回填”的问题。
        // 这里用当前 additionalData（同 this.additionalDataList）立刻重新初始化一次，确保后续弹窗能反选/回填输入框。
        this.additionalDataList = additionalData;
        this.initPreviousSelectedDetailPids();
        this.initDetailSelectedCacheFromDatas();

        // 反填设备信息
        this.fillEquipmentInfo(additionalData);

        // 反填封面信息
        this.fillCoverInfo(additionalData);

        if (!skipToolbox) {
          // 反填工具箱号（从 datas 中读取）
          this.fillToolboxNum(additionalData);
          // 反填设备仪器数据
          this.fillInstrumentData(additionalData);
        }

        // 如果有其他数据格式（如原来的datas数组或对象），也进行处理
        let datasArray = [];
        if (additionalData.datas) {
          if (Array.isArray(additionalData.datas)) {
            datasArray = additionalData.datas;
          } else if (typeof additionalData.datas === 'object') {
            // 如果是对象格式（键为数字的对象），转换为数组
            datasArray = Object.values(additionalData.datas);
          }

          if (datasArray.length > 0) {
            // 后端返回了具体的检测项结果，按老规则进行回填
            // 说明之前保存过数据，直接按照 datas 里的值来，不需要特殊处理
            this.fillLegacyData(datasArray);
            // 反填详情数据
            this.fillDetailData(datasArray);
          }
          //else {
          // datas 字段存在但为空数组：表示该记录当前没有任何"不符合/无此项"等特殊项
          // 在这种情况下，需要根据设备类型判断 A1.3.12.1 的默认值
          // 已在 resetPageOneResultsAndDetails 中统一重置为"符合"，这里需要特殊处理 A1.3.12.1
          //console.log('additionalData.datas 为空数组，根据设备类型设置 A1.3.12.1 默认值');
          // this.setA13121DefaultValue();
          //}
        }
        //else {
        // 连 datas 字段都不存在，同样视为没有特殊检测结果
        // 需要根据设备类型判断 A1.3.12.1 的默认值
        // console.log('additionalData 中不存在 datas 字段，根据设备类型设置 A1.3.12.1 默认值');
        // this.setA13121DefaultValue();
        //}

        // 反填“infoList里的空详情占位”到本地缓存：
        // 场景：不符合且未勾选详情时，该记录只存在 infoList，不存在 datas。
        // 若不恢复，重新打开后不操作直接保存会丢失该类记录。
        this.restoreUnqualifiedCustomInfoList(additionalData);

        console.log('数据回填完成');
      } catch (error) {
        console.error('数据回填过程中发生错误:', error);
        this.$message.warning('部分数据回填失败，请检查数据格式');
      }
    },

    /**
     * 根据设备类型设置特定检测项目的默认值
     * 如果是'曳引式货梯'，将以下项目的默认值改为 'notApplicable'（无此项）：
     * - A1.3.12.1 (125%额定载重量制动试验)
     * - A1.3.14.1, A1.3.14.2, A1.3.14.3, A1.3.14.4 (噪声测试)
     * - A1.4.1.1, A1.4.1.2 (视频监控设施)
     * 如果是'曳引式客梯'，保持默认值 'qualified'（符合）
     */
    // setA13121DefaultValue () {
    //   if (this.recordInfo && this.recordInfo.equipmentName === '曳引式货梯') {
    //     // 需要设置为"无此项"的项目ID列表
    //     const itemsToSetNotApplicable = [
    //       'A1.3.12-1',    // A1.3.12.1 - 125%额定载重量制动试验
    //       'A1.3.14-1',    // A1.3.14.1 - 机房噪声
    //       'A1.3.14-2',    // A1.3.14.2 - 轿厢内噪声
    //       'A1.3.14-3',    // A1.3.14.3 - 开关门噪声
    //       'A1.3.14-4',    // A1.3.14.4 - 无机房电梯层门处噪声
    //       'A1.4.1-1',     // A1.4.1.1 - 视频监控设施设置情况
    //       'A1.4.1-2'      // A1.4.1.2 - 视频监控设施功能检查
    //     ];

    //     let updatedCount = 0;
    //     itemsToSetNotApplicable.forEach(itemId => {
    //       // 在 pageOneData 中查找对应项目
    //       const targetItem = this.pageOneData.find(item => item.id === itemId);
    //       if (targetItem) {
    //         targetItem.result = 'notApplicable';
    //         // 同时更新原始树形数据中的值
    //         this.updateTreeNodeResult(itemId, 'notApplicable');
    //         // 更新父级的自动检验结果
    //         this.updateParentAutoResult(targetItem);
    //         updatedCount++;
    //         console.log(`${targetItem.itemNumber} 已设置为"无此项"（曳引式货梯）`);
    //       }
    //     });

    //     if (updatedCount > 0) {
    //       console.log(`共 ${updatedCount} 个项目已设置为"无此项"（曳引式货梯）`);
    //     }
    //   } else {
    //     // 曳引式客梯保持默认的 'qualified'，无需修改
    //     console.log('所有检测项目保持默认"符合"（曳引式客梯）');
    //   }
    // },

    /**
     * 重置第一页“检测项目”模块的结果和详情相关缓存
     * 场景：
     *  - 第一次打开时，接口返回的 datas 里有“不符合”等信息，会把对应项目置为 unqualified
     *  - 关闭后再次打开，接口有可能返回 datas: []（或根本没有 datas 字段），此时所有项目应该恢复为“符合”
     *  - 为避免上一次的“不符合”状态残留，这里在每次 fillFormData 开始时统一重置一次
     */
    resetPageOneResultsAndDetails () {
      console.log('resetPageOneResultsAndDetails -> 重置第一页检验结果与详情缓存');

      // 1）重置第一页表格中所有 level 3 项目的 result 为 "qualified"
      if (Array.isArray(this.pageOneData) && this.pageOneData.length > 0) {
        const level3Items = this.pageOneData.filter(item => item.level === 3);
        level3Items.forEach(item => {
          // 只重置“曾经被回填/编辑过”的项：当 result 为空时才设置默认“符合”
          // 不能覆盖配置文件里预置的默认值（例如 A1.3.12.1 预置为 notApplicable）
          if (!item.result) {
            item.result = 'qualified';
            // 同步更新树形数据中的结果
            this.updateTreeNodeResult(item.id, 'qualified');
            // 级联更新父级综合检验结果
            this.updateParentAutoResult(item);
          }
        });
      }

      // 2）清空与详情选择/缓存相关的所有状态，防止旧详情影响本次打开
      this.detailList = [];
      this.selectedDetailPids = [];
      this.detailInputValues = {};
      this.detailSelectedCache = {};
      this.initialSelectedDetailPids = {};
      this.previousSelectedDetailPids = {};

      // 当前正在编辑的行状态也一并清空，避免弹窗残留
      this.currentEditRow = null;
      this.initialEditRowResult = null;
      this.tempResult = null;
    },

    // 反填设备信息
    fillEquipmentInfo (additionalData) {
      // 设备信息字段映射
      const equipmentMapping = {
        'USE_UNT_NAME': 'useUnitName', // 使用单位名称
        'EQP_INNER_COD': 'unitInternalNumber', // 单位内编号
        'EQP_VART_NAME': 'equipmentType', // 设备品种
        'EQP_AREA_NAME': 'installLocation', // 设备安装地点
        'EQP_MOD': 'productModel', // 产品型号
        'EQP_USECERT_COD': 'registrationNumber', // 使用登记证号
        'FACTORY_COD': 'productNumber', // 产品编号
        'MAKE_UNT_NAME': 'manufacturerName', // 制造单位名称
        'MAKE_DATE': 'manufactureDate', // 制造日期
        'renovation_unt_name': 'renovationUnitName', // 改造单位名称
        'renovation_date': 'renovationDate', // 改造日期
        'service_unt_name': 'maintenanceUnit', // 维护保养单位
        'SAFE_MEN': 'safetyManager', // 安管人员
        'RATEDLOAD': 'ratedLoad', // 额定载重量
        'CONTROL_TYPE': 'controlMethod', // 控制方式
        'EQP_USE_ADDR': 'eqpUseAddr', // 使用地址（与 EQP_AREA_NAME 安装地点区分）
        'EQP_NAME': 'equipmentName', // 设备名称
        'EQP_SORT_NAME': 'eqpSortName', // 设备类别（与封面一致，提交时优先 coverInfo）
        'OIDNO': 'oidNo', // 设备编号
        'EQP_TEMP_NAME': 'eqpTempName', // 设备型式
        'USE_UNT_COD': 'USE_UNT_COD', // 统一信用代码
        'standardData': 'standardData', // 检测依据
        'RATEDVELOCITY': 'ratedSpeed', // 额定速度(m/s)
        'RUNVELOCITY': 'runVelocity', // 额定运行速度（与 RATEDVELOCITY 区分）
        'ELEHEIGHT': 'eleHeight', // 提升高度
        'SLIDWAY_USE_LENG': 'slidwayUseLeng', // 滑道使用长度等
        'FIRST_YEAR': 'firstYear', // 首检年份
        'powerSupply': 'powerSupply', // 电源
        'humidity': 'humidity', // 湿度
        'temperature': 'temperature', // 温度
      };

      // 遍历映射关系，将数据填入对应字段
      Object.keys(equipmentMapping).forEach(apiKey => {
        if (additionalData[apiKey] !== undefined) {
          const formKey = equipmentMapping[apiKey];
          let value = additionalData[apiKey];

          // 特殊处理日期格式
          if (formKey === 'manufactureDate' && value) {
            // manufactureDate 使用 YYYY-MM-DD 格式
            if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
              value = value;
            } else {
              // 尝试格式化日期
              const date = new Date(value);
              if (!isNaN(date.getTime())) {
                value = date.toISOString().split('T')[0];
              }
            }
          }

          // 特殊处理日期格式：改造日期 renovationDate 使用 YYYY-MM-DD 格式
          if (formKey === 'renovationDate' && value) {
            if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
              value = value;
            } else {
              const date = new Date(value);
              if (!isNaN(date.getTime())) {
                value = date.toISOString().split('T')[0];
              }
            }
          }

          // 展示字段保留接口原始小数格式，避免 parseFloat 丢失尾部 0
          if ((formKey === 'ratedLoad' || formKey === 'ratedSpeed' || formKey === 'runVelocity') && value !== '' && value !== null && value !== undefined) {
            value = String(value);
          }
          if ((formKey === 'eleHeight' || formKey === 'slidwayUseLeng') && value !== '' && value !== null && value !== undefined) {
            const n = typeof value === 'number' ? value : parseFloat(value);
            value = Number.isNaN(n) ? value : n;
          }

          this.equipmentInfo[formKey] = value;
          console.log(`设备信息回填: ${apiKey} -> ${formKey} = ${value}`);
        }
      });

      // 处理下次检测日期和下次检验日期
      // 仍按历史优先级取值，但不再拆分年月；且 '无' 也是有效值（直接使用，不再回退第二字段）
      const isValidNextDateValue = (v) => typeof v === 'string' && v !== '';

      if (isValidNextDateValue(additionalData.nextTestDate)) {
        this.equipmentInfo.nextTestDate = additionalData.nextTestDate;
        console.log('下次检测日期回填:', this.equipmentInfo.nextTestDate);
      } else if (isValidNextDateValue(additionalData.nextTestYearMonth)) {
        this.equipmentInfo.nextTestDate = additionalData.nextTestYearMonth;
        console.log('下次检测日期回填(YearMonth):', this.equipmentInfo.nextTestDate);
      }

      if (isValidNextDateValue(additionalData.nextCheckDate)) {
        this.equipmentInfo.nextCheckDate = additionalData.nextCheckDate;
        console.log('下次检验日期回填:', this.equipmentInfo.nextCheckDate);
      } else if (isValidNextDateValue(additionalData.nextRegularDate)) {
        this.equipmentInfo.nextCheckDate = additionalData.nextRegularDate;
        console.log('下次检验日期回填(RegularDate):', this.equipmentInfo.nextCheckDate);
      }

      // 特殊处理：层/站/门信息（支持 0；分项字段单独保存便于提交根字段）
      const eleF = additionalData.ELEFLOORNUMBER;
      const eleS = additionalData.ELESTADENUMBER;
      const eleD = additionalData.ELEDOORNUMBER;
      if (eleF !== undefined && eleF !== null && eleF !== '') {
        this.equipmentInfo.eleFloorNumber = eleF;
      }
      if (eleS !== undefined && eleS !== null && eleS !== '') {
        this.equipmentInfo.eleStadeNumber = eleS;
      }
      if (eleD !== undefined && eleD !== null && eleD !== '') {
        this.equipmentInfo.eleDoorNumber = eleD;
      }
      if (eleF != null || eleS != null || eleD != null) {
        const floorInfo = [];
        if (eleF != null && eleF !== '') floorInfo.push(`${eleF}`);
        if (eleS != null && eleS !== '') floorInfo.push(`${eleS}`);
        if (eleD != null && eleD !== '') floorInfo.push(`${eleD}`);
        if (floorInfo.length) {
          this.equipmentInfo.floorStationDoor = floorInfo.join('/');
        }
      }

      // 与历史逻辑一致：EQP_USE_ADDR 与 EQP_AREA_NAME 曾共用 installLocation，且后者在映射顺序上会被前者覆盖
      if (additionalData.EQP_USE_ADDR !== undefined && additionalData.EQP_USE_ADDR !== null && additionalData.EQP_USE_ADDR !== '') {
        this.equipmentInfo.installLocation = additionalData.EQP_USE_ADDR;
      } else if (!String(this.equipmentInfo.installLocation || '').trim() && this.equipmentInfo.eqpUseAddr) {
        this.equipmentInfo.installLocation = this.equipmentInfo.eqpUseAddr;
      }

      // 反填检测人员和校核人员
      if (additionalData.testEmployeePid) {
        this.equipmentInfo.detectionPersonnel = additionalData.testEmployeePid;
        console.log('检测人员回填:', additionalData.testEmployeePid);
      }

      // 校核人员：如果有值就用自己的，如果为空就用检测人员的值
      if (additionalData.checkEmployeePid) {
        this.equipmentInfo.reviewPersonnel = additionalData.checkEmployeePid;
        console.log('校核人员回填:', additionalData.checkEmployeePid);
      } else if (additionalData.testEmployeePid) {
        this.equipmentInfo.reviewPersonnel = additionalData.testEmployeePid;
        console.log('校核人员为空，使用检测人员填充:', additionalData.testEmployeePid);
      }

      // 反填检测问题汇总和备注
      if (additionalData.testConclusion) {
        this.equipmentInfo.problemSummary = additionalData.testConclusion.replace(/\\n/g, '\n');
        console.log('检测问题汇总回填:', additionalData.testConclusion);
      }
      if (additionalData.testConclusionDesc) {
        this.equipmentInfo.remarks = additionalData.testConclusionDesc.replace(/\\n/g, '\n');
        console.log('备注回填:', additionalData.testConclusionDesc);
      }

      // 反填检测日期
      if (additionalData.testEmployeeDate) {
        this.equipmentInfo.detectionDate = additionalData.testEmployeeDate;
        this.equipmentInfo.detectionDate = additionalData.testEmployeeDate;
        console.log('检测日期回填:', additionalData.testEmployeeDate);
      }
    },

    // 反填封面信息
    fillCoverInfo (additionalData) {
      // 封面信息字段映射
      const coverMapping = {
        'USE_UNT_NAME': 'useUnitName', // 使用单位
        'recordNum': 'recordNum', // 记录编号
        'testEmployeeDate': 'testDate', // 检测日期 - 从testEmployeeDate字段获取
        'EQP_VART_NAME': 'EQP_VART_NAME', // 原始记录名称
        'EQP_SORT_NAME': 'EQP_SORT_NAME', // 设备类别
      };

      // 遍历映射关系，将数据填入对应字段
      Object.keys(coverMapping).forEach(apiKey => {
        if (additionalData[apiKey] !== undefined) {
          const formKey = coverMapping[apiKey];
          let value = additionalData[apiKey];

          // 特殊处理日期格式
          if (formKey === 'testDate' && value) {
            // 确保日期格式正确，如果是 YYYY-MM-DD 格式则保持不变
            if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
              value = value;
            } else {
              // 尝试格式化日期
              const date = new Date(value);
              if (!isNaN(date.getTime())) {
                value = date.toISOString().split('T')[0];
              }
            }
          }

          this.coverInfo[formKey] = value;
          console.log(`封面信息回填: ${apiKey} -> ${formKey} = ${value}`);
          if (formKey === 'EQP_SORT_NAME') {
            this.equipmentInfo.eqpSortName = value;
          }
        }
      });

      // 设备代码可能来自多个字段
      if (additionalData.EQP_STATION_COD) {
        this.coverInfo.EQP_STATION_COD = additionalData.EQP_STATION_COD;
      }
    },

    // 反填设备仪器数据
    fillInstrumentData (additionalData) {
      // 首先尝试从datas数组中获取所有相关数据
      const equipmentDataFromDatas = {};
      if (additionalData.datas && Array.isArray(additionalData.datas)) {
        additionalData.datas.forEach(item => {
          if (item.dataKey && (item.dataKey.startsWith('EquipmentName') || item.dataKey.startsWith('MgmtNo') || item.dataKey.startsWith('V'))) {
            equipmentDataFromDatas[item.dataKey] = item.dataValue;
          }
        });
      }

      // 设备名称字段映射
      const equipmentNameMapping = [
        'EquipmentName01', 'EquipmentName02', 'EquipmentName03', 'EquipmentName04', 'EquipmentName05',
        'EquipmentName06', 'EquipmentName07', 'EquipmentName08', 'EquipmentName09', 'EquipmentName10',
        'EquipmentName11', 'EquipmentName12', 'EquipmentName13', 'EquipmentName14', 'EquipmentName15',
        'EquipmentName16', 'EquipmentName17', 'EquipmentName18', 'EquipmentName19', 'EquipmentName20'
      ];

      // 管理编号字段映射
      const managementNumberMapping = [
        'MgmtNo01', 'MgmtNo02', 'MgmtNo03', 'MgmtNo04', 'MgmtNo05',
        'MgmtNo06', 'MgmtNo07', 'MgmtNo08', 'MgmtNo09', 'MgmtNo10',
        'MgmtNo11', 'MgmtNo12', 'MgmtNo13', 'MgmtNo14', 'MgmtNo15',
        'MgmtNo16', 'MgmtNo17', 'MgmtNo18', 'MgmtNo19', 'MgmtNo20'
      ];

      // 使用记录字段映射
      const usageRecordMapping = [
        'V01', 'V02', 'V03', 'V04', 'V05',
        'V06', 'V07', 'V08', 'V09', 'V10',
        'V11', 'V12', 'V13', 'V14', 'V15',
        'V16', 'V17', 'V18', 'V19', 'V20'
      ];

      // 反填设备名称、管理编号和使用记录
      for (let i = 0; i < 10; i++) {
        // 第一列设备（name, managementNumber, usageRecord）
        const equipmentData1 = equipmentDataFromDatas[equipmentNameMapping[i]];
        const mgmtData1 = equipmentDataFromDatas[managementNumberMapping[i]];
        const usageData1 = equipmentDataFromDatas[usageRecordMapping[i]];

        if (equipmentData1) {
          // 如果dataValue是对象(旧格式),包含name、managementNumber、usageRecord
          if (typeof equipmentData1 === 'object' && equipmentData1.name) {
            this.instrumentTableData[i].name = this.getEquipmentIdByName(equipmentData1.name);
            this.instrumentTableData[i].managementNumber = equipmentData1.managementNumber || '';
            this.instrumentTableData[i].usageRecord = equipmentData1.usageRecord || '';
          }
          // 如果dataValue是字符串(新格式),只有设备名称
          else if (typeof equipmentData1 === 'string') {
            this.instrumentTableData[i].name = this.getEquipmentIdByName(equipmentData1);
            // 从对应的管理编号和使用记录字段获取数据
            this.instrumentTableData[i].managementNumber = mgmtData1 || additionalData[managementNumberMapping[i]] || '';
            this.instrumentTableData[i].usageRecord = usageData1 || '';
          }
        }
        // 如果datas中没有,尝试从外层获取(向后兼容)
        else if (additionalData[equipmentNameMapping[i]]) {
          this.instrumentTableData[i].name = this.getEquipmentIdByName(additionalData[equipmentNameMapping[i]]);
          this.instrumentTableData[i].managementNumber = additionalData[managementNumberMapping[i]] || '';
        }

        // 第二列设备（name2, managementNumber2, usageRecord2）
        const equipmentData2 = equipmentDataFromDatas[equipmentNameMapping[i + 10]];
        const mgmtData2 = equipmentDataFromDatas[managementNumberMapping[i + 10]];
        const usageData2 = equipmentDataFromDatas[usageRecordMapping[i + 10]];

        if (equipmentData2) {
          // 如果dataValue是对象(旧格式),包含name、managementNumber、usageRecord
          if (typeof equipmentData2 === 'object' && equipmentData2.name) {
            this.instrumentTableData[i].name2 = this.getEquipmentIdByName(equipmentData2.name);
            this.instrumentTableData[i].managementNumber2 = equipmentData2.managementNumber || '';
            this.instrumentTableData[i].usageRecord2 = equipmentData2.usageRecord || '';
          }
          // 如果dataValue是字符串(新格式),只有设备名称
          else if (typeof equipmentData2 === 'string') {
            this.instrumentTableData[i].name2 = this.getEquipmentIdByName(equipmentData2);
            // 从对应的管理编号和使用记录字段获取数据
            this.instrumentTableData[i].managementNumber2 = mgmtData2 || additionalData[managementNumberMapping[i + 10]] || '';
            this.instrumentTableData[i].usageRecord2 = usageData2 || '';
          }
        }
        // 如果datas中没有,尝试从外层获取(向后兼容)
        else if (additionalData[equipmentNameMapping[i + 10]]) {
          this.instrumentTableData[i].name2 = this.getEquipmentIdByName(additionalData[equipmentNameMapping[i + 10]]);
          this.instrumentTableData[i].managementNumber2 = additionalData[managementNumberMapping[i + 10]] || '';
        }
      }

      console.log('设备仪器数据回填完成');
    },

    // 处理原有格式的数据（兼容性）
    fillLegacyData (datas) {
      // 先收集所有在datas中出现的第一页项目编号
      const existingPageOneKeys = new Set();

      // 若设备为曳引式货梯/自动扶梯原始记录/自动人行道原始记录，A1.3.12.1 强制为无此项；曳引式客梯维持原逻辑
      const forceNotApplicableEquipmentNames = ['曳引式货梯', '自动扶梯原始记录', '自动人行道原始记录'];

      // 遍历返回的数据，根据dataKey反填到对应的字段
      datas.forEach(item => {
        const { dataKey, dataValue } = item;

        // 反填第一页检验结果数据
        if (this.isPageOneDataKey(dataKey)) {
          existingPageOneKeys.add(dataKey);
          const cleanDataKey = dataKey.startsWith('*') ? dataKey.substring(1) : dataKey;
          let valueToFill = dataValue;
          // if (cleanDataKey === 'A1.3.12.1' && forceNotApplicableEquipmentNames.includes(this.recordInfo?.equipmentName)) {
          //   valueToFill = '无此项';
          // }
          this.fillPageOneData(dataKey, valueToFill);
        }

        // 反填第二页表格数据
        if (this.isPageTwoDataKey(dataKey)) {
          this.fillPageTwoData(dataKey, dataValue);
        }

        // 反填其他字段（如人员、日期等）
        this.fillOtherFields(dataKey, dataValue);
      });

      // 为所有未在datas中出现的level 3项目设置默认的"符合"状态
      this.setDefaultResultsForMissingItems(existingPageOneKeys);
    },

    // 反填详情数据
    fillDetailData (datas) {
      if (!datas || !Array.isArray(datas)) {
        return;
      }

      // 遍历datas，查找所有详情数据（dataKey为itemNumber格式的）
      datas.forEach(item => {
        if (item.dataKey && item.dataValue) {
          // 检查dataKey是否是itemNumber格式（如 A1.2.5.6.2-4）
          // 这里我们假设dataKey可能是itemNumber本身，或者是itemNumber-数字的格式
          // 根据用户描述，dataKey应该是itemNumber（如 A1.2.5.6.2-4）

          try {
            const parsedData = JSON.parse(item.dataValue);
            if (Array.isArray(parsedData) && parsedData.length > 0) {
              // 找到对应的树节点
              const treeNode = this.findTreeNodeByItemNumber(item.dataKey);
              if (treeNode) {
                // 存储到additionalDataList中，以便后续恢复
                if (!this.additionalDataList) {
                  this.additionalDataList = {};
                }
                if (!this.additionalDataList.datas) {
                  this.additionalDataList.datas = [];
                }

                // 检查是否已存在
                const existingIndex = this.additionalDataList.datas.findIndex(d => d.dataKey === item.dataKey);
                if (existingIndex >= 0) {
                  this.additionalDataList.datas[existingIndex] = item;
                } else {
                  this.additionalDataList.datas.push(item);
                }
              }
            }
          } catch (e) {
            // 如果不是JSON格式，忽略
            console.log('dataKey:', item.dataKey, '不是JSON格式，跳过');
          }
        }
      });
    },

    // 根据itemNumber查找树节点
    findTreeNodeByItemNumber (itemNumber) {
      // 递归查找树节点
      const findInTree = (nodes) => {
        for (const node of nodes) {
          if (node.itemNumber === itemNumber) {
            return node;
          }
          if (node.children && node.children.length > 0) {
            const found = findInTree(node.children);
            if (found) return found;
          }
        }
        return null;
      };

      return findInTree(this.pageOneTreeData);
    },

    // 判断是否为第一页数据
    isPageOneDataKey (dataKey) {
      // 第一页的dataKey通常是检验项目编号，如 A1.1.1.1, A1.2.1.1 等
      // 关键检测项目以*开头，如 *A1.2.2.4
      return /^(\*)?A\d+\.\d+(\.\d+)*(\.\d+)?$/.test(dataKey);
    },

    // 判断是否为第二页数据
    isPageTwoDataKey (dataKey) {
      // 第二页的dataKey包括各种表格字段
      const pageTwoKeys = [
        'CheckFloor1', 'DF', 'DR', 'ZF', 'ZR', 'MF', 'MR', 'KF', 'KR',
        'WR', 'MDF', 'MDR', 'MZF', 'MZR', 'MMF', 'MMR', 'MKF', 'MKR', 'MWR',
        'WF', 'FZ', 'T', 'K', 'CW', 'WCM', 'WBC', 'WZX', 'NXY',
        'W', 'ZDSX', 'WFZZ', 'FZZl', 'WJJ', 'BNKQ', 'BCKS',
        'S', 'SJ', 'B', 'SJSX', 'C', 'SF', 'SR', 'D', 'Q',
        'WDQ', 'Y', 'JJXF', 'JJXR', 'CJXF', 'CJXR',
        'Upload', 'Download', 'Specification', 'JXDZ', 'DQDZ',
        'JFZS', 'NZS', 'KGZS', 'MZS', 'WZJZS', 'BJS', 'TestResult'
      ];
      return pageTwoKeys.some(key => dataKey.startsWith(key));
    },

    // 反填第一页数据
    fillPageOneData (dataKey, dataValue) {
      // 去掉关键检测项目的*前缀来查找对应项目
      const cleanDataKey = dataKey.startsWith('*') ? dataKey.substring(1) : dataKey;

      // 在pageOneData中查找对应的项目并设置result或autoResult
      const item = this.pageOneData.find(item => item.itemNumber === cleanDataKey);
      if (!item) {
        const treeNode = this.findTreeNodeByItemNumber(this.pageOneTreeData, cleanDataKey);
        if (treeNode && treeNode.level === 2 && treeNode.children) {
          if (dataValue === '符合') {
            treeNode.autoResult = 'qualified';
          } else if (dataValue === '无此项') {
            treeNode.autoResult = 'notApplicable';
          } else {
            treeNode.autoResult = 'unqualified';
          }
        }
        return;
      }

      let resultValue = '';
      if (item.level === 3) {
          // 子项设置检验结果
          // 根据dataValue设置对应状态：符合、不符合、无此项，其他值默认为不符合
          if (dataValue === '符合') {
            resultValue = 'qualified';
          } else if (dataValue === '无此项') {
            resultValue = 'notApplicable';
          } else if (dataValue === '不符合') {
            resultValue = 'unqualified';
          } else {
            // 其他任何值都默认为不符合
            resultValue = 'unqualified';
            // 如果dataValue不是标准值，可以存储到备注中
            if (dataValue && dataValue !== '不合格') {
              console.log(`检测项目 ${cleanDataKey} 的具体问题: ${dataValue}`);
            }
          }
          item.result = resultValue;

          // 同步更新pageOneTreeData中的数据，防止flattenTreeData时数据丢失
          this.updateTreeNodeResult(item.id, resultValue);

          // 设置子项结果后，需要更新父项的综合检验结果
          this.updateParentAutoResult(item);
        } else if (item.hasChildren) {
          // 父项设置综合检验结果
          if (dataValue === '符合') {
            item.autoResult = 'qualified';
          } else if (dataValue === '无此项') {
            item.autoResult = 'notApplicable';
          } else {
            item.autoResult = 'unqualified';
          }
        }
    },

    // 更新树形数据中节点的result值（不触发flattenTreeData）
    updateTreeNodeResult (id, result) {
      const updateNode = (nodes) => {
        for (let node of nodes) {
          if (node.id === id) {
            node.result = result;
            return true;
          }
          if (node.children && updateNode(node.children)) {
            return true;
          }
        }
        return false;
      };
      updateNode(this.pageOneTreeData);
    },

    // 为所有未在datas中出现的level 3项目设置默认的"符合"状态
    setDefaultResultsForMissingItems (existingPageOneKeys) {
      console.log('=== 开始设置默认结果 ===');
      console.log('已存在的项目编号:', Array.from(existingPageOneKeys));

      // 获取所有level 3的项目
      const level3Items = this.pageOneData.filter(item => item.level === 3);
      console.log(`找到 ${level3Items.length} 个 level 3 项目`);

      let updatedCount = 0;
      level3Items.forEach(item => {
        // 如果该项目编号不在datas中，且当前没有result值，则设置为"符合"
        if (!existingPageOneKeys.has(item.itemNumber) && !item.result) {
          console.log(`设置默认符合状态: ${item.itemNumber}`);
          item.result = 'qualified';
          updatedCount++;

          // 更新父项的综合检验结果
          this.updateParentAutoResult(item);
        }
      });

      console.log(`共设置了 ${updatedCount} 个项目为默认符合状态`);
      console.log('=== 默认结果设置完成 ===');
    },


    // 反填第二页数据
    fillPageTwoData (dataKey, dataValue) {
      // 根据dataKey的模式来确定是哪个表格的哪个字段
      // 这里需要根据具体的数据结构来实现反填逻辑
      // 由于第二页的数据结构比较复杂，这里提供一个基础框架

      // 抽查层站 - CheckFloor 或 CheckFloor1, CheckFloor2 等
      if (dataKey === 'CheckFloor' || dataKey.startsWith('CheckFloor')) {
        // 若当前已有层站配置（checkStations），则以配置驱动的动态列为准，
        // 避免旧 datas 中的 CheckFloorX 将 samplingFloors 回填成历史值。
        const hasConfiguredStations = Array.isArray(this.floorSettingData && this.floorSettingData.checkStations) &&
          this.floorSettingData.checkStations.length > 0;
        if (hasConfiguredStations) {
          return;
        }

        let tableNum = 1; // 默认表格1
        if (dataKey !== 'CheckFloor') {
          const floorNum = dataKey.replace('CheckFloor', '');
          const parsedNum = parseInt(floorNum);
          if (!isNaN(parsedNum) && parsedNum >= 1 && parsedNum <= 14) {
            // 建立正确的映射关系：CheckFloor1-10 对应 table1-10，CheckFloor11 对应 table11，CheckFloor12 对应 table12，CheckFloor13 对应 table13，CheckFloor14 对应 table14
            if (parsedNum <= 10) {
              tableNum = parsedNum;
            } else if (parsedNum === 11) {
              tableNum = 11;
            } else if (parsedNum === 12) {
              tableNum = 12;
            } else if (parsedNum === 13) {
              tableNum = 13;
            } else if (parsedNum === 14) {
              tableNum = 14;
            }
          }
        }
        const tableName = `pageTwoTable${tableNum}`;
        if (this[tableName] && this[tableName].samplingFloors !== undefined) {
          this[tableName].samplingFloors = dataValue;
        }
      }

      // 附表 A1.2.7.1(1) 和 A1.2.7.1(2) - 层门间隙检测记录表
      // 新需求：仅处理检测结果（R），不再处理层站（F）
      // DR: 门扇与门扇 (doorToDoor.result)
      // ZR: 门扇与立柱 (doorToColumn.result)
      // MR: 门扇与门楣 (doorToLintel.result)
      // KR: 门扇与门坎 (doorToSill.result)
      // 注意：MDR/MZR 属于附表 A1.2.7.8（table14），不可在此匹配，否则会 return 截胡导致 table14 无法回填
      const table1Patterns = [
        // 附表 A1.2.7.1(2) 前缀更长，必须先于 table1 的 MR/KR 匹配
        { prefix: 'MMR', key: 'doorToLintel', field: 'result', tables: [2] },
        { prefix: 'MKR', key: 'doorToSill', field: 'result', tables: [2] },
        { prefix: 'MWR', key: 'externalForceDoorToDoor', field: 'result', tables: [2] },
        // 附表 A1.2.7.1(1)
        { prefix: 'DR', key: 'doorToDoor', field: 'result', tables: [1] },
        { prefix: 'ZR', key: 'doorToColumn', field: 'result', tables: [1] },
        { prefix: 'MR', key: 'doorToLintel', field: 'result', tables: [1] },
        { prefix: 'KR', key: 'doorToSill', field: 'result', tables: [1] },
        // 施外力门扇与门扇（门扇与门扇间隙）
        { prefix: 'WR', key: 'externalForceDoorToDoor', field: 'result', tables: [1] }
      ];

      for (const pattern of table1Patterns) {
        if (dataKey.startsWith(pattern.prefix)) {
          const colNum = parseInt(dataKey.replace(pattern.prefix, ''));
          if (!isNaN(colNum) && colNum >= 1) {
            const colIndex = colNum - 1; // 转换为数组索引（0-12）
            for (const tableNum of pattern.tables) {
              const tableName = `pageTwoTable${tableNum}`;
              if (this[tableName] && this[tableName].columns && this[tableName].columns[colIndex]) {
                if (this[tableName].columns[colIndex].data && this[tableName].columns[colIndex].data[pattern.key]) {
                  this[tableName].columns[colIndex].data[pattern.key][pattern.field] = dataValue;
                }
              }
            }
          }
          return; // 找到匹配后直接返回
        }
      }

      // 附表 A1.2.7.2 - 玻璃门防拖曳措施检查记录表（表格3）
      // WF: 无防止儿童的手被拖曳的措施 (noMeasure)
      // FZ: 防止儿童的手被拖曳的措施无效 (invalidMeasure)
      // 注意：WFZZ / FZZl 属于表格8，这里需要排除，避免被模糊匹配截胡
      if (dataKey.startsWith('WF') && !dataKey.startsWith('WFZZ')) {
        const colNum = parseInt(dataKey.replace('WF', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable3 && this.pageTwoTable3.columns && this.pageTwoTable3.columns[colIndex]) {
            this.pageTwoTable3.columns[colIndex].data.noMeasure = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('FZ') && !dataKey.startsWith('FZZl')) {
        const colNum = parseInt(dataKey.replace('FZ', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable3 && this.pageTwoTable3.columns && this.pageTwoTable3.columns[colIndex]) {
            this.pageTwoTable3.columns[colIndex].data.invalidMeasure = dataValue;
          }
        }
        return;
      }

      // 附表 A1.2.7.4(1) - 门的运行与导向检查记录表（表格4）
      // T: 层门运行时有脱轨现象 (derailment)
      // K: 层门运行时有机械卡阻现象 (jamming)
      // CW: 层门运行到终端时有错位现象 (misalignment)
      // 注意：TestResultX 属于表格17，这里需要排除，避免被 T 的模糊匹配截胡
      if (dataKey.startsWith('T') && !dataKey.startsWith('TestResult')) {
        const colNum = parseInt(dataKey.replace('T', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable4 && this.pageTwoTable4.columns && this.pageTwoTable4.columns[colIndex]) {
            this.pageTwoTable4.columns[colIndex].data.derailment = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('K') && !dataKey.startsWith('KF') && !dataKey.startsWith('KR')) {
        const colNum = parseInt(dataKey.replace('K', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable4 && this.pageTwoTable4.columns && this.pageTwoTable4.columns[colIndex]) {
            this.pageTwoTable4.columns[colIndex].data.jamming = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('CW')) {
        const colNum = parseInt(dataKey.replace('CW', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable4 && this.pageTwoTable4.columns && this.pageTwoTable4.columns[colIndex]) {
            this.pageTwoTable4.columns[colIndex].data.misalignment = dataValue;
          }
        }
        return;
      }

      // 附表 A1.2.7.4(2) - 门的运行与导向检查记录表（表格5）
      // WCM: 层门导向装置失效时无层门保持装置 (noDevice)
      // WBC: 层门导向装置失效时层门保持装置无法使层门保持在原位置 (deviceInvalid)
      if (dataKey.startsWith('WCM')) {
        const colNum = parseInt(dataKey.replace('WCM', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable5 && this.pageTwoTable5.columns && this.pageTwoTable5.columns[colIndex]) {
            this.pageTwoTable5.columns[colIndex].data.noDevice = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('WBC')) {
        const colNum = parseInt(dataKey.replace('WBC', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable5 && this.pageTwoTable5.columns && this.pageTwoTable5.columns[colIndex]) {
            this.pageTwoTable5.columns[colIndex].data.deviceInvalid = dataValue;
          }
        }
        return;
      }

      // 附表 A1.2.7.4(3) - 门的运行与导向检查记录表（表格6）
      // WZX: 底部的层门保持装置无最小啮合深度的标记 (noMark)
      // NXY: 底部的层门保持装置啮合深度小于标记值 (lessThanMark)
      if (dataKey.startsWith('WZX')) {
        const colNum = parseInt(dataKey.replace('WZX', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable6 && this.pageTwoTable6.columns && this.pageTwoTable6.columns[colIndex]) {
            this.pageTwoTable6.columns[colIndex].data.noMark = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('NXY')) {
        const colNum = parseInt(dataKey.replace('NXY', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable6 && this.pageTwoTable6.columns && this.pageTwoTable6.columns[colIndex]) {
            this.pageTwoTable6.columns[colIndex].data.lessThanMark = dataValue;
          }
        }
        return;
      }

      // 附表 A1.2.7.5(1) - 自动关闭层门装置检查记录表（表格7）
      // W: 层门无自动关闭装置 (noAutoClose)
      // ZDSX: 层门自动关闭装置失效 (autoCloseInvalid)
      // 注意：WDQ / WZJZS 等前缀属于后面的表格，需要在这里排除，否则会被错误拦截
      if (
        dataKey === 'W' ||
        (dataKey.startsWith('W') &&
          !dataKey.startsWith('WF') &&
          !dataKey.startsWith('WCM') &&
          !dataKey.startsWith('WBC') &&
          !dataKey.startsWith('WZX') &&
          !dataKey.startsWith('WJJ') &&
          !dataKey.startsWith('WDQ') &&
          !dataKey.startsWith('WZJZS'))
      ) {
        const colNum = parseInt(dataKey.replace('W', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable7 && this.pageTwoTable7.columns && this.pageTwoTable7.columns[colIndex]) {
            this.pageTwoTable7.columns[colIndex].data.noAutoClose = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('ZDSX')) {
        const colNum = parseInt(dataKey.replace('ZDSX', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable7 && this.pageTwoTable7.columns && this.pageTwoTable7.columns[colIndex]) {
            this.pageTwoTable7.columns[colIndex].data.autoCloseInvalid = dataValue;
          }
        }
        return;
      }

      // 附表 A1.2.7.5(2) - 自动关闭层门装置检查记录表（表格8）
      // WFZZ: 重块式自动关闭层门装置无防止重块坠落措施 (noPreventFall)
      // FZZl: 重块式自动关闭层门装置防止重块坠落措施不可靠 (preventFallUnreliable)
      if (dataKey.startsWith('WFZZ')) {
        const colNum = parseInt(dataKey.replace('WFZZ', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable8 && this.pageTwoTable8.columns && this.pageTwoTable8.columns[colIndex]) {
            this.pageTwoTable8.columns[colIndex].data.noPreventFall = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('FZZl')) {
        const colNum = parseInt(dataKey.replace('FZZl', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable8 && this.pageTwoTable8.columns && this.pageTwoTable8.columns[colIndex]) {
            this.pageTwoTable8.columns[colIndex].data.preventFallUnreliable = dataValue;
          }
        }
        return;
      }

      // 附表 A1.2.7.6(1) - 紧急开锁检查记录表（表格9）
      // WJJ: 层门无紧急开锁装置 (noEmergencyUnlock)
      // BNKQ: 层门紧急开锁装置不能可靠开启 (emergencyUnlockUnreliable)
      // BCKS: 层门闭合时紧急开锁装置仍保持开锁位置 (unlockStillOpen)
      if (dataKey.startsWith('WJJ')) {
        const colNum = parseInt(dataKey.replace('WJJ', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable9 && this.pageTwoTable9.columns && this.pageTwoTable9.columns[colIndex]) {
            this.pageTwoTable9.columns[colIndex].data.noEmergencyUnlock = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('BNKQ')) {
        const colNum = parseInt(dataKey.replace('BNKQ', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable9 && this.pageTwoTable9.columns && this.pageTwoTable9.columns[colIndex]) {
            this.pageTwoTable9.columns[colIndex].data.emergencyUnlockUnreliable = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('BCKS')) {
        const colNum = parseInt(dataKey.replace('BCKS', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable9 && this.pageTwoTable9.columns && this.pageTwoTable9.columns[colIndex]) {
            this.pageTwoTable9.columns[colIndex].data.unlockStillOpen = dataValue;
          }
        }
        return;
      }

      // 附表 A1.2.7.7(1) - 门的锁紧与闭合检查记录表（表格10）
      // S: 未设置门锁装置 (noLockDevice)
      // SJ: 锁紧动作不由重力、永久磁铁或弹簧产生和保持 (lockNotByGravity)
      // B: 锁紧动作不能保持 (lockNotMaintain)
      // SJSX: 保持锁紧的元件失效后重力可导致开锁 (gravityCanUnlock)
      // C: 层门门锁装置失效 (doorLockInvalid)
      // 注意：Specification 属于表格16，这里需要排除，避免被 S 的模糊匹配截胡
      if (
        dataKey === 'S' ||
        (dataKey.startsWith('S') &&
          !dataKey.startsWith('SJ') &&
          !dataKey.startsWith('SF') &&
          !dataKey.startsWith('SR') &&
          !dataKey.startsWith('Specification'))
      ) {
        const colNum = parseInt(dataKey.replace('S', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable10 && this.pageTwoTable10.columns && this.pageTwoTable10.columns[colIndex]) {
            this.pageTwoTable10.columns[colIndex].data.noLockDevice = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('SJ') && !dataKey.startsWith('SJSX')) {
        const colNum = parseInt(dataKey.replace('SJ', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable10 && this.pageTwoTable10.columns && this.pageTwoTable10.columns[colIndex]) {
            this.pageTwoTable10.columns[colIndex].data.lockNotByGravity = dataValue;
          }
        }
        return;
      }
      if (dataKey === 'B' || (dataKey.startsWith('B') && !dataKey.startsWith('BNKQ') && !dataKey.startsWith('BCKS') && !dataKey.startsWith('BJS'))) {
        const colNum = parseInt(dataKey.replace('B', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable10 && this.pageTwoTable10.columns && this.pageTwoTable10.columns[colIndex]) {
            this.pageTwoTable10.columns[colIndex].data.lockNotMaintain = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('SJSX')) {
        const colNum = parseInt(dataKey.replace('SJSX', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable10 && this.pageTwoTable10.columns && this.pageTwoTable10.columns[colIndex]) {
            this.pageTwoTable10.columns[colIndex].data.gravityCanUnlock = dataValue;
          }
        }
        return;
      }
      if (dataKey === 'C' || (dataKey.startsWith('C') && !dataKey.startsWith('CW') && !dataKey.startsWith('CJXF') && !dataKey.startsWith('CJXR'))) {
        const colNum = parseInt(dataKey.replace('C', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable10 && this.pageTwoTable10.columns && this.pageTwoTable10.columns[colIndex]) {
            this.pageTwoTable10.columns[colIndex].data.doorLockInvalid = dataValue;
          }
        }
        return;
      }

      // 附表 A1.2.7.7(2) - 门锁啮合长度检测记录表（表格11）
      // 新需求：仅处理 SR（result），不再处理 SF（floor）
      // 表格11有4行lockLength，每列都有这4个lockLength
      if (dataKey.startsWith('SR')) {
        const rest = dataKey.replace('SR', '');
        if (!/^\d+$/.test(rest) || !this.pageTwoTable11 || !this.pageTwoTable11.columns) {
          return;
        }
        const maxCols = this.pageTwoTable11.columns.length;
        if (maxCols < 1) {
          return;
        }

        let colNum = NaN;
        let rowNum = 1;

        // 优先按“整段列号”处理，确保 SR10、SR11... 能正确回填到第10、11列
        const directColNum = parseInt(rest, 10);
        if (!isNaN(directColNum) && directColNum >= 1 && directColNum <= maxCols) {
          colNum = directColNum;
        } else if (rest.length >= 2) {
          // 兼容旧格式：SR{列号}{行号}，例如 SR122 => 第12列第2行
          rowNum = parseInt(rest.slice(-1), 10);
          colNum = parseInt(rest.slice(0, -1), 10);
        }

        if (isNaN(colNum) || colNum < 1 || colNum > maxCols || isNaN(rowNum) || rowNum < 1 || rowNum > 4) {
          return;
        }

        const colIndex = colNum - 1;
        const lockLengthKey = `lockLength${rowNum}`;
        const targetCol = this.pageTwoTable11.columns[colIndex];
        if (targetCol && targetCol.data && targetCol.data[lockLengthKey]) {
          targetCol.data[lockLengthKey].result = dataValue;
        }
        return;
      }

      // 附表 A1.2.7.7(3) - 层门锁紧状态的电气安全装置检查记录表（表格12）
      // D: 未设检查层门锁紧状态的电气安全装置 (noElectricDevice)
      // Q: 检查层门锁紧状态的电气安全装置失效 (electricDeviceInvalid)
      if (dataKey === 'D' || (dataKey.startsWith('D') && !dataKey.startsWith('DQDZ') && !dataKey.startsWith('Download'))) {
        const colNum = parseInt(dataKey.replace('D', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable12 && this.pageTwoTable12.columns && this.pageTwoTable12.columns[colIndex]) {
            this.pageTwoTable12.columns[colIndex].data.noElectricDevice = dataValue;
          }
        }
        return;
      }
      if (dataKey === 'Q' || (dataKey.startsWith('Q') && !dataKey.startsWith('QF'))) {
        const colNum = parseInt(dataKey.replace('Q', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable12 && this.pageTwoTable12.columns && this.pageTwoTable12.columns[colIndex]) {
            this.pageTwoTable12.columns[colIndex].data.electricDeviceInvalid = dataValue;
          }
        }
        return;
      }

      // 附表 A1.2.7.7(4) - 验证层门闭合的电气安全装置检查记录表（表格13）
      // WDQ: 无验证层门(间接门扇)的电气安全装置 (noVerifyDevice)
      // Y: 验证层门(间接门扇)的电气安全装置失效 (verifyDeviceInvalid)
      if (dataKey.startsWith('WDQ')) {
        const colNum = parseInt(dataKey.replace('WDQ', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable13 && this.pageTwoTable13.columns && this.pageTwoTable13.columns[colIndex]) {
            this.pageTwoTable13.columns[colIndex].data.noVerifyDevice = dataValue;
          }
        }
        return;
      }
      if (dataKey === 'Y' || (dataKey.startsWith('Y') && !dataKey.startsWith('YF'))) {
        const colNum = parseInt(dataKey.replace('Y', ''));
        if (!isNaN(colNum) && colNum >= 1) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable13 && this.pageTwoTable13.columns && this.pageTwoTable13.columns[colIndex]) {
            this.pageTwoTable13.columns[colIndex].data.verifyDeviceInvalid = dataValue;
          }
        }
        return;
      }

      // 附表 A1.2.7.8 - 轿门门刀与层门地坎，层门锁滚轮与轿厢地坎的间隙检测记录表（表格14）
      // 新需求：仅处理 MDR/MZR（result），不再处理 MDF/MZF（floor）
      if (dataKey.startsWith('MDR')) {
        const colNum = parseInt(dataKey.replace('MDR', ''), 10);
        const maxCols = this.pageTwoTable14 && this.pageTwoTable14.columns ? this.pageTwoTable14.columns.length : 0;
        if (!isNaN(colNum) && colNum >= 1 && colNum <= maxCols) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable14 && this.pageTwoTable14.columns && this.pageTwoTable14.columns[colIndex]) {
            this.pageTwoTable14.columns[colIndex].data.doorKnifeGap.result = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('MZR')) {
        const colNum = parseInt(dataKey.replace('MZR', ''), 10);
        const maxCols = this.pageTwoTable14 && this.pageTwoTable14.columns ? this.pageTwoTable14.columns.length : 0;
        if (!isNaN(colNum) && colNum >= 1 && colNum <= maxCols) {
          const colIndex = colNum - 1;
          if (this.pageTwoTable14 && this.pageTwoTable14.columns && this.pageTwoTable14.columns[colIndex]) {
            this.pageTwoTable14.columns[colIndex].data.rollerGap.result = dataValue;
          }
        }
        return;
      }

      // 附表 A1.3.2 - 电梯平衡系数测试记录表（表格15）
      // JJXF/JJXR: 电流，上行 (currentUp的load30/40/45/50/60)
      // CJXF/CJXR: 电流，下行 (currentDown的load30/40/45/50/60)
      // Upload1~Upload5: 上行电流 currentUp 的 load30/40/45/50/60（保存时使用的简化编码）
      // Download1~Download5: 下行电流 currentDown 的 load30/40/45/50/60（保存时使用的简化编码）
      // 字段命名规则：JJXF30表示上行30%负载，JJXF40表示上行40%负载，以此类推
      if (dataKey.startsWith('JJXF')) {
        const suffix = dataKey.replace('JJXF', '');
        const loadKey = suffix ? `load${suffix}` : 'load30';
        if (this.pageTwoTable15 && this.pageTwoTable15.currentUp) {
          if (['load30', 'load40', 'load45', 'load50', 'load60'].includes(loadKey)) {
            this.pageTwoTable15.currentUp[loadKey] = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('JJXR')) {
        // JJXR可能不需要，因为currentUp只有load值
        return;
      }
      if (dataKey.startsWith('CJXF')) {
        const suffix = dataKey.replace('CJXF', '');
        const loadKey = suffix ? `load${suffix}` : 'load30';
        if (this.pageTwoTable15 && this.pageTwoTable15.currentDown) {
          if (['load30', 'load40', 'load45', 'load50', 'load60'].includes(loadKey)) {
            this.pageTwoTable15.currentDown[loadKey] = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('CJXR')) {
        // CJXR可能不需要
        return;
      }

      // 兼容使用 Upload1~Upload5 / Download1~Download5 保存的电流数据
      if (dataKey.startsWith('Upload')) {
        const index = parseInt(dataKey.replace('Upload', ''));
        const loadMap = {
          1: 'load30',
          2: 'load40',
          3: 'load45',
          4: 'load50',
          5: 'load60'
        };
        const loadKey = loadMap[index];
        if (loadKey && this.pageTwoTable15 && this.pageTwoTable15.currentUp) {
          this.pageTwoTable15.currentUp[loadKey] = dataValue;
        }
        return;
      }
      if (dataKey.startsWith('Download')) {
        const index = parseInt(dataKey.replace('Download', ''));
        const loadMap = {
          1: 'load30',
          2: 'load40',
          3: 'load45',
          4: 'load50',
          5: 'load60'
        };
        const loadKey = loadMap[index];
        if (loadKey && this.pageTwoTable15 && this.pageTwoTable15.currentDown) {
          this.pageTwoTable15.currentDown[loadKey] = dataValue;
        }
        return;
      }

      // 附表 A1.3.4(1) - 限速器校验记录表（表格16）
      // Specification: 规格型号
      // JXDZ1~8: 机械动作速度（上行1/2/3/平均，下行1/2/3/平均）
      // DQDZ1~8: 电气动作速度（上行1/2/3/平均，下行1/2/3/平均）
      if (dataKey === 'Specification') {
        if (this.pageTwoTable16) {
          this.pageTwoTable16.model = dataValue;
        }
        return;
      }
      if (dataKey.startsWith('JXDZ')) {
        // 机械动作速度：JXDZ1~8 对应 up1/up2/up3/upAvg/down1/down2/down3/downAvg
        const index = parseInt(dataKey.replace('JXDZ', ''), 10);
        const keyMap = ['up1', 'up2', 'up3', 'upAvg', 'down1', 'down2', 'down3', 'downAvg'];
        if (!isNaN(index) && index >= 1 && index <= 8) {
          const speedKey = keyMap[index - 1];
          if (this.pageTwoTable16 && this.pageTwoTable16.mechanicalSpeed && speedKey) {
            this.pageTwoTable16.mechanicalSpeed[speedKey] = dataValue;
            this.updatePageTwoTable16Avg('mechanicalSpeed', 'up');
            this.updatePageTwoTable16Avg('mechanicalSpeed', 'down');
          }
        }
        return;
      }
      if (dataKey.startsWith('DQDZ')) {
        // 电气动作速度：DQDZ1~8 对应 up1/up2/up3/upAvg/down1/down2/down3/downAvg
        const index = parseInt(dataKey.replace('DQDZ', ''), 10);
        const keyMap = ['up1', 'up2', 'up3', 'upAvg', 'down1', 'down2', 'down3', 'downAvg'];
        if (!isNaN(index) && index >= 1 && index <= 8) {
          const speedKey = keyMap[index - 1];
          if (this.pageTwoTable16 && this.pageTwoTable16.electricSpeed && speedKey) {
            this.pageTwoTable16.electricSpeed[speedKey] = dataValue;
            this.updatePageTwoTable16Avg('electricSpeed', 'up');
            this.updatePageTwoTable16Avg('electricSpeed', 'down');
          }
        }
        return;
      }

      // 附表 A1.3.14 - 噪声测试记录表（表格17）
      // JFZS: 机房噪声测试点
      // NZS: 轿厢内噪声
      // KGZS/MZS: 开关门噪声（保存时使用 MZS1/MZS2）
      // WZJZS: 无机房电梯层门处噪声
      // TestResultX: 测试结果（1~4 分别对应机房噪声、轿厢内噪声、开关门噪声、无机房电梯层门处噪声）
      if (dataKey.startsWith('BJS')) {
        const suffix = dataKey.replace('BJS', '');
        const index = suffix ? parseInt(suffix, 10) - 1 : 0;
        const backgroundKeys = ['machineRoom', 'carInside', 'doorNoise', 'noMachineRoom'];
        if (!isNaN(index) && index >= 0 && index < backgroundKeys.length) {
          const targetKey = backgroundKeys[index];
          if (this.pageTwoTable17 && this.pageTwoTable17[targetKey]) {
            this.pageTwoTable17[targetKey].background = dataValue;
          }
        }
        return;
      }
      if (dataKey.startsWith('JFZS')) {
        const suffix = dataKey.replace('JFZS', '');
        if (this.pageTwoTable17 && this.pageTwoTable17.machineRoom) {
          if (suffix === '1' || suffix === 'point1') {
            this.pageTwoTable17.machineRoom.point1 = dataValue;
          } else if (suffix === '2' || suffix === 'point2') {
            this.pageTwoTable17.machineRoom.point2 = dataValue;
          } else if (suffix === '3' || suffix === 'point3') {
            this.pageTwoTable17.machineRoom.point3 = dataValue;
          }
          this.updatePageTwoTable17Result('machineRoom');
        }
        return;
      }
      if (dataKey.startsWith('NZS')) {
        const suffix = dataKey.replace('NZS', '');
        if (this.pageTwoTable17 && this.pageTwoTable17.carInside) {
          if (suffix === 'up' || suffix === '1') {
            this.pageTwoTable17.carInside.up = dataValue;
          } else if (suffix === 'down' || suffix === '2') {
            this.pageTwoTable17.carInside.down = dataValue;
          }
          this.updatePageTwoTable17Result('carInside');
        }
        return;
      }
      if (dataKey.startsWith('MZS')) {
        const suffix = dataKey.replace('MZS', '');
        if (this.pageTwoTable17) {
          if (!this.pageTwoTable17.doorNoise) {
            this.$set(this.pageTwoTable17, 'doorNoise', {});
          }
          if (suffix === 'open' || suffix === '1') {
            this.$set(this.pageTwoTable17.doorNoise, 'open', dataValue);
            console.log(`回填 MZS${suffix}: ${dataValue} 到 pageTwoTable17.doorNoise.open`);
          } else if (suffix === 'close' || suffix === '2') {
            this.$set(this.pageTwoTable17.doorNoise, 'close', dataValue);
            console.log(`回填 MZS${suffix}: ${dataValue} 到 pageTwoTable17.doorNoise.close`);
          }
          this.updatePageTwoTable17Result('doorNoise');
        }
        return;
      }
      if (dataKey.startsWith('WZJZS')) {
        const suffix = dataKey.replace('WZJZS', '');
        if (this.pageTwoTable17 && this.pageTwoTable17.noMachineRoom) {
          if (suffix === 'up' || suffix === '1') {
            this.pageTwoTable17.noMachineRoom.up = dataValue;
          } else if (suffix === 'down' || suffix === '2') {
            this.pageTwoTable17.noMachineRoom.down = dataValue;
          }
          this.updatePageTwoTable17Result('noMachineRoom');
        }
        return;
      }
      if (dataKey.startsWith('TestResult')) {
        const suffix = dataKey.replace('TestResult', '');
        const index = suffix ? parseInt(suffix, 10) - 1 : 0;
        const resultKeys = ['machineRoom', 'carInside', 'doorNoise', 'noMachineRoom'];

        if (!isNaN(index) && index >= 0 && index < resultKeys.length) {
          const targetKey = resultKeys[index];
          if (this.pageTwoTable17 && this.pageTwoTable17[targetKey]) {
            this.pageTwoTable17[targetKey].result = dataValue;
          }
        }
        return;
      }
    },
    // 反填其他字段
    fillOtherFields (dataKey, dataValue) {
      // 处理检测环境条件确认结果 Result01-07（1-7条独立）
      if (dataKey === 'Result01') {
        // 第1条结果
        if (this.environmentConditionsData[0]) {
          this.environmentConditionsData[0].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result02') {
        // 第2条结果
        if (this.environmentConditionsData[1]) {
          this.environmentConditionsData[1].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result03') {
        // 第3条结果
        if (this.environmentConditionsData[2]) {
          this.environmentConditionsData[2].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result04') {
        // 第4条结果
        if (this.environmentConditionsData[3]) {
          this.environmentConditionsData[3].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result05') {
        // 第5条结果
        if (this.environmentConditionsData[4]) {
          this.environmentConditionsData[4].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result06') {
        // 第6条结果
        if (this.environmentConditionsData[5]) {
          this.environmentConditionsData[5].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result07') {
        // 第7条结果
        if (this.environmentConditionsData[6]) {
          this.environmentConditionsData[6].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'Result08') {
        // 第8条“其他：无”仅展示，无确认结果，不做回填处理
      } else if (dataKey === 'LegacyResult01') {
        // 兼容历史：旧版“第1-5条合并结果”不再使用，保留占位避免误处理
        if (this.environmentConditionsData[0] && !this.environmentConditionsData[0].confirmResult) {
          this.environmentConditionsData[0].confirmResult = dataValue === '是' ? 'qualified' : 'unqualified';
        }
      } else if (dataKey === 'ProductionUnit') {
        // 附表 A1.3.4(1) 限速器校验记录表 - 制造单位
        if (this.pageTwoTable16) {
          this.pageTwoTable16.manufacturer = dataValue;
        }
      } else if (dataKey === 'ProductionNum') {
        // 附表 A1.3.4(1) 限速器校验记录表 - 产品编号
        if (this.pageTwoTable16) {
          this.pageTwoTable16.productNumber = dataValue;
        }
      }
      // 其他特殊字段可以继续在这里添加
    },

    // 表格1单元格合并方法
    tableCellMerge ({ row, column, rowIndex, columnIndex }) {
    },
    // 表格2单元格合并方法
    tableCellMerge2 ({ row, column, rowIndex, columnIndex }) {
    },
    // 表格3单元格合并方法
    tableCellMerge3 ({ row, column, rowIndex, columnIndex }) {
    },
    // 噪声测试记录表单元格合并方法
    pageTwoTable17SpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 第一列：噪声测试项目 - 合并两行
      if (columnIndex === 0) {
        // 机房噪声 (rowIndex 0, 1)
        if (rowIndex === 0) {
          return { rowspan: 2, colspan: 1 };
        } else if (rowIndex === 1) {
          return { rowspan: 0, colspan: 0 };
        }
        // 轿厢内噪声 (rowIndex 2, 3)
        else if (rowIndex === 2) {
          return { rowspan: 2, colspan: 1 };
        } else if (rowIndex === 3) {
          return { rowspan: 0, colspan: 0 };
        }
        // 开关门噪声 (rowIndex 4, 5)
        else if (rowIndex === 4) {
          return { rowspan: 2, colspan: 1 };
        } else if (rowIndex === 5) {
          return { rowspan: 0, colspan: 0 };
        }
        // 无机房电梯层门处噪声 (rowIndex 6, 7)
        else if (rowIndex === 6) {
          return { rowspan: 2, colspan: 1 };
        } else if (rowIndex === 7) {
          return { rowspan: 0, colspan: 0 };
        }
      }

      // 第3-4列：对于 twoColumn 类型，合并两列
      if (row.type === 'header' && row.rowType === 'twoColumn' && (columnIndex === 2 || columnIndex === 3)) {
        if (columnIndex === 2) {
          return { rowspan: 1, colspan: 2 };
        } else if (columnIndex === 3) {
          return { rowspan: 0, colspan: 0 };
        }
      }

      // 最后一列：测试结果 - 合并两行
      if (columnIndex === 5) {
        // 机房噪声 (rowIndex 0, 1)
        if (rowIndex === 0) {
          return { rowspan: 2, colspan: 1 };
        } else if (rowIndex === 1) {
          return { rowspan: 0, colspan: 0 };
        }
        // 轿厢内噪声 (rowIndex 2, 3)
        else if (rowIndex === 2) {
          return { rowspan: 2, colspan: 1 };
        } else if (rowIndex === 3) {
          return { rowspan: 0, colspan: 0 };
        }
        // 开关门噪声 (rowIndex 4, 5)
        else if (rowIndex === 4) {
          return { rowspan: 2, colspan: 1 };
        } else if (rowIndex === 5) {
          return { rowspan: 0, colspan: 0 };
        }
        // 无机房电梯层门处噪声 (rowIndex 6, 7)
        else if (rowIndex === 6) {
          return { rowspan: 2, colspan: 1 };
        } else if (rowIndex === 7) {
          return { rowspan: 0, colspan: 0 };
        }
      }
    },
    // 表格4单元格合并方法
    tableCellMerge4 ({ row, column, rowIndex, columnIndex }) {
    },
    // 表格5单元格合并方法
    tableCellMerge5 ({ row, column, rowIndex, columnIndex }) {
    },
    // 表格6单元格合并方法
    tableCellMerge6 ({ row, column, rowIndex, columnIndex }) {
    },
    // 表格7单元格合并方法
    tableCellMerge7 ({ row, column, rowIndex, columnIndex }) {
    },
    // 表格8单元格合并方法
    tableCellMerge8 ({ row, column, rowIndex, columnIndex }) {
    },
    // 表格9单元格合并方法
    tableCellMerge9 ({ row, column, rowIndex, columnIndex }) {
    },
    // 表格10单元格合并方法
    tableCellMerge10 ({ row, column, rowIndex, columnIndex }) {
    },
    // 表格11单元格合并方法 - 合并“层门锁啮合长度”4行的左侧项目名称
    tableCellMerge11 ({ row, column, rowIndex, columnIndex }) {
      // 仅对第1列（项目列）做跨行合并
      if (columnIndex !== 0) {
        return { rowspan: 1, colspan: 1 };
      }

      // rowIndex: 0=项目, 1~4=层门锁啮合长度（lockLength1~lockLength4）
      if (rowIndex === 1) {
        return { rowspan: 4, colspan: 1 };
      }
      if (rowIndex >= 2 && rowIndex <= 4) {
        return { rowspan: 0, colspan: 0 };
      }
      return { rowspan: 1, colspan: 1 };
    },
    // 表格12单元格合并方法
    tableCellMerge12 ({ row, column, rowIndex, columnIndex }) {
    },
    // 表格13单元格合并方法
    tableCellMerge13 ({ row, column, rowIndex, columnIndex }) {
    },
    // 表格14单元格合并方法
    tableCellMerge14 ({ row, column, rowIndex, columnIndex }) {
    },
    // 环境条件确认表格单元格合并方法
    environmentConditionsSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 需求变更：检测环境条件不再做任何行合并，所有单元格都独立显示
      return { rowspan: 1, colspan: 1 };
    },

    // 表格17单元格合并方法 - 噪声测试记录表
    tableCellMerge17 ({ row, column, rowIndex, columnIndex }) {
      // 每两行为一组，第一行是header，第二行是input
      const groupIndex = Math.floor(rowIndex / 2);
      const isHeaderRow = rowIndex % 2 === 0;

      // 第1列：噪声测试项目（每组的两行合并）
      if (columnIndex === 0) {
        if (isHeaderRow) {
          return { rowspan: 2, colspan: 1 };
        } else {
          return { rowspan: 0, colspan: 0 };
        }
      }

      // 第2列：空列（每组的两行合并）
      if (columnIndex === 1) {
        if (isHeaderRow) {
          return { rowspan: 2, colspan: 1 };
        } else {
          return { rowspan: 0, colspan: 0 };
        }
      }

      // 第3-5列：测试点或测试工况（嵌套列）
      // 机房噪声（rowIndex 0-1）：测试点1、测试点2、测试点3，各占1列，不合并
      if (groupIndex === 0) {
        // 机房噪声：3列独立，不做任何合并
        return {};
      }

      // 轿厢内噪声（rowIndex 2-3）、开关门噪声（rowIndex 4-5）、无机房电梯层门处噪声（rowIndex 6-7）
      // header行和input行：第3列合并到第4列，第5列独立
      if (groupIndex === 1 || groupIndex === 2 || groupIndex === 3) {
        if (columnIndex === 2) {
          // 第3列：合并第3和第4列（占1.5列的效果）
          return { rowspan: 1, colspan: 2 };
        } else if (columnIndex === 3) {
          // 第4列：被第3列合并
          return { rowspan: 0, colspan: 0 };
        } else if (columnIndex === 4) {
          // 第5列：独立显示（占1.5列的效果）
          return { rowspan: 1, colspan: 1 };
        }
      }

      // 第6列：测试结果（每组的两行合并）
      if (columnIndex === 5) {
        if (isHeaderRow) {
          return { rowspan: 2, colspan: 1 };
        } else {
          return { rowspan: 0, colspan: 0 };
        }
      }
    },
    // 表格16基本信息单元格合并方法
    tableCellMerge16Info ({ row, column, rowIndex, columnIndex }) {
      // 第一行（制造单位行）：第二列到第九列合并（columnIndex 1-8）
      if (rowIndex === 0 && columnIndex === 1) {
        return {
          rowspan: 1,
          colspan: 8
        };
      } else if (rowIndex === 0 && columnIndex > 1 && columnIndex <= 8) {
        return {
          rowspan: 0,
          colspan: 0
        };
      }

      // 第二行（产品编号行）：columnIndex 1-3 合并为产品编号，4 为规格型号标签，5-8 合并为规格型号输入
      if (rowIndex === 1) {
        if (columnIndex === 1) {
          // 产品编号输入框合并3列
          return {
            rowspan: 1,
            colspan: 3
          };
        } else if (columnIndex === 2 || columnIndex === 3) {
          return {
            rowspan: 0,
            colspan: 0
          };
        } else if (columnIndex === 4) {
          // 规格型号标签列
          return {
            rowspan: 1,
            colspan: 1
          };
        } else if (columnIndex === 5) {
          // 规格型号输入框合并3列
          return {
            rowspan: 1,
            colspan: 3
          };
        } else if (columnIndex === 6 || columnIndex === 7 || columnIndex === 8) {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 统计一级节点下二级子节点数量
    getLevel2ChildrenCount (level1Node) {
      if (!level1Node || !Array.isArray(level1Node.children)) {
        return 0;
      }
      return level1Node.children.filter(child => child.level === 2).length;
    },

    // 一级下仅有一个二级时，该二级不在表格展示（仍保留在树中参与汇总与提交）
    shouldHideLevel2InTable (level1Node) {
      return this.getLevel2ChildrenCount(level1Node) === 1;
    },

    // 将树形数据转换为平层数据用于表格显示
    flattenTreeData () {
      const result = [];
      const usedIds = new Set(); // 用于检测重复ID

      const flatten = (nodes, parentNode = null, topLevelId = '') => {
        nodes.forEach((node, index) => {
          // 确保ID唯一
          let uniqueId = node.id;
          if (usedIds.has(uniqueId)) {
            uniqueId = `${node.id}-${Date.now()}-${index}`;
          }
          usedIds.add(uniqueId);

          const currentTopLevelId = node.level === 1 ? node.id : topLevelId;

          // 一级下仅有一个二级时隐藏该二级；多个二级时正常展示
          const skipLevel2InTable = node.level === 2
            && parentNode
            && parentNode.level === 1
            && this.shouldHideLevel2InTable(parentNode);

          if (!skipLevel2InTable) {
            const flatItem = {
              id: uniqueId,
              originalId: node.id, // 保留原始ID用于逻辑处理
              itemNumber: node.itemNumber,
              description: node.description,
              level: node.level,
              topLevelId: currentTopLevelId, // 所属一级父节点分组ID（用于分组样式）
              result: node.result || '',
              hasChildren: node.children && node.children.length > 0,
              autoResult: node.autoResult || null,
              attachmentTable: node.attachmentTable || null, // 附表配置
              hasOpenedResultDialog: !!node.hasOpenedResultDialog
            };

            result.push(flatItem);
          }

          // 递归处理子节点（含被隐藏的二级）
          if (node.children && node.children.length > 0) {
            flatten(node.children, node, currentTopLevelId);
          }
        });
      };

      flatten(this.pageOneTreeData);

      // 使用 Vue.set 确保响应式更新
      this.$set(this, 'pageOneData', result);

      // 调试：检查 level 3 的默认值
      console.log('=== flattenTreeData 完成 ===');
      const level3Items = result.filter(item => item.level === 3);
      console.log(`Level 3 项目总数: ${level3Items.length}`);
      const qualifiedCount = level3Items.filter(item => item.result === 'qualified').length;
      const emptyCount = level3Items.filter(item => !item.result || item.result === '').length;
      console.log(`默认为 qualified 的: ${qualifiedCount}`);
      console.log(`result 为空的: ${emptyCount}`);
      if (level3Items.length > 0) {
        console.log('前3个 level 3 项目:', level3Items.slice(0, 3).map(item => ({
          id: item.id,
          itemNumber: item.itemNumber,
          result: item.result
        })));
      }
    },

    // 根据ID更新树形数据中的结果
    updateTreeDataResult (id, result) {
      const updateNode = (nodes) => {
        for (let node of nodes) {
          if (node.id === id || node.id === this.findOriginalIdByUniqueId(id)) {
            node.result = result;
            return true;
          }
          if (node.children && updateNode(node.children)) {
            return true;
          }
        }
        return false;
      };

      updateNode(this.pageOneTreeData);

      // 更新平铺数据
      this.flattenTreeData();

      // 更新父级的自动检验结果
      const item = this.findItemById(this.pageOneData, id);
      if (item) {
        this.updateParentAutoResult(item);
      }
    },

    // 根据平铺唯一ID反查原始ID（未命中则回退自身）
    findOriginalIdByUniqueId (id) {
      const matched = Array.isArray(this.pageOneData)
        ? this.pageOneData.find(item => item.id === id)
        : null;
      return matched && matched.originalId ? matched.originalId : id;
    },

    // 标记树节点已打开过结果弹窗，避免 flatten 后图标状态丢失
    setTreeNodeVisited (id) {
      if (!id) return;
      const markNodeVisited = (nodes) => {
        for (let node of nodes) {
          if (node.id === id) {
            this.$set(node, 'hasOpenedResultDialog', true);
            return true;
          }
          if (Array.isArray(node.children) && markNodeVisited(node.children)) {
            return true;
          }
        }
        return false;
      };
      markNodeVisited(this.pageOneTreeData);
    },

    // 生成动态编号
    generateDynamicNumbers (data) {
      const numberCount = {};

      // 统计每个基础编号下的数据数量
      data.forEach(item => {
        if (item.level === 3) {
          // 获取基础编号（去掉最后的-x部分）
          const baseNumber = item.id.replace(/-\d+$/, '');
          if (!numberCount[baseNumber]) {
            numberCount[baseNumber] = [];
          }
          numberCount[baseNumber].push(item);
        }
      });

      // 为每个基础编号分配具体编号
      Object.keys(numberCount).forEach(baseNumber => {
        const items = numberCount[baseNumber];
        // 无论有几个子项，都给每个子项分配独立的编号
        items.forEach((item, index) => {
          const itemNumber = `${baseNumber}.${index + 1}`;
          item.itemNumber = itemNumber;
          item.dataKey = itemNumber;
        });
      });

      return data;
    },

    // 查找数据项
    findItemById (data, id) {
      for (let item of data) {
        if (item.id === id) {
          return item;
        }
      }
      return null;
    },

    // 更新父级自动检验结果 - 支持三级联动
    updateParentAutoResult (changedItem) {
      console.log(`updateParentAutoResult 被调用，项目: ${changedItem.itemNumber}, level: ${changedItem.level}`);

      // level 3 变更：先更新树中的 level 2，再更新表格中的 level 1
      if (changedItem.level === 3) {
        const level2ParentId = changedItem.id.replace(/-\d+$/, '');
        const level2Parent = this.findOriginalItem(this.pageOneTreeData, level2ParentId);
        if (level2Parent && level2Parent.children && level2Parent.children.length > 0) {
          this.updateItemAutoResult(level2Parent);

          const level1Parent = this.findParentItem(this.pageOneData, { id: level2ParentId, level: 2 });
          if (level1Parent && level1Parent.hasChildren && level1Parent.level === 1) {
            this.updateItemAutoResult(level1Parent);
          }
        }
      }
      // 如果传入的是 level 1 项目，直接更新它的 autoResult
      else if (changedItem.level === 1 && changedItem.hasChildren) {
        this.updateItemAutoResult(changedItem);
      }
      else {
        console.log(`  跳过: level ${changedItem.level} 不参与计算或无子项`);
      }
    },

    // 更新单个项目的自动检验结果
    updateItemAutoResult (item) {
      const childResults = this.getChildrenResults(item);
      // console.log(`  更新项目 ${item.itemNumber} (level ${item.level}), 子项结果:`, childResults);

      // 计算自动检验结果：
      // 1. 如果所有子项都是"无此项"，则父项也是"无此项"
      // 2. 如果有"无此项"也有其他结果，"无此项"不参与计算
      // 3. 只要有一个"不符合"就是"不符合"
      // 4. 全部"符合"才是"符合"

      if (childResults.length === 0) {
        item.autoResult = null;
      } else {
        // 过滤掉"无此项"的结果
        const effectiveResults = childResults.filter(result => result !== 'notApplicable');
        const notApplicableCount = childResults.filter(result => result === 'notApplicable').length;

        if (effectiveResults.length === 0 && notApplicableCount > 0) {
          // 所有子项都是"无此项"
          item.autoResult = 'notApplicable';
        } else if (effectiveResults.some(result => result === 'unqualified')) {
          // 有效结果中有"不符合"
          item.autoResult = 'unqualified';
        } else if (effectiveResults.every(result => result === 'qualified')) {
          // 有效结果全部是"符合"
          item.autoResult = 'qualified';
        } else {
          // 还有未检验的项目
          item.autoResult = null;
        }
      }
      // console.log(`  计算结果: ${item.autoResult}`);

      // 同步更新树形数据中的autoResult
      const updateTreeAutoResult = (nodes) => {
        for (let node of nodes) {
          if (node.id === item.id) {
            node.autoResult = item.autoResult;
            return true;
          }
          if (node.children && updateTreeAutoResult(node.children)) {
            return true;
          }
        }
        return false;
      };
      updateTreeAutoResult(this.pageOneTreeData);
    },

    // 查找父级项目
    findParentItem (data, targetItem) {
      // 根据ID规律找父级：
      // A1.2.1.1-1 (level 3) 的父级是 A1.2.1.1 (level 2)
      // A1.2.1.1 (level 2) 的父级是 A1.2.1 (level 1)
      const targetId = targetItem.id;
      let parentId = '';

      if (targetId.includes('-')) {
        // 如果是 level 3 子项（包含-），父级是去掉-x部分
        parentId = targetId.replace(/-\d+$/, '');
      } else if (targetItem.level === 2) {
        // 如果是 level 2 项（如 A1.2.1.1），父级是去掉最后一个点及之后的部分（A1.2.1）
        const parts = targetId.split('.');
        if (parts.length > 1) {
          parts.pop(); // 移除最后一部分
          parentId = parts.join('.');
        }
      }

      if (parentId) {
        return this.findItemById(data, parentId);
      }

      return null;
    },

    // 获取子项检验结果 - 支持三级联动
    getChildrenResults (parentItem) {
      const results = [];
      const parentId = parentItem.id;
      const parentLevel = parentItem.level;

      if (parentLevel === 1) {
        const level1TreeNode = this.findOriginalItem(this.pageOneTreeData, parentId);
        if (level1TreeNode && this.shouldHideLevel2InTable(level1TreeNode)) {
          // 单个二级被隐藏：一级综合结果直接汇总其下所有 level 3
          const childItems = this.pageOneData.filter(item =>
            item.level === 3 && item.id.startsWith(parentId + '.')
          );
          childItems.forEach(item => {
            if (item.result) {
              results.push(item.result);
            }
          });
        } else if (level1TreeNode && Array.isArray(level1TreeNode.children)) {
          // 多个二级在表格展示：汇总各二级的 autoResult
          level1TreeNode.children
            .filter(child => child.level === 2)
            .forEach(level2Node => {
              if (level2Node.autoResult) {
                results.push(level2Node.autoResult);
              }
            });
        }
      } else if (parentLevel === 2) {
        // level 2 的父项，查找直接的 level 3 子项
        const childItems = this.pageOneData.filter(item =>
          item.level === 3 && item.id.startsWith(parentId + '-')
        );

        // console.log(`  父项 ${parentItem.itemNumber} (level 2) 的子项:`, childItems.map(c => `${c.itemNumber}:${c.result || 'null'}`));

        // 统计所有子项的result
        childItems.forEach(item => {
          if (item.result) {
            results.push(item.result);
          }
        });

        // console.log(`  有效结果数: ${results.length}/${childItems.length}`);
      }

      return results;
    },

    // 初始化数据结构
    initializePageOneData () {
      // 先平铺数据
      this.flattenTreeData();

      // 为数据添加必要的属性
      this.pageOneData.forEach(item => {
        // 判断是否有子项 - 修复逻辑：检查原始树形数据中是否有children
        item.hasChildren = false;
        if (item.level < 3) {
          // 在原始树形数据中查找对应项目
          const originalItem = this.findOriginalItem(this.pageOneTreeData, item.id);
          if (originalItem && originalItem.children && originalItem.children.length > 0) {
            item.hasChildren = true;
          }
        }

        // 初始化自动检验结果（level 1 和 level 2 都参与）
        if (item.hasChildren && (item.level === 1 || item.level === 2)) {
          item.autoResult = null;
        }
      });

      // 编号已在数据文件中固定，无需动态生成

      // 初始化所有父级的综合检验结果
      this.initializeAllParentAutoResults();

      // 生成导航列表
      this.generateNavigationList();

      // 确保表格滚动条可见
      this.ensureTableScrollable();

      // 最终调试：输出前5个 level 3 项目的完整信息
      // console.log('=== 初始化完成后的 level 3 项目 ===');
      const level3Final = this.pageOneData.filter(item => item.level === 3).slice(0, 5);
      level3Final.forEach(item => {
        // console.log(`${item.itemNumber}: result="${item.result}", 显示文本="${this.getResultText(item.result)}", 颜色类="${this.getResultColorClass(item)}"`);
      });

      // 强制刷新表格视图 - 使用多种方式确保更新
      this.$nextTick(() => {
        // 方法1: 强制Vue重新渲染
        this.$forceUpdate();

        // 方法2: 刷新表格布局
        if (this.$refs.pageOneTable) {
          this.$refs.pageOneTable.doLayout();
        }

        // 方法3: 再次在下一个tick强制更新
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      });
    },

    // 初始化所有父级的综合检验结果
    initializeAllParentAutoResults () {
      // console.log('=== 开始初始化父级 autoResult ===');
      // 从level 3的项目开始，向上更新所有父级
      const level3Items = this.pageOneData.filter(item => item.level === 3);
      // console.log(`找到 ${level3Items.length} 个 level 3 项目`);

      // 收集所有需要更新的 level 2 父级ID（避免重复更新）
      const level2ParentIds = new Set();
      const level1ParentIds = new Set();

      level3Items.forEach(item => {
        const level2ParentId = item.id.replace(/-\d+$/, '');
        if (level2ParentId) {
          level2ParentIds.add(level2ParentId);

          const parts = level2ParentId.split('.');
          if (parts.length > 1) {
            parts.pop();
            level1ParentIds.add(parts.join('.'));
          }
        }
      });

      // 先更新树中所有 level 2 父级的综合检验结果
      level2ParentIds.forEach(parentId => {
        const treeNode = this.findOriginalItem(this.pageOneTreeData, parentId);
        if (treeNode) {
          this.updateItemAutoResult(treeNode);
        }
      });

      // 再更新所有 level 1 父级的综合检验结果
      level1ParentIds.forEach(parentId => {
        const parentItem = this.findItemById(this.pageOneData, parentId);
        if (parentItem) {
          // console.log(`更新 level 1 父项: ${parentItem.itemNumber}`);
          this.updateItemAutoResult(parentItem);
          // console.log(`  -> autoResult: ${parentItem.autoResult}`);
        }
      });

      // console.log('=== 父级 autoResult 初始化完成 ===');
    },

    // 在原始树形数据中查找项目
    findOriginalItem (treeData, targetId) {
      for (let item of treeData) {
        if (item.id === targetId) {
          return item;
        }
        if (item.children) {
          const found = this.findOriginalItem(item.children, targetId);
          if (found) return found;
        }
      }
      return null;
    },

    // 在树形数据中按 itemNumber 查找节点（用于隐藏二级的回填）
    findTreeNodeByItemNumber (treeData, itemNumber) {
      for (const item of treeData) {
        if (item.itemNumber === itemNumber) {
          return item;
        }
        if (item.children) {
          const found = this.findTreeNodeByItemNumber(item.children, itemNumber);
          if (found) return found;
        }
      }
      return null;
    },

    // 生成导航列表：一级始终显示；一级下仅一个二级时不显示二级，多个二级时显示
    generateNavigationList () {
      this.navigationList = [];

      this.pageOneTreeData.forEach(level1Item => {
        if (!level1Item.itemNumber) {
          return;
        }

        this.navigationList.push({
          id: level1Item.id,
          itemNumber: level1Item.itemNumber,
          description: this.truncateDescription(level1Item.description, 15),
          level: 1
        });

        if (!this.shouldHideLevel2InTable(level1Item) && Array.isArray(level1Item.children)) {
          level1Item.children
            .filter(child => child.level === 2 && child.itemNumber)
            .forEach(level2Item => {
              this.navigationList.push({
                id: level2Item.id,
                itemNumber: level2Item.itemNumber,
                description: this.truncateDescription(level2Item.description, 15),
                level: 2
              });
            });
        }
      });

      console.log('生成的导航列表:', this.navigationList);
      console.log('表格数据:', this.pageOneData);
    },

    // 截断描述文本
    truncateDescription (text, maxLength) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },

    // 滚动到指定项目
    scrollToItem (itemId) {
      this.activeNavId = itemId;
      console.log('点击导航项:', itemId);

      // 在表格数据中找到对应的行索引
      const targetIndex = this.pageOneData.findIndex(item => item.id === itemId);
      console.log('找到目标行索引:', targetIndex);

      if (targetIndex !== -1) {
        this.$nextTick(() => {
          const table = this.$refs.pageOneTable;
          if (table && table.$el) {
            // 获取表格的滚动容器
            const scrollContainer = table.$el.querySelector('.el-table__body-wrapper');
            // 获取目标行的DOM元素
            const rows = table.$el.querySelectorAll('.el-table__row');
            const targetRow = rows[targetIndex];

            console.log('找到的目标行:', targetRow);
            console.log('滚动容器:', scrollContainer);

            if (targetRow && scrollContainer) {
              // 获取目标行相对于表格body的偏移位置
              const targetOffsetTop = targetRow.offsetTop;

              // 只滚动表格内部的容器，不影响整个页面
              scrollContainer.scrollTo({
                top: targetOffsetTop - 10, // 减去10px，让目标行有一点间距
                behavior: 'smooth'
              });
              console.log('滚动到位置:', targetOffsetTop);
            } else {
              // 备用方案：使用原来的计算方式
              let bodyWrapper = table.$el.querySelector('.el-table__body-wrapper');
              if (!bodyWrapper) {
                bodyWrapper = table.$el.querySelector('.el-table__body');
              }
              if (!bodyWrapper) {
                bodyWrapper = table.$el.querySelector('.el-scrollbar__wrap');
              }

              console.log('找到的滚动容器:', bodyWrapper);

              if (bodyWrapper && rows.length > 0) {
                // 获取表格行的实际高度
                let rowHeight = rows[0].offsetHeight || 80;

                // 计算目标行的位置，滚动到顶部
                const scrollTop = Math.max(0, targetIndex * rowHeight);

                console.log('滚动前容器状态:', {
                  scrollHeight: bodyWrapper.scrollHeight,
                  clientHeight: bodyWrapper.clientHeight,
                  currentScrollTop: bodyWrapper.scrollTop,
                  targetScrollTop: scrollTop
                });

                // 尝试多种滚动方式
                try {
                  // 方式1：使用Element UI的setScrollTop方法
                  if (table.setScrollTop && typeof table.setScrollTop === 'function') {
                    table.setScrollTop(scrollTop);
                    console.log('使用Element UI setScrollTop方法');
                  }
                  // 方式2：使用scrollTo方法
                  else if (bodyWrapper.scrollTo) {
                    bodyWrapper.scrollTo({
                      top: scrollTop,
                      behavior: 'smooth'
                    });
                    console.log('使用scrollTo方法');
                  }
                  // 方式3：直接设置scrollTop
                  else {
                    bodyWrapper.scrollTop = scrollTop;
                    console.log('使用直接设置scrollTop方法');
                  }
                } catch (error) {
                  console.error('滚动失败:', error);
                  // 最后的备用方案
                  bodyWrapper.scrollTop = scrollTop;
                }

                console.log('滚动到位置:', scrollTop, '行高:', rowHeight);
              }
            }

            // 延迟高亮显示目标行
            setTimeout(() => {
              this.highlightTargetRow(itemId, targetIndex);
            }, 300);
          } else {
            console.error('未找到表格或表格元素');
          }
        });
      } else {
        console.error('未找到目标行');
      }
    },

    // 高亮目标行
    highlightTargetRow (itemId, targetIndex) {
      // 移除之前的高亮
      const previousHighlight = document.querySelector('.highlight-row');
      if (previousHighlight) {
        previousHighlight.classList.remove('highlight-row');
      }

      // 添加新的高亮
      setTimeout(() => {
        const table = this.$refs.pageOneTable;
        if (table && table.$el) {
          // 尝试多种方式找到目标行
          let targetRow = null;

          // 方法1：通过row-key查找
          targetRow = table.$el.querySelector(`[data-row-key="${itemId}"]`);

          // 方法2：通过行索引查找
          if (!targetRow && typeof targetIndex === 'number') {
            const rows = table.$el.querySelectorAll('.el-table__row');
            if (rows[targetIndex]) {
              targetRow = rows[targetIndex];
            }
          }

          // 方法3：通过CSS类查找
          if (!targetRow) {
            targetRow = table.$el.querySelector(`.row-${itemId}`);
          }

          if (targetRow) {
            targetRow.classList.add('highlight-row');
            // 3秒后移除高亮
            setTimeout(() => {
              targetRow.classList.remove('highlight-row');
            }, 3000);
          } else {
            console.log('未找到目标行:', itemId, targetIndex);
          }
        }
      }, 200);
    },

    // 获取表格行的CSS类名
    getRowClassName ({ row, rowIndex }) {
      const classNames = [`row-${row.id}`, `row-level-${row.level}`];
      const prevRow = this.pageOneData[rowIndex - 1];
      const nextRow = this.pageOneData[rowIndex + 1];

      if (!prevRow || prevRow.topLevelId !== row.topLevelId) {
        classNames.push('group-start-row');
      }
      if (!nextRow || nextRow.topLevelId !== row.topLevelId) {
        classNames.push('group-end-row');
      }

      if (row.level === 3) {
        const parentId = row.id.replace(/-\d+$/, '');
        const prevParentId = prevRow && prevRow.level === 3 ? prevRow.id.replace(/-\d+$/, '') : null;
        const nextParentId = nextRow && nextRow.level === 3 ? nextRow.id.replace(/-\d+$/, '') : null;

        if (!prevRow || prevRow.level !== 3 || prevParentId !== parentId) {
          classNames.push('level-3-group-start-row');
        }
        if (!nextRow || nextRow.level !== 3 || nextParentId !== parentId) {
          classNames.push('level-3-group-end-row');
        }
      }

      return classNames.join(' ');
    },

    // 确保表格可滚动
    ensureTableScrollable () {
      this.$nextTick(() => {
        const table = this.$refs.pageOneTable;
        if (table && table.$el) {
          const bodyWrapper = table.$el.querySelector('.el-table__body-wrapper');
          if (bodyWrapper) {
            // 强制设置滚动属性
            bodyWrapper.style.overflowY = 'auto';

            console.log('表格滚动设置完成:', {
              scrollHeight: bodyWrapper.scrollHeight,
              clientHeight: bodyWrapper.clientHeight,
              overflowY: bodyWrapper.style.overflowY
            });
          }
        }
      });
    },

    // 第一页表格单元格合并方法
    pageOneTableSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 只对综合检验结果列（第3列，columnIndex = 2）进行合并
      if (columnIndex === 2) {
        // 如果当前行有子项，需要计算合并的行数
        if (row.hasChildren) {
          // 计算从当前行开始，有多少个连续的子项
          let spanCount = 1;
          for (let i = rowIndex + 1; i < this.pageOneData.length; i++) {
            const nextRow = this.pageOneData[i];
            // 如果下一行是当前行的子项（level=3且id以当前行id开头）
            if (nextRow.level === 3 && nextRow.id.startsWith(row.id + '-')) {
              spanCount++;
            } else {
              break;
            }
          }
          return {
            rowspan: spanCount,
            colspan: 1
          };
        } else if (row.level === 3) {
          // 如果是子项，检查是否是父项的第一个子项
          const parentId = row.id.replace(/-\d+$/, '');
          const parentIndex = this.pageOneData.findIndex(item => item.id === parentId);
          if (parentIndex !== -1 && parentIndex < rowIndex) {
            // 不是第一个子项，隐藏单元格
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
      // 其他列不合并
      return {
        rowspan: 1,
        colspan: 1
      };
    },

    // 保存数据为指定格式
    savePageOneData () {
      const datas = [];

      // 将result值转换为中文
      const convertResultToText = (result) => {
        if (result === 'qualified') return '符合';
        if (result === 'notApplicable') return '无此项';
        return '不符合';
      };

      this.pageOneData.forEach(item => {
        // 保存子项的检验结果（level === 3 且有result的项目）
        if (item.level === 3 && item.result && item.itemNumber) {
          datas.push({
            dataKey: item.itemNumber,
            dataValue: convertResultToText(item.result)
          });
        }

        // 保存一级综合检验结果
        if (item.hasChildren && item.autoResult && item.itemNumber && item.level === 1) {
          datas.push({
            dataKey: item.itemNumber,
            dataValue: convertResultToText(item.autoResult)
          });
        }
      });

      // 未在表格展示的二级（一级下仅一个二级时隐藏），仍从树中提交综合检验结果
      const collectLevel2AutoResults = (nodes) => {
        nodes.forEach(node => {
          if (node.level === 2 && node.autoResult && node.itemNumber) {
            datas.push({
              dataKey: node.itemNumber,
              dataValue: convertResultToText(node.autoResult)
            });
          }
          if (node.children && node.children.length > 0) {
            collectLevel2AutoResults(node.children);
          }
        });
      };
      collectLevel2AutoResults(this.pageOneTreeData);

      return {
        datas: datas
      };
    },


    // 保存第二页数据为指定格式
    savePageTwoData () {
      const datas = [];
      const getTableSamplingFloors = (tableObj) => {
        if (!tableObj) return '';
        const stationsFromColumns = Array.isArray(tableObj.columns)
          ? tableObj.columns
            .map(col => String((col && col.station) || '').trim())
            .filter(Boolean)
            .join('/')
          : '';
        const samplingFromInput = String(tableObj.samplingFloors || '').trim();
        return stationsFromColumns || samplingFromInput;
      };

      // 附表 A1.2.7.1(1) - 层门间隙（(1)(2)检测项共用本表，不再单独提交 table2）
      // 与客梯一致：含 WR 施外力门扇与门扇
      let hasTable1Data = false;
      const table1ResultKeys = ['DR', 'ZR', 'MR', 'KR', 'WR'];
      const table1Rows = ['doorToDoor', 'doorToColumn', 'doorToLintel', 'doorToSill', 'externalForceDoorToDoor'];

      table1ResultKeys.forEach((keyPrefix, rowIndex) => {
        const rowKey = table1Rows[rowIndex];
        this.getTableColumnsForSubmit(1).forEach((col, colIndex) => {
          const resultValue = col.data[rowKey]?.result;
          if (resultValue) {
            hasTable1Data = true;
            datas.push({
              dataKey: `${keyPrefix}${colIndex + 1}`,
              dataValue: resultValue
            });
          }
        });
      });
      if (hasTable1Data) {
        const table1SamplingFloors = this.getSubmitCheckFloorValue(1, this.pageTwoTable1, getTableSamplingFloors);
        if (table1SamplingFloors) {
          datas.push({
            dataKey: 'CheckFloor1',
            dataValue: table1SamplingFloors
          });
        }
      }

      // A1.2.7.2 玻璃门防拖曳措施检查记录表
      let hasTable3Data = false;

      // 无防止儿童的手被拖曳的措施 和 防止儿童的手被拖曳的措施无效
      const table3Rows = ['noMeasure', 'invalidMeasure'];
      const table3Keys = ['WF', 'FZ'];

      table3Keys.forEach((keyPrefix, rowIndex) => {
        const rowKey = table3Rows[rowIndex];
        this.getTableColumnsForSubmit(3).forEach((col, colIndex) => {
          const value = col.data[rowKey];
          if (value) {
            hasTable3Data = true;
            datas.push({
              dataKey: `${keyPrefix}${colIndex + 1}`,
              dataValue: value
            });
          }
        });
      });
      const table3SamplingFloors = this.getSubmitCheckFloorValue(3, this.pageTwoTable3, getTableSamplingFloors);
      if (hasTable3Data && table3SamplingFloors) {
        datas.push({
          dataKey: 'CheckFloor3',
          dataValue: table3SamplingFloors
        });
      }

      // A1.2.7.4(1) 门的运行与导向检查记录表
      let hasTable4Data = false;

      // 层门运行时有脱轨现象、机械卡阻现象、错位现象
      const table4Rows = ['derailment', 'jamming', 'misalignment'];
      const table4Keys = ['T', 'K', 'CW'];

      table4Keys.forEach((keyPrefix, rowIndex) => {
        const rowKey = table4Rows[rowIndex];
        this.getTableColumnsForSubmit(4).forEach((col, colIndex) => {
          const value = col.data[rowKey];
          if (value) {
            hasTable4Data = true;
            datas.push({
              dataKey: `${keyPrefix}${colIndex + 1}`,
              dataValue: value
            });
          }
        });
      });
      const table4SamplingFloors = this.getSubmitCheckFloorValue(4, this.pageTwoTable4, getTableSamplingFloors);
      if (hasTable4Data && table4SamplingFloors) {
        datas.push({
          dataKey: 'CheckFloor4',
          dataValue: table4SamplingFloors
        });
      }

      // A1.2.7.4(2) 门的运行与导向检查记录表
      let hasTable5Data = false;

      // 层门导向装置失效相关检查
      const table5Rows = ['noDevice', 'deviceInvalid'];
      const table5Keys = ['WCM', 'WBC'];

      table5Keys.forEach((keyPrefix, rowIndex) => {
        const rowKey = table5Rows[rowIndex];
        this.getTableColumnsForSubmit(5).forEach((col, colIndex) => {
          const value = col.data[rowKey];
          if (value) {
            hasTable5Data = true;
            datas.push({
              dataKey: `${keyPrefix}${colIndex + 1}`,
              dataValue: value
            });
          }
        });
      });
      const table5SamplingFloors = this.getSubmitCheckFloorValue(5, this.pageTwoTable5, getTableSamplingFloors);
      if (hasTable5Data && table5SamplingFloors) {
        datas.push({
          dataKey: 'CheckFloor5',
          dataValue: table5SamplingFloors
        });
      }

      // A1.2.7.4(3) 门的运行与导向检查记录表
      let hasTable6Data = false;

      // 底部的层门保持装置相关检查
      const table6Rows = ['noMark', 'lessThanMark'];
      const table6Keys = ['WZX', 'NXY'];

      table6Keys.forEach((keyPrefix, rowIndex) => {
        const rowKey = table6Rows[rowIndex];
        this.getTableColumnsForSubmit(6).forEach((col, colIndex) => {
          const value = col.data[rowKey];
          if (value) {
            hasTable6Data = true;
            datas.push({
              dataKey: `${keyPrefix}${colIndex + 1}`,
              dataValue: value
            });
          }
        });
      });
      const table6SamplingFloors = this.getSubmitCheckFloorValue(6, this.pageTwoTable6, getTableSamplingFloors);
      if (hasTable6Data && table6SamplingFloors) {
        datas.push({
          dataKey: 'CheckFloor6',
          dataValue: table6SamplingFloors
        });
      }

      // A1.2.7.5(1) 自动关闭层门装置检查记录表
      let hasTable7Data = false;

      // 层门自动关闭装置相关检查
      const table7Rows = ['noAutoClose', 'autoCloseInvalid'];
      const table7Keys = ['W', 'ZDSX'];

      table7Keys.forEach((keyPrefix, rowIndex) => {
        const rowKey = table7Rows[rowIndex];
        this.getTableColumnsForSubmit(7).forEach((col, colIndex) => {
          const value = col.data[rowKey];
          if (value) {
            hasTable7Data = true;
            datas.push({
              dataKey: `${keyPrefix}${colIndex + 1}`,
              dataValue: value
            });
          }
        });
      });
      const table7SamplingFloors = this.getSubmitCheckFloorValue(7, this.pageTwoTable7, getTableSamplingFloors);
      if (hasTable7Data && table7SamplingFloors) {
        datas.push({
          dataKey: 'CheckFloor7',
          dataValue: table7SamplingFloors
        });
      }

      // A1.2.7.5(2) 自动关闭层门装置检查记录表
      let hasTable8Data = false;

      // 重块式自动关闭层门装置相关检查
      const table8Rows = ['noPreventFall', 'preventFallUnreliable'];
      const table8Keys = ['WFZZ', 'FZZl'];

      table8Keys.forEach((keyPrefix, rowIndex) => {
        const rowKey = table8Rows[rowIndex];
        this.getTableColumnsForSubmit(8).forEach((col, colIndex) => {
          const value = col.data[rowKey];
          if (value) {
            hasTable8Data = true;
            datas.push({
              dataKey: `${keyPrefix}${colIndex + 1}`,
              dataValue: value
            });
          }
        });
      });
      const table8SamplingFloors = this.getSubmitCheckFloorValue(8, this.pageTwoTable8, getTableSamplingFloors);
      if (hasTable8Data && table8SamplingFloors) {
        datas.push({
          dataKey: 'CheckFloor8',
          dataValue: table8SamplingFloors
        });
      }

      // 附表 A1.2.7.6(1) 紧急开锁检查记录表
      let hasTable9Data = false;

      // 紧急开锁装置相关检查
      const table9Rows = ['noEmergencyUnlock', 'emergencyUnlockUnreliable', 'unlockStillOpen'];
      const table9Keys = ['WJJ', 'BNKQ', 'BCKS'];

      table9Keys.forEach((keyPrefix, rowIndex) => {
        const rowKey = table9Rows[rowIndex];
        this.getTableColumnsForSubmit(9).forEach((col, colIndex) => {
          const value = col.data[rowKey];
          if (value) {
            hasTable9Data = true;
            datas.push({
              dataKey: `${keyPrefix}${colIndex + 1}`,
              dataValue: value
            });
          }
        });
      });
      const table9SamplingFloors = this.getSubmitCheckFloorValue(9, this.pageTwoTable9, getTableSamplingFloors);
      if (hasTable9Data && table9SamplingFloors) {
        datas.push({
          dataKey: 'CheckFloor9',
          dataValue: table9SamplingFloors
        });
      }

      // 附表 A1.2.7.7(1) 门的锁紧与闭合检查记录表
      let hasTable10Data = false;

      // 门锁装置相关检查
      const table10Rows = ['noLockDevice', 'lockNotByGravity', 'lockNotMaintain', 'gravityCanUnlock', 'doorLockInvalid'];
      const table10Keys = ['S', 'SJ', 'B', 'SJSX', 'C'];

      table10Keys.forEach((keyPrefix, rowIndex) => {
        const rowKey = table10Rows[rowIndex];
        this.getTableColumnsForSubmit(10).forEach((col, colIndex) => {
          const value = col.data[rowKey];
          if (value) {
            hasTable10Data = true;
            datas.push({
              dataKey: `${keyPrefix}${colIndex + 1}`,
              dataValue: value
            });
          }
        });
      });
      if (hasTable10Data) {
        const table10SamplingFloors = this.getSubmitCheckFloorValue(10, this.pageTwoTable10, getTableSamplingFloors);
        if (table10SamplingFloors) {
          datas.push({
            dataKey: 'CheckFloor10',
            dataValue: table10SamplingFloors
          });
        }
      }

      // 附表 A1.2.7.7(2) 门锁啮合长度检测记录表
      let hasTable11Data = false;
      // 层门锁啮合长度 - 特殊处理，有4行lockLength，每列都有这4个lockLength
      this.getTableColumnsForSubmit(11).forEach((col, colIndex) => {
        // 遍历4行lockLength
        for (let rowIndex = 1; rowIndex <= 4; rowIndex++) {
          const lockLengthKey = `lockLength${rowIndex}`;
          const lockLengthData = col.data[lockLengthKey];

          if (lockLengthData) {
            const resultValue = lockLengthData.result;

            // 新需求：不再传 SF（层站），仅传 SR（检测结果）
            if (resultValue) {
              hasTable11Data = true;
              const dataKey = rowIndex === 1 ? `SR${colIndex + 1}` : `SR${colIndex + 1}${rowIndex}`;
              datas.push({
                dataKey: dataKey,
                dataValue: resultValue
              });
            }
          }
        }
      });

      if (hasTable11Data) {
        const table11SamplingFloors = this.getSubmitCheckFloorValue(11, this.pageTwoTable11, getTableSamplingFloors);
        if (table11SamplingFloors) {
          datas.push({
            dataKey: 'CheckFloor11',
            dataValue: table11SamplingFloors
          });
        }
      }


      // 附表 A1.2.7.7(3) 层门锁紧状态的电气安全装置检查记录表
      let hasTable12Data = false;

      // 层门锁紧状态电气安全装置相关检查
      const table12Rows = ['noElectricDevice', 'electricDeviceInvalid'];
      const table12Keys = ['D', 'Q'];

      table12Keys.forEach((keyPrefix, rowIndex) => {
        const rowKey = table12Rows[rowIndex];
        this.getTableColumnsForSubmit(12).forEach((col, colIndex) => {
          const value = col.data[rowKey];
          if (value) {
            hasTable12Data = true;
            datas.push({
              dataKey: `${keyPrefix}${colIndex + 1}`,
              dataValue: value
            });
          }
        });
      });
      const table12SamplingFloors = this.getSubmitCheckFloorValue(12, this.pageTwoTable12, getTableSamplingFloors);
      if (hasTable12Data && table12SamplingFloors) {
        datas.push({
          dataKey: 'CheckFloor12',
          dataValue: table12SamplingFloors
        });
      }

      // 附表 A1.2.7.7(4) 验证层门闭合的电气安全装置检查记录表
      let hasTable13Data = false;

      // 验证层门闭合电气安全装置相关检查
      const table13Rows = ['noVerifyDevice', 'verifyDeviceInvalid'];
      const table13Keys = ['WDQ', 'Y'];

      table13Keys.forEach((keyPrefix, rowIndex) => {
        const rowKey = table13Rows[rowIndex];
        this.getTableColumnsForSubmit(13).forEach((col, colIndex) => {
          const value = col.data[rowKey];
          if (value) {
            hasTable13Data = true;
            datas.push({
              dataKey: `${keyPrefix}${colIndex + 1}`,
              dataValue: value
            });
          }
        });
      });
      const table13SamplingFloors = this.getSubmitCheckFloorValue(13, this.pageTwoTable13, getTableSamplingFloors);
      if (hasTable13Data && table13SamplingFloors) {
        datas.push({
          dataKey: 'CheckFloor13',
          dataValue: table13SamplingFloors
        });
      }

      // 附表 A1.2.7.8 轿门门刀与层门地坎间隙检测记录表
      // 新需求：保留 CheckFloor13；不再传 MDF/MZF（层站）；仅传 MDR/MZR（检测结果）
      let hasTable14Data = false;
      const table14Rows = ['doorKnifeGap', 'rollerGap'];
      const table14ResultKeys = ['MDR', 'MZR'];

      table14ResultKeys.forEach((resultKeyPrefix, rowIndex) => {
        const rowKey = table14Rows[rowIndex];
        this.getTableColumnsForSubmit(14).forEach((col, colIndex) => {
          const resultValue = col.data[rowKey]?.result;

          if (resultValue) {
            hasTable14Data = true;
            datas.push({
              dataKey: `${resultKeyPrefix}${colIndex + 1}`,
              dataValue: resultValue
            });
          }
        });
      });
      const table14SamplingFloors = this.getSubmitCheckFloorValue(14, this.pageTwoTable14, getTableSamplingFloors);
      if (hasTable14Data && table14SamplingFloors) {
        datas.push({
          dataKey: 'CheckFloor14',
          dataValue: table14SamplingFloors
        });
      }

      // 附表 A1.3.2 电梯平衡系数测试记录表
      // 说明：
      // - 上行电流 currentUp 的 load30/40/45/50/60 分别映射为 Upload1~Upload5
      // - 下行电流 currentDown 的 load30/40/45/50/60 分别映射为 Download1~Download5
      let hasTable15Data = false;
      if (this.pageTwoTable15 && this.pageTwoTable15.currentUp) {
        const upLoads = ['load30', 'load40', 'load45', 'load50', 'load60'];
        upLoads.forEach((loadKey, index) => {
          const value = this.pageTwoTable15.currentUp[loadKey];
          if (value !== undefined && value !== null && value !== '') {
            hasTable15Data = true;
            datas.push({
              dataKey: `Upload${index + 1}`,
              dataValue: value
            });
          }
        });
      }

      if (this.pageTwoTable15 && this.pageTwoTable15.currentDown) {
        const downLoads = ['load30', 'load40', 'load45', 'load50', 'load60'];
        downLoads.forEach((loadKey, index) => {
          const value = this.pageTwoTable15.currentDown[loadKey];
          if (value !== undefined && value !== null && value !== '') {
            hasTable15Data = true;
            datas.push({
              dataKey: `Download${index + 1}`,
              dataValue: value
            });
          }
        });
      }
      if (hasTable15Data) {
        datas.push({
          dataKey: 'CheckFloor15',
          dataValue: 'A1.3.2'
        });
      }

      // 附表 A1.3.4(1) 限速器校验记录表
      let hasTable16Data = false;
      if (this.pageTwoTable16.manufacturer) {
        hasTable16Data = true;
        datas.push({
          dataKey: 'ProductionUnit',
          dataValue: this.pageTwoTable16.manufacturer
        });
      }
      if (this.pageTwoTable16.productNumber) {
        hasTable16Data = true;
        datas.push({
          dataKey: 'ProductionNum',
          dataValue: this.pageTwoTable16.productNumber
        });
      }
      if (this.pageTwoTable16.model) {
        hasTable16Data = true;
        datas.push({
          dataKey: 'Specification',
          dataValue: this.pageTwoTable16.model
        });
      }

      // 机械动作速度
      ['JXDZ1', 'JXDZ2', 'JXDZ3', 'JXDZ4', 'JXDZ5', 'JXDZ6', 'JXDZ7', 'JXDZ8'].forEach((key, index) => {
        const speedKeys = ['mechanicalSpeed', 'electricalSpeed'];
        const dataKeys = [
          ['up1', 'up2', 'up3', 'upAvg', 'down1', 'down2', 'down3', 'downAvg'],
          ['up1', 'up2', 'up3', 'upAvg', 'down1', 'down2', 'down3', 'downAvg']
        ];

        if (index < 4) {
          // 机械动作速度 (上行)
          const value = this.pageTwoTable16.mechanicalSpeed?.[dataKeys[0][index]];
          if (value) {
            hasTable16Data = true;
            datas.push({
              dataKey: key,
              dataValue: value
            });
          }
        } else {
          // 机械动作速度 (下行)
          const value = this.pageTwoTable16.mechanicalSpeed?.[dataKeys[0][index]];
          if (value) {
            hasTable16Data = true;
            datas.push({
              dataKey: key,
              dataValue: value
            });
          }
        }
      });

      // 电气动作速度
      ['DQDZ1', 'DQDZ2', 'DQDZ3', 'DQDZ4', 'DQDZ5', 'DQDZ6', 'DQDZ7', 'DQDZ8'].forEach((key, index) => {
        const dataKeys = ['up1', 'up2', 'up3', 'upAvg', 'down1', 'down2', 'down3', 'downAvg'];
        const value = this.pageTwoTable16.electricSpeed?.[dataKeys[index]];
        if (value) {
          hasTable16Data = true;
          datas.push({
            dataKey: key,
            dataValue: value
          });
        }
      });
      if (hasTable16Data) {
        datas.push({
          dataKey: 'CheckFloor16',
          dataValue: 'A1.3.4(1)'
        });
      }

      // 附表 A1.3.14 噪声测试记录表
      let hasTable17Data = false;
      // 四个噪声项目对应的背景值
      ['BJS1', 'BJS2', 'BJS3', 'BJS4'].forEach((key, index) => {
        const backgroundKeys = ['machineRoom', 'carInside', 'doorNoise', 'noMachineRoom'];
        const value = this.pageTwoTable17[backgroundKeys[index]]?.background;
        if (value) {
          hasTable17Data = true;
          datas.push({
            dataKey: key,
            dataValue: value
          });
        }
      });

      // 机房噪声测试点
      ['JFZS1', 'JFZS2', 'JFZS3'].forEach((key, index) => {
        const pointKey = `point${index + 1}`;
        const value = this.pageTwoTable17.machineRoom?.[pointKey];
        if (value) {
          hasTable17Data = true;
          datas.push({
            dataKey: key,
            dataValue: value
          });
        }
      });

      // 轿厢内噪声
      if (this.pageTwoTable17.carInside?.up) {
        hasTable17Data = true;
        datas.push({
          dataKey: 'NZS1',
          dataValue: this.pageTwoTable17.carInside.up
        });
      }
      if (this.pageTwoTable17.carInside?.down) {
        hasTable17Data = true;
        datas.push({
          dataKey: 'NZS2',
          dataValue: this.pageTwoTable17.carInside.down
        });
      }

      // 开关门噪声
      if (this.pageTwoTable17.doorNoise?.open) {
        hasTable17Data = true;
        datas.push({
          dataKey: 'MZS1',
          dataValue: this.pageTwoTable17.doorNoise.open
        });
      }
      if (this.pageTwoTable17.doorNoise?.close) {
        hasTable17Data = true;
        datas.push({
          dataKey: 'MZS2',
          dataValue: this.pageTwoTable17.doorNoise.close
        });
      }

      // 无机房电梯层门处噪声
      if (this.pageTwoTable17.noMachineRoom?.up) {
        hasTable17Data = true;
        datas.push({
          dataKey: 'WZJZS1',
          dataValue: this.pageTwoTable17.noMachineRoom.up
        });
      }
      if (this.pageTwoTable17.noMachineRoom?.down) {
        hasTable17Data = true;
        datas.push({
          dataKey: 'WZJZS2',
          dataValue: this.pageTwoTable17.noMachineRoom.down
        });
      }

      // 测试结果
      ['TestResult1', 'TestResult2', 'TestResult3', 'TestResult4'].forEach((key, index) => {
        const resultKeys = ['machineRoom', 'carInside', 'doorNoise', 'noMachineRoom'];
        const value = this.pageTwoTable17[resultKeys[index]]?.result;
        if (value) {
          hasTable17Data = true;
          datas.push({
            dataKey: key,
            dataValue: value
          });
        }
      });
      if (hasTable17Data) {
        datas.push({
          dataKey: 'CheckFloor17',
          dataValue: 'A1.3.14'
        });
      }

      return datas;
    },
    handleFloorSetting () {
      const hasSavedFloorSetting = !!(
        this.floorSettingData &&
        (
          this.floorSettingData.id ||
          String(this.floorSettingData.floorDoorNumbers || '').trim() ||
          (Array.isArray(this.floorSettingData.checkStations) && this.floorSettingData.checkStations.length > 0)
        )
      );

      const floorStationDoor = String(this.equipmentInfo.floorStationDoor || '').trim();
      const firstFloorSegment = floorStationDoor.split('层/')[0];
      const parsedTotalDoors = /^[1-9]\d*$/.test(firstFloorSegment) ? firstFloorSegment : '';

      // 仅首次打开（未保存过层站设置）时，优先使用 additionalData.ELEFLOORNUMBER 作为默认层门总数
      // 已保存过配置时，沿用已保存值，不在此处覆盖
      if (!hasSavedFloorSetting) {
        const eleFloorNumber = this.additionalDataList && this.additionalDataList.ELEFLOORNUMBER;
        const defaultTotalDoors = /^[1-9]\d*$/.test(String(eleFloorNumber || '').trim())
          ? String(eleFloorNumber).trim()
          : parsedTotalDoors;

        if (defaultTotalDoors) {
          this.floorSettingData = {
            ...this.floorSettingData,
            totalDoors: defaultTotalDoors
          };
        }
      } else if (parsedTotalDoors && !String(this.floorSettingData.totalDoors || '').trim()) {
        // 已保存场景下若本地 totalDoors 意外为空，再做一次解析补齐
        this.floorSettingData = {
          ...this.floorSettingData,
          totalDoors: parsedTotalDoors
        };
      }

      this.floorSettingDialogVisible = true;
    },
    //层站设置保存
    handleFloorSettingSave (payload) {
      this.floorSettingData = {
        ...payload,
        checkStations: Array.isArray(payload.checkStations) ? payload.checkStations : [],
        floorOptions: Array.isArray(payload.floorOptions) ? payload.floorOptions : []
      };

      // 立即按新层站重建附表列并回填，避免仍保留参照时的 30 列结构
      this.applyCheckStationsToTables();
      this.refillPageTwoDataAfterTableRebuild();
      if (this.additionalDataList && Array.isArray(this.additionalDataList.datas)) {
        this.additionalDataList.datas = this.trimReferenceDatasToCurrentFloorSetting(this.additionalDataList.datas);
      }
      this.syncAdditionalDataListPageTwoFromUI();

      // 层/站/门与层门编号保持一致，方便后续附表动态表格使用
      // this.equipmentInfo.floorStationDoor = payload.floorDoorNumbers || '';

      this.saveOrUpdateElevatorSetting();
    },
    async fetchElevatorSetting (options = {}) {
      const skipRefill = !!(options && options.skipRefill);
      try {
        const res = await getElevatorSetting(this.recordInfo.entrustNum);
        const data = (res && (res.data || res.additionalData || res.result || res)) || {};
        const payload = data && data.additionalData && Object.keys(data.additionalData || {}).length > 0
          ? data.additionalData
          : data;
        if (!payload) return;
        this.applyElevatorSettingToLocal(payload);
        // 应用完层站配置后，按需动态渲染各附表列
        this.applyCheckStationsToTables();
        // 关键：重建附表列会清空 columns.data，需要立即按已保存 datas 再回填一次附表值
        if (!skipRefill) {
          this.refillPageTwoDataAfterTableRebuild();
        }
      } catch (e) {
        console.warn('查询层站设置信息失败：', e);
        if (options && options.rethrow) {
          throw e;
        }
      }
    },
    // 在附表列结构重建后，基于 additionalDataList.datas 重新回填附表数据
    refillPageTwoDataAfterTableRebuild () {
      if (!this.additionalDataList || !Array.isArray(this.additionalDataList.datas)) {
        return;
      }

      this.additionalDataList.datas.forEach(item => {
        if (!item || !item.dataKey) return;
        const { dataKey, dataValue } = item;
        // 只处理附表字段，避免影响第一页或其它字段
        if (this.isPageTwoDataKey(dataKey)) {
          this.fillPageTwoData(dataKey, dataValue);
        }
      });
    },
    applyElevatorSettingToLocal (setting) {
      if (!setting) return;
      const minStr = setting.minElefloor != null ? String(setting.minElefloor) : '1';
      const maxStr = setting.maxElefloor != null ? String(setting.maxElefloor) : '';
      let totalDoors = '';
      // 最低层数支持负数，需用 -?\d+ 而非 \d+（否则 minElefloor=-2 时无法反算层门总数）
      if (/^-?\d+$/.test(minStr) && /^-?\d+$/.test(maxStr)) {
        const diff = Number(maxStr) - Number(minStr) + 1;
        totalDoors = diff > 0 ? String(diff) : '';
      }
      const finalDoorType = setting.elefloorType === '贯通门' ? 'through' : 'normal';
      const openType = setting.doorOperType === '旁开门' ? 'side' : 'center';
      const carDoorLock = Number(setting.elevatorGateLock) === 1 ? 'yes' : 'no';
      const floorDoorNumbers = setting.elefloorNumber || '';
      const checkStations = String(setting.checkElefloor || '')
        .split('/')
        .map(s => String(s || '').trim())
        .filter(s => s);

      const floorOptions = String(floorDoorNumbers || '')
        .split('/')
        .map(s => String(s || '').trim())
        .filter(s => s)
        .map(v => ({ label: v, value: v }));

      this.floorSettingData = {
        id: setting.id,
        minFloor: minStr || '1',
        totalDoors: totalDoors,
        doorType: finalDoorType,
        openType: openType,
        carDoorLock: carDoorLock,
        floorDoorNumbers: floorDoorNumbers,
        checkStations: checkStations,
        floorOptions: floorOptions
      };

      // 根据 checkStations 动态调整附表列和“抽查层站”展示
      this.applyCheckStationsToTables();
    },
    // 将 checkStations 应用到各个附表：动态列数 + 抽查层站标题
    applyCheckStationsToTables () {
      const ctx = this.getFloorSettingStationContext();
      const { hasConfig, floorDoorStations, withoutLock, withLock, getTableStations, buildTable11Stations } = ctx;
      // 更新“抽查层站：...”展示
      const setSamplingFloors = (tableObj, stations, shouldSet) => {
        if (tableObj && Object.prototype.hasOwnProperty.call(tableObj, 'samplingFloors')) {
          if (shouldSet && stations && stations.length) {
            tableObj.samplingFloors = stations.join('/');
          } else {
            // 无配置时保持原有行为（不自动填充抽查层站，让用户输入）
            // 配置存在但剔除后为空时，清空
            if (hasConfig) {
              tableObj.samplingFloors = '';
            }
          }
        }
      };

      // 简单型表格（每列是简单字符串值）生成器
      const buildSimpleColumns = (tableKey, count, stations = null) => {
        return Array.from({ length: count }, (_, i) => ({
          id: `${tableKey}-col-${i}`,
          label: `第${i + 1}列`,
          station: stations && stations[i] ? stations[i] : '',
          data: {}
        }));
      };

      // 针对不同表格填充其 data 结构的键
      const fillSimpleDataKeys = (columns, keys) => {
        columns.forEach(col => {
          const data = {};
          keys.forEach(k => { data[k] = '' });
          col.data = data;
        });
      };

      // 分割型表格生成器
      // includeFloor=true: 生成 { floor, result }（兼容旧表）
      // includeFloor=false: 生成 { result }（新需求：不传层站）
      const buildSplitColumns = (tableKey, count, keys, stations = null, includeFloor = true) => {
        return Array.from({ length: count }, (_, i) => ({
          id: `${tableKey}-col-${i}`,
          label: `第${i + 1}列`,
          station: stations && stations[i] ? stations[i] : '',
          data: keys.reduce((acc, k) => {
            // 新需求下，部分附表不再维护 floor，仅保留 result
            const stationVal = stations && stations[i] ? String(stations[i]) : '';
            acc[k] = includeFloor ? { floor: stationVal, result: '' } : { result: '' };
            return acc;
          }, {})
        }));
      };

      // 1) A1.2.7.1(1) 表格1 - 需要轿门（split型：doorToDoor/doorToColumn/doorToLintel/doorToSill）
      if (this.pageTwoTable1) {
        const stations = hasConfig ? getTableStations(withLock, 'table1') : null;
        setSamplingFloors(this.pageTwoTable1, stations, hasConfig);
        const count = stations ? stations.length : 13;
        // 与客梯一致：含施外力门扇与门扇
        this.pageTwoTable1.columns = buildSplitColumns('table1', count, ['doorToDoor', 'doorToColumn', 'doorToLintel', 'doorToSill', 'externalForceDoorToDoor'], stations, false);
      }
      // 2) A1.2.7.1(2) 表格2 - 需要轿门（split型）
      if (this.pageTwoTable2) {
        const stations = hasConfig ? getTableStations(withLock, 'table2') : null;
        setSamplingFloors(this.pageTwoTable2, stations, hasConfig);
        const count = stations ? stations.length : 13;
        this.pageTwoTable2.columns = buildSplitColumns('table2', count, ['doorToDoor', 'doorToColumn', 'doorToLintel', 'doorToSill', 'externalForceDoorToDoor'], stations, false);
      }
      // 3) A1.2.7.4(1) 表格4 - 不需要轿门（simple型：derailment/jamming/misalignment）
      if (this.pageTwoTable4) {
        const stations = hasConfig ? withoutLock : null;
        setSamplingFloors(this.pageTwoTable4, stations, hasConfig);
        const cols = buildSimpleColumns('table4', stations ? stations.length : 13, stations);
        fillSimpleDataKeys(cols, ['derailment', 'jamming', 'misalignment']);
        this.pageTwoTable4.columns = cols;
      }
      // 4) A1.2.7.4(2) 表格5 - 不需要轿门（simple型：noDevice/deviceInvalid）
      if (this.pageTwoTable5) {
        const stations = hasConfig ? withoutLock : null;
        setSamplingFloors(this.pageTwoTable5, stations, hasConfig);
        const cols = buildSimpleColumns('table5', stations ? stations.length : 13, stations);
        fillSimpleDataKeys(cols, ['noDevice', 'deviceInvalid']);
        this.pageTwoTable5.columns = cols;
      }
      // 5) A1.2.7.4(3) 表格6 - 不需要轿门（simple型：noMark/lessThanMark）
      if (this.pageTwoTable6) {
        const stations = hasConfig ? withoutLock : null;
        setSamplingFloors(this.pageTwoTable6, stations, hasConfig);
        const cols = buildSimpleColumns('table6', stations ? stations.length : 13, stations);
        fillSimpleDataKeys(cols, ['noMark', 'lessThanMark']);
        this.pageTwoTable6.columns = cols;
      }
      // 6) A1.2.7.5(1) 表格7 - 不需要轿门（simple型：noAutoClose/autoCloseInvalid）
      if (this.pageTwoTable7) {
        const stations = hasConfig ? withoutLock : null;
        setSamplingFloors(this.pageTwoTable7, stations, hasConfig);
        const cols = buildSimpleColumns('table7', stations ? stations.length : 13, stations);
        fillSimpleDataKeys(cols, ['noAutoClose', 'autoCloseInvalid']);
        this.pageTwoTable7.columns = cols;
      }
      // 7) A1.2.7.5(2) 表格8 - 不需要轿门（simple型：noPreventFall/preventFallUnreliable）
      if (this.pageTwoTable8) {
        const stations = hasConfig ? withoutLock : null;
        setSamplingFloors(this.pageTwoTable8, stations, hasConfig);
        const cols = buildSimpleColumns('table8', stations ? stations.length : 13, stations);
        fillSimpleDataKeys(cols, ['noPreventFall', 'preventFallUnreliable']);
        this.pageTwoTable8.columns = cols;
      }
      // 8) A1.2.7.6(1) 表格9 - 不需要轿门（simple型：noEmergencyUnlock/emergencyUnlockUnreliable/unlockStillOpen）
      if (this.pageTwoTable9) {
        const stations = hasConfig ? withoutLock : null;
        setSamplingFloors(this.pageTwoTable9, stations, hasConfig);
        const cols = buildSimpleColumns('table9', stations ? stations.length : 13, stations);
        fillSimpleDataKeys(cols, ['noEmergencyUnlock', 'emergencyUnlockUnreliable', 'unlockStillOpen']);
        this.pageTwoTable9.columns = cols;
      }
      // 9) A1.2.7.7(1) 表格10 - 需要轿门（simple型：noLockDevice/lockNotByGravity/lockNotMaintain/gravityCanUnlock/doorLockInvalid）
      if (this.pageTwoTable10) {
        const stations = hasConfig ? getTableStations(withLock, 'table10') : null;
        // 与其他附表一致，维护抽查层站用于提交 CheckFloor10
        setSamplingFloors(this.pageTwoTable10, stations, hasConfig);
        const cols = buildSimpleColumns('table10', stations ? stations.length : 13, stations);
        fillSimpleDataKeys(cols, ['noLockDevice', 'lockNotByGravity', 'lockNotMaintain', 'gravityCanUnlock', 'doorLockInvalid']);
        this.pageTwoTable10.columns = cols;
      }
      // 10) A1.2.7.7(2) 表格11 - 按层门编号 + 按门类型固定追加轿门
      if (this.pageTwoTable11) {
        const stations = buildTable11Stations(floorDoorStations);

        const count = stations.length > 0 ? stations.length : 13;
        this.pageTwoTable11.columns = buildSplitColumns(
          'table11',
          count,
          ['project', 'lockLength1', 'lockLength2', 'lockLength3', 'lockLength4'],
          stations.length > 0 ? stations : null,
          false // 新需求：表11不再传层站
        );
      }

      // 11) A1.2.7.7(3) 表格12 - 需要轿门（simple型：noElectricDevice/electricDeviceInvalid）
      if (this.pageTwoTable12) {
        const stations = hasConfig ? withLock : null;
        setSamplingFloors(this.pageTwoTable12, stations, hasConfig);
        const cols = buildSimpleColumns('table12', stations ? stations.length : 13, stations);
        fillSimpleDataKeys(cols, ['noElectricDevice', 'electricDeviceInvalid']);
        this.pageTwoTable12.columns = cols;
      }
      // 12) A1.2.7.7(4) 表格13 - 需要轿门（simple型：noVerifyDevice/verifyDeviceInvalid）
      if (this.pageTwoTable13) {
        const stations = hasConfig ? withLock : null;
        setSamplingFloors(this.pageTwoTable13, stations, hasConfig);
        const cols = buildSimpleColumns('table13', stations ? stations.length : 13, stations);
        fillSimpleDataKeys(cols, ['noVerifyDevice', 'verifyDeviceInvalid']);
        this.pageTwoTable13.columns = cols;
      }
      // 13) A1.2.7.8 表格14 - 不需要轿门（split型：doorKnifeGap/rollerGap），与 table10 等同走 getTableStations
      if (this.pageTwoTable14) {
        const stations = hasConfig ? getTableStations(withLock, 'table14') : null;
        setSamplingFloors(this.pageTwoTable14, stations, hasConfig);
        const count = stations ? stations.length : 13;
        // 新需求：表14不再传层站
        this.pageTwoTable14.columns = buildSplitColumns('table14', count, ['doorKnifeGap', 'rollerGap'], stations, false);
      }
    },
    async saveOrUpdateElevatorSetting (options = {}) {
      const silent = !!(options && options.silent);
      const skipRefill = !!(options && options.skipRefill);
      try {
        const form = this.floorSettingData || {};
        const min = Number(String(form.minFloor || '1').trim());
        const total = Number(String(form.totalDoors || '').trim());
        const max = Number.isFinite(min) && Number.isFinite(total) ? (min + total - 1) : undefined;

        const apiPayload = {
          entrustNum: this.recordInfo.entrustNum,
          minElefloor: Number.isFinite(min) ? min : undefined,
          maxElefloor: Number.isFinite(max) ? max : undefined,
          elefloorType: form.doorType === 'through' ? '贯通门' : '普通门',
          doorOperType: form.openType === 'side' ? '旁开门' : '中开门',
          elevatorGateLock: form.carDoorLock === 'yes' ? 1 : 2,
          elefloorNumber: String(form.floorDoorNumbers || '').trim(),
          checkElefloor: (Array.isArray(form.checkStations) ? form.checkStations : []).join('/')
        };

        let res;
        if (form.id) {
          res = await updateElevatorSetting({ id: form.id, ...apiPayload });
        } else {
          res = await saveElevatorSetting(apiPayload);
        }

        const data = (res && (res.data || res.additionalData || res.result || res)) || {};
        if (data && (data.id || (data.additionalData && data.additionalData.id))) {
          this.floorSettingData.id = data.id || data.additionalData.id;
        }

        // 成功后立刻重新查询，获取最新完整数据（含id等），避免不同步
        if (this.recordInfo.entrustNum) {
          await this.fetchElevatorSetting({ skipRefill, rethrow: silent });
        }

        if (!silent) {
          this.$message.success('层站设置已保存');
        }
      } catch (e) {
        console.error('保存层站设置失败：', e);
        if (!silent) {
          this.$message.error('层站设置保存失败，请重试');
        } else {
          throw e;
        }
      }
    },
    // 参照回填：将参照单的层站配置同步到当前单（本地 floorSettingData + 附表列结构 + 后台持久化）
    async syncReferenceElevatorSetting (elevSettingData) {
      const setting = elevSettingData && elevSettingData.additionalData
        ? elevSettingData.additionalData
        : elevSettingData;
      if (!setting || typeof setting !== 'object') {
        return false;
      }
      if (!this.recordInfo || !this.recordInfo.entrustNum) {
        throw new Error('缺少委托编号，无法同步层站设置');
      }

      const currentSettingId = this.floorSettingData && this.floorSettingData.id
        ? this.floorSettingData.id
        : undefined;

      // 1. 先写入本地，确保 floorSettingData 与附表 columns 立即按参照层站重建
      this.applyElevatorSettingToLocal({
        ...setting,
        id: currentSettingId
      });

      // 2. 保存到当前单后台，并重新拉取以确保本地与后台一致（参照阶段跳过附表值回填，由后续 fillFormData 统一处理）
      await this.saveOrUpdateElevatorSetting({ silent: true, skipRefill: true });

      return true;
    },
    // 测试保存功能（可以在控制台查看结果）
    testSaveData () {
      console.log('当前pageOneData：', this.pageOneData);
      console.log('Level 3 items with itemNumber:', this.pageOneData.filter(item => item.level === 3 && item.itemNumber));
      console.log('Level 3 items with result:', this.pageOneData.filter(item => item.level === 3 && item.result));

      const pageOneResult = this.savePageOneData();
      const pageTwoResult = this.savePageTwoData();

      const allData = {
        datas: [...pageOneResult.datas, ...pageTwoResult]
      };

      console.log('第一页保存的数据：', JSON.stringify(pageOneResult, null, 2));
      console.log('第二页保存的数据：', JSON.stringify({ datas: pageTwoResult }, null, 2));
      console.log('合并后的数据格式：', JSON.stringify(allData, null, 2));
      this.$message.success('数据已输出到控制台，请按F12查看');
    },

    // 从URL参数初始化页面
    async initPageFromRoute () {
      this.pageLoading = true; // 开始加载

      console.log('接收到的url prop:', this.url);

      // 从url prop中解析查询参数
      let queryParams = {};
      if (this.url && this.url.includes('?')) {
        const queryString = this.url.split('?')[1];
        const urlParams = new URLSearchParams(queryString);
        urlParams.forEach((value, key) => {
          queryParams[key] = value;
        });
      }

      const dataKey = queryParams.dataKey;
      console.log('解析出的查询参数:', queryParams);
      console.log('获取到的dataKey:', dataKey);

      let recordData = {};

      if (dataKey) {
        // 从sessionStorage获取数据
        const storedData = sessionStorage.getItem(dataKey);
        console.log('从sessionStorage读取的原始数据:', storedData);
        if (storedData) {
          try {
            recordData = JSON.parse(storedData);
            console.log('从sessionStorage获取的数据:', recordData); this.recordData = recordData
            // 使用完后清理数据
            sessionStorage.removeItem(dataKey);
          } catch (error) {
            console.error('解析sessionStorage数据失败:', error);
          }
        } else {
          console.warn('sessionStorage中没有找到dataKey对应的数据:', dataKey);
        }
      } else {
        // 兼容旧的URL参数方式
        recordData = {
          entrustNum: queryParams.entrustNum || '',
          useUnitName: queryParams.useUnitName || '',
          elevatorCode: queryParams.elevatorCode || '',
          status: queryParams.status || '',
          productNumber: queryParams.productNumber || '',
          equipmentName: queryParams.equipmentName || ''
        };
        console.log('从URL参数获取的数据:', recordData);
      }

      // 设置记录信息
      this.recordInfo = {
        entrustNum: recordData.entrustNum || '',
        useUnitName: recordData.useUnitName || '',
        elevatorCode: recordData.elevatorCode || '',
        status: recordData.status || '',
        productNumber: recordData.productNumber || '',
        equipmentName: recordData.equipmentName || '',
        configReportPid: recordData.configReportPid || '',
        FIRST_YEAR: recordData.FIRST_YEAR || '',
      };

      const today = new Date();
      const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

      // 初始化封面信息
      this.coverInfo = {
        entrustNum: this.recordInfo.entrustNum,
        useUnitName: this.recordInfo.useUnitName,
        // equipmentCode: this.recordInfo.elevatorCode,
        testDate: this.coverInfo.testDate || todayString,
        qrcodeImage: '',
        qrcodeBase64: ''
      };

      console.log('初始化记录信息4:', this.recordInfo.equipmentName);

      try {
        // 并行执行初始化操作
        const initPromises = [
          // 初始化页面数据
          Promise.resolve(this.initializePageOneData()),
          // 获取人员选项
          this.getDetectionPersonnelOptions(),
          // this.getReviewPersonnelOptions(),
          // 获取设备选项
          this.getEquipmentOptions()
        ];

        // 如果有委托编号，加载暂存数据
        if (this.recordInfo.entrustNum) {
          initPromises.push(this.loadSavedData(this.recordInfo.entrustNum, this.recordInfo.status, this.recordInfo.FIRST_YEAR));
        }

        // 等待所有初始化操作完成
        await Promise.all(initPromises);

        // 初始化已选设备列表
        this.updateSelectedEquipments();

        // 自动加载工具箱及对应设备：
        // 只有 status===9（未录入）才需要默认工具箱/默认设备；其他状态走接口回填（datas）即可，避免覆盖已保存数据
        if (Number(this.recordInfo.status) === 9) {
          await this.loadToolboxEqptInfos();
        }

        // 进入时查询层站设置
        if (this.recordInfo.entrustNum) {
          await this.fetchElevatorSetting();
        }

        console.log('原始记录页面初始化完成');
      } catch (error) {
        console.error('初始化原始记录页面失败:', error);
        this.$message.error('初始化页面失败，请重试');
      } finally {
        this.pageLoading = false; // 结束加载
      }
    },

    // 返回上一页
    goBack () {
      // 在这个框架中，通过关闭当前标签页来返回
      // 尝试找到父组件的removeTab方法
      let parent = this.$parent;
      while (parent && !parent.removeTab) {
        parent = parent.$parent;
      }

      if (parent && parent.removeTab) {
        // 刷新父页面列表数据
        this.refreshParentList();

        // 获取当前标签页的name并关闭
        const currentTabName = parent.editableTabsValue;
        parent.removeTab(currentTabName);
      } else {
        // 如果找不到removeTab方法，尝试其他方式
        // 可以通过window.close()或者其他方式
        console.log('无法找到父组件的removeTab方法');
        // 作为备选方案，可以发送事件给父组件
        this.$emit('close');
      }
    },

    // 刷新父页面列表
    refreshParentList () {
      try {
        // 尝试通过 sessionStorage 触发父页面刷新
        const refreshKey = 'needRefreshOriginalManagement';
        sessionStorage.setItem(refreshKey, Date.now().toString());

        // 尝试直接调用父页面的刷新方法
        let parent = window.parent;
        if (parent && parent !== window) {
          // 尝试找到原始管理列表页面并触发刷新
          const frames = parent.frames;
          for (let i = 0; i < frames.length; i++) {
            try {
              const frame = frames[i];
              if (frame && frame.$vm && frame.$vm.$children) {
                // 查找原始管理列表组件
                const findListComponent = (components) => {
                  for (let comp of components) {
                    if (comp.$options && comp.$options.name === 'OriginalManagementList') {
                      return comp;
                    }
                    if (comp.$children && comp.$children.length > 0) {
                      const found = findListComponent(comp.$children);
                      if (found) return found;
                    }
                  }
                  return null;
                };

                const listComp = findListComponent(frame.$vm.$children);
                if (listComp && typeof listComp.getList === 'function') {
                  listComp.getList();
                  console.log('成功刷新父页面列表');
                  return;
                }
              }
            } catch (e) {
              // 跨域或其他错误，继续尝试
            }
          }
        }

        console.log('已设置刷新标记，父页面将在下次激活时刷新');
      } catch (error) {
        console.error('刷新父页面失败:', error);
      }
    },
    // 获取所有检验结果
    getAllResults () {
      const results = [];

      const collectResults = (nodes) => {
        nodes.forEach(node => {
          if (node.level === 3 && node.result) {
            results.push({
              id: node.id,
              itemNumber: node.itemNumber,
              description: node.description,
              result: node.result
            });
          }
          if (node.children) {
            collectResults(node.children);
          }
        });
      };

      collectResults(this.pageOneTreeData);
      return results;
    },

    // 二维码上传前的校验
    beforeQrcodeUpload (file) {
      const isImage = file.type.indexOf('image/') === 0;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('上传文件只能是图片格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },

    // 处理二维码上传
    handleQrcodeUpload (options) {
      const file = options.file;
      const reader = new FileReader();

      reader.onload = (e) => {
        const base64 = e.target.result;
        // 存储完整的base64数据用于显示
        this.coverInfo.qrcodeImage = base64;
        // 存储base64数据（去掉data:image/...;base64,前缀）用于提交
        this.coverInfo.qrcodeBase64 = base64.split(',')[1];

        this.$message.success('二维码上传成功!');
      };

      reader.onerror = () => {
        this.$message.error('图片读取失败!');
      };

      reader.readAsDataURL(file);
    },

    // 人员图片上传前的校验

    // 提交合并用：去掉值为 undefined 的顶层键，避免覆盖 additionalDataList 中接口带回的有效字段
    omitUndefinedTopLevel (obj) {
      if (!obj || typeof obj !== 'object') return obj;
      return Object.keys(obj).reduce((acc, key) => {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
      }, {});
    },

    // 构建API数据结构
    buildApiData () {
      // 构建字段映射数据结构
      const apiData = {
        // 封面信息字段映射
        recordNum: this.coverInfo.recordNum, // «recordNum»
        IMG_recordNumQrcode: this.coverInfo.qrcodeBase64, // «IMG_recordNumQrcode»
        USE_UNT_NAME: this.coverInfo.useUnitName, // «USE_UNT_NAME»
        EQP_STATION_COD: this.coverInfo.EQP_STATION_COD, // «EQP_STATION_COD»
        testDate: this.coverInfo.testDate, // «testDate»
        entrustNum: this.coverInfo.entrustNum,
        // 设备信息字段映射
        EQP_INNER_COD: this.equipmentInfo.unitInternalNumber, // «EQP_INNER_COD»
        USE_UNT_COD: this.equipmentInfo.USE_UNT_COD, // «USE_UNT_COD»
        EQP_VART_NAME: this.equipmentInfo.equipmentType, // «EQP_VART_NAME»
        EQP_SORT_NAME: this.coverInfo.EQP_SORT_NAME || this.equipmentInfo.eqpSortName || undefined, // «EQP_SORT_NAME»（与 fillCoverInfo 一致）
        EQP_AREA_NAME: this.equipmentInfo.installLocation, // «EQP_AREA_NAME»
        EQP_MOD: this.equipmentInfo.productModel, // «EQP_MOD»
        EQP_USECERT_COD: this.equipmentInfo.registrationNumber, // «EQP_USECERT_COD»
        FACTORY_COD: this.equipmentInfo.productNumber, // «FACTORY_COD»
        powerSupply: this.equipmentInfo.powerSupply,
        humidity: this.equipmentInfo.humidity,
        temperature: this.equipmentInfo.temperature,
        MAKE_UNT_NAME: this.equipmentInfo.manufacturerName, // «MAKE_UNT_NAME»
        MAKE_DATE: this.equipmentInfo.manufactureDate, // «MAKE_DATE»
        renovation_unt_name: this.equipmentInfo.renovationUnitName, // «renovation_unt_name»
        renovation_date: this.equipmentInfo.renovationDate, // «renovation_date»
        service_unt_name: this.equipmentInfo.maintenanceUnit, // «service_unt_name»
        SAFE_MEN: this.equipmentInfo.safetyManager, // «SAFE_MEN»
        RATEDLOAD: this.equipmentInfo.ratedLoad, // «RATEDLOAD»
        FLOOR_STADE_DOOR: this.equipmentInfo.floorStationDoor, // «FLOOR_STADE_DOOR»
        RATEDVELOCITY: this.equipmentInfo.ratedSpeed, // «RATEDVELOCITY»
        RUNVELOCITY: (() => {
          const rv = this.equipmentInfo.runVelocity;
          if (rv === '' || rv === null || rv === undefined) return undefined;
          return rv;
        })(), // «RUNVELOCITY»（0 为有效值）
        CONTROL_TYPE: this.equipmentInfo.controlMethod, // «CONTROL_TYPE»
        OIDNO: this.equipmentInfo.oidNo || undefined,
        EQP_NAME: this.equipmentInfo.equipmentName || undefined,
        EQP_TEMP_NAME: this.equipmentInfo.eqpTempName || undefined,
        EQP_USE_ADDR: this.equipmentInfo.eqpUseAddr || undefined,
        ELEFLOORNUMBER: this.equipmentInfo.eleFloorNumber != null ? this.equipmentInfo.eleFloorNumber : undefined,
        ELESTADENUMBER: this.equipmentInfo.eleStadeNumber != null ? this.equipmentInfo.eleStadeNumber : undefined,
        ELEDOORNUMBER: this.equipmentInfo.eleDoorNumber != null ? this.equipmentInfo.eleDoorNumber : undefined,
        ELEHEIGHT: (this.equipmentInfo.eleHeight === '' || this.equipmentInfo.eleHeight === null || this.equipmentInfo.eleHeight === undefined)
          ? undefined
          : this.equipmentInfo.eleHeight,
        SLIDWAY_USE_LENG: (this.equipmentInfo.slidwayUseLeng === '' || this.equipmentInfo.slidwayUseLeng === null || this.equipmentInfo.slidwayUseLeng === undefined)
          ? undefined
          : this.equipmentInfo.slidwayUseLeng,
        FIRST_YEAR: this.equipmentInfo.firstYear || this.recordInfo.FIRST_YEAR || undefined,
        testEmployeePid: this.equipmentInfo.detectionPersonnel, // 检测人员
        checkEmployeePid: this.equipmentInfo.reviewPersonnel, // 校核人员

        // 其他表单数据
        standardData: this.equipmentInfo.standardData,
        testConclusion: this.equipmentInfo.problemSummary ? this.equipmentInfo.problemSummary.replace(/\n/g, '\\n') : '', // «testConclusion» - 检测问题汇总
        testConclusionDesc: this.equipmentInfo.remarks ? this.equipmentInfo.remarks.replace(/\n/g, '\\n') : '', // «testConclusionDesc» - 备注
        nextTestDate: this.equipmentInfo.nextTestDate, // «nextTestDate» - 下次检测日期
        nextCheckDate: this.equipmentInfo.nextCheckDate, // «nextCheckDate» - 下次检验日期
        IMG_test: this.equipmentInfo.detectionPersonnelBase64, // «IMG_test» - 检测人员签名图片
        IMG_audit: this.equipmentInfo.reviewPersonnelBase64, // «IMG_audit» - 校核人员签名图片
        testEmployeeDate: this.equipmentInfo.detectionDate, // «testEmployeeDate» - 检测日期

        // 检验结果
        inspectionResults: this.getAllResults(),


        environmentConditions: {
          // 第1-7条独立确认结果
          condition1Result: this.environmentConditionsData[0]?.confirmResult || '',
          condition2Result: this.environmentConditionsData[1]?.confirmResult || '',
          condition3Result: this.environmentConditionsData[2]?.confirmResult || '',
          condition4Result: this.environmentConditionsData[3]?.confirmResult || '',
          condition5Result: this.environmentConditionsData[4]?.confirmResult || '',
          condition6Result: this.environmentConditionsData[5]?.confirmResult || '',
          condition7Result: this.environmentConditionsData[6]?.confirmResult || '',
          // 第8条“其他：无”仅展示，无确认结果
          condition8Result: '',
          allConditions: this.environmentConditionsData // 完整的环境条件数据
        },

        // 各种表格数据
        // pageTwoTableData: {
        //   table1: this.pageTwoTable1,
        //   table2: this.pageTwoTable2,
        //   table3: this.pageTwoTable3,
        //   table4: this.pageTwoTable4,
        //   table5: this.pageTwoTable5,
        //   table6: this.pageTwoTable6,
        //   table7: this.pageTwoTable7,
        //   table8: this.pageTwoTable8,
        //   table9: this.pageTwoTable9,
        //   table10: this.pageTwoTable10,
        //   table11: this.pageTwoTable11,
        //   table12: this.pageTwoTable12,
        //   table13: this.pageTwoTable13,
        //   table14: this.pageTwoTable14,
        //   table15: this.pageTwoTable15,
        //   table16: this.pageTwoTable16,
        //   table17: this.pageTwoTable17
        // }
      };

      return apiData;
    },

    // 根据 pageOneTreeData.js 的树结构推导 testItemChildName
    // 规则：找到叶子节点（level=3对应的 configTestItemsContentCode）在树中的祖先链，
    // 返回链路最顶层节点的 itemNumber（去掉前导'*'）。
    // 如果树中找不到，则兜底使用按 '.' 截前三段的策略。
    getTestItemChildName (configTestItemsContentCode) {
      if (!configTestItemsContentCode || typeof configTestItemsContentCode !== 'string') return '';

      const normalize = (s) => {
        const v = String(s || '');
        return v.startsWith('*') ? v.substring(1) : v;
      };

      const target = normalize(configTestItemsContentCode);
      const tree = this.pageOneTreeData && Array.isArray(this.pageOneTreeData) ? this.pageOneTreeData : [];

      const findPath = (nodes) => {
        for (const node of nodes) {
          const nodeNum = normalize(node && (node.itemNumber || node.id));
          if (nodeNum && nodeNum === target) {
            return [node];
          }
          if (node && Array.isArray(node.children) && node.children.length > 0) {
            const childPath = findPath(node.children);
            if (childPath) return [node].concat(childPath);
          }
        }
        return null;
      };

      const path = findPath(tree);
      if (path && path.length > 0) {
        const topNode = path[0];
        const topVal = normalize(topNode && (topNode.itemNumber || topNode.id));
        return topVal || '';
      }

      // 兜底：按 '.' 截前三段
      const parts = target.split('.');
      if (parts.length >= 3) return parts.slice(0, 3).join('.');
      return target;
    },

    // 构建提交参数：infoList
    // 目标结构：
    // infoList: [{
    //   testItemChildName: 'A1.1.1',
    //   configTestItemsContentCode: 'A1.1.1.1.1',
    //   unqualifiedDetail: '[{ ...detail... }, ...]'
    // }]
    // 规则：遍历 additionalDataList.datas 中保存的“详情明细数组”(包含 contentDetailPid 的 JSON)，
    // 先筛选出 checkResult = 0 的明细，再按 configTestItemsContentCode 分组。
    buildInfoList (extraDatas = []) {
      const infoList = [];
      const baseDatas = this.additionalDataList && Array.isArray(this.additionalDataList.datas)
        ? this.additionalDataList.datas
        : [];
      // 仅允许“当前第一页结果为不符合”的检验项进入 infoList 自定义补充逻辑
      const unqualifiedCodeSet = new Set(
        (Array.isArray(this.pageOneData) ? this.pageOneData : [])
          .filter(item => item && item.level === 3 && item.result === 'unqualified' && item.itemNumber)
          .map(item => item.itemNumber)
      );
      const isCurrentUnqualified = code => !!code && unqualifiedCodeSet.has(code);
      const mergedDatas = baseDatas.concat(Array.isArray(extraDatas) ? extraDatas : []);
      if (mergedDatas.length === 0) {
        return infoList;
      }

      // key: configTestItemsContentCode（叶子编号，如 A1.1.1.1.1）
      // value: 该检验项下所有“不符合”的详情明细数组
      const groupMap = new Map();
      const seen = new Set(); // 避免同一 contentDetailPid 在同一检验项下重复

      // 附表表头(CheckFloor) 与检验项/显示编号映射
      const floorToAppendixConfigMap = {
        CheckFloor1: { appendixText: 'A1.2.7.1(1)', leafCode: 'A1.2.7.1.1' },
        CheckFloor3: { appendixText: 'A1.2.7.2' },
        CheckFloor4: { appendixText: 'A1.2.7.4(1)' },
        CheckFloor5: { appendixText: 'A1.2.7.4(2)' },
        CheckFloor6: { appendixText: 'A1.2.7.4(3)' },
        CheckFloor7: { appendixText: 'A1.2.7.5(1)' },
        CheckFloor8: { appendixText: 'A1.2.7.5(2)' },
        CheckFloor9: { appendixText: 'A1.2.7.6(1)' },
        CheckFloor10: { appendixText: 'A1.2.7.7(1)' },
        CheckFloor11: { appendixText: 'A1.2.7.7(2)' },
        CheckFloor12: { appendixText: 'A1.2.7.7(3)' },
        CheckFloor13: { appendixText: 'A1.2.7.7(4)' },
        CheckFloor14: { appendixText: 'A1.2.7.8' },
        CheckFloor15: { appendixText: 'A1.3.2' },
        // A1.3.4(1) 的明细实际落在 A1.3.4.1.1，需显式指定叶子编号避免拆成两条
        CheckFloor16: { appendixText: 'A1.3.4(1)', leafCode: 'A1.3.4.1.1' },
        CheckFloor17: { appendixText: 'A1.3.14' },
      };

      // 把附表编号文本转换为提交用的叶子 configTestItemsContentCode
      // - A1.2.7.5(1) -> A1.2.7.5.1
      // - A1.2.7.1 -> A1.2.7.1.1
      const appendixToLeafCode = (appendixText) => {
        const raw = String(appendixText || '').trim();
        if (!raw) return '';
        if (raw.includes('(') && raw.includes(')')) {
          return raw.replace('(', '.').replace(')', '');
        }
        return `${raw}.1`;
      };
      // key: configTestItemsContentCode，value: { appendixNo, floorValue }
      const floorReferenceMap = new Map();

      const buildFloorReferenceDetail = (code, appendixNo) => ({
        configReportPid: this.recordData ? this.recordData.configReportPid : null,
        configTestItemsContentCode: code,
        checkResult: 0,
        detailContent: `详见附表 ${appendixNo}`
      });

      mergedDatas.forEach(d => {
        if (!d || !d.dataValue) return;

        try {
          // 先识别附表表头，作为“不符合详情补充”依据
          if (typeof d.dataKey === 'string' && floorToAppendixConfigMap[d.dataKey]) {
            const floorValue = String(d.dataValue || '').trim();
            if (floorValue) {
              const config = floorToAppendixConfigMap[d.dataKey];
              const leafCode = (config && config.leafCode) || appendixToLeafCode(config && config.appendixText);
              if (leafCode) {
                floorReferenceMap.set(leafCode, {
                  appendixNo: config.appendixText,
                  floorValue
                });
              }
            }
            return;
          }

          const parsed = JSON.parse(d.dataValue);
          if (!Array.isArray(parsed) || parsed.length === 0) return;
          // 兼容历史：旧版本把“未勾选详情占位”存进 datas，这里迁移为 infoList 结构
          if (
            d.dataKey &&
            d.dataKey.startsWith('__UNQUALIFIED_CUSTOM__') &&
            parsed[0] &&
            parsed[0].configTestItemsContentCode
          ) {
            const code = parsed[0].configTestItemsContentCode;
            if (!isCurrentUnqualified(code)) return;
            infoList.push({
              testItemChildName: this.getTestItemChildName(code),
              configTestItemsContentCode: code,
              unqualifiedDetail: JSON.stringify([{
                configReportPid: parsed[0].configReportPid || (this.recordData ? this.recordData.configReportPid : null),
                configTestItemsContentCode: code,
                checkResult: 0
              }])
            });
            return;
          }
          if (!parsed[0] || !parsed[0].contentDetailPid) return; // 只处理详情明细数组

          const groupCheckResult = parsed[0].checkResult ?? 0;

          parsed.forEach(item => {
            if (!item || !item.contentDetailPid) return;

            const cr = item.checkResult ?? groupCheckResult;
            if (Number(cr) !== 0) return; // 只要“不符合”

            const code = item.configTestItemsContentCode || parsed[0].configTestItemsContentCode || d.dataKey;
            if (!code) return;
            if (!isCurrentUnqualified(code)) return;

            const dupKey = `${code}__${item.contentDetailPid}`;
            if (seen.has(dupKey)) return;
            seen.add(dupKey);

            const list = groupMap.get(code) || [];
            list.push({
              ...item,
              checkResult: 0 // 明确标记为“不符合”
            });
            groupMap.set(code, list);
          });
        } catch (e) {
          // 非 JSON 或非详情结构，忽略
        }
      });

      // 按检验项组装最终结构
      groupMap.forEach((details, code) => {
        if (!details || details.length === 0) return;

        // 已存在“不符合详情”时，附加“详见附表xxxx”
        const floorReference = floorReferenceMap.get(code);
        if (floorReference && floorReference.appendixNo) {
          details.push(buildFloorReferenceDetail(code, floorReference.appendixNo));
        }

        const testItemChildName = this.getTestItemChildName(code);

        infoList.push({
          testItemChildName,
          configTestItemsContentCode: code,
          // 后端需要字符串形式的 JSON 数组
          unqualifiedDetail: JSON.stringify(details)
        });
      });

      // 合并弹窗内“未勾选详情”的自定义记录（去重：同 code 只保留一条）
      if (Array.isArray(this.unqualifiedCustomInfoList) && this.unqualifiedCustomInfoList.length > 0) {
        const existedCodeSet = new Set(infoList.map(i => i && i.configTestItemsContentCode).filter(Boolean));
        this.unqualifiedCustomInfoList.forEach(item => {
          if (!item || !item.configTestItemsContentCode || existedCodeSet.has(item.configTestItemsContentCode)) return;
          if (!isCurrentUnqualified(item.configTestItemsContentCode)) return;

          // “不符合且未勾选详情”场景：若附表有值，则把空白 detailContent 改为“详见附表xxxx”
          const floorReference = floorReferenceMap.get(item.configTestItemsContentCode);
          if (!floorReference || !floorReference.appendixNo) {
            infoList.push(item);
            existedCodeSet.add(item.configTestItemsContentCode);
            return;
          }

          let unqualifiedDetailList = [];
          try {
            const parsed = JSON.parse(item.unqualifiedDetail);
            if (Array.isArray(parsed)) {
              unqualifiedDetailList = parsed;
            }
          } catch (e) {
            unqualifiedDetailList = [];
          }

          const floorReferenceDetail = buildFloorReferenceDetail(
            item.configTestItemsContentCode,
            floorReference.appendixNo
          );
          if (unqualifiedDetailList.length === 0) {
            unqualifiedDetailList.push(floorReferenceDetail);
          } else {
            const target = unqualifiedDetailList[0] || {};
            unqualifiedDetailList[0] = {
              ...target,
              configReportPid: target.configReportPid || floorReferenceDetail.configReportPid,
              configTestItemsContentCode: target.configTestItemsContentCode || floorReferenceDetail.configTestItemsContentCode,
              checkResult: 0,
              detailContent: floorReferenceDetail.detailContent
            };
          }

          infoList.push({
            ...item,
            unqualifiedDetail: JSON.stringify(unqualifiedDetailList)
          });
          existedCodeSet.add(item.configTestItemsContentCode);
        });
      }

      // 只要附表表头(CheckFloorX)有值，就确保对应检验项在 infoList 中至少有一条“详见附表xxx”记录。
      // 说明：该记录不依赖详情分组/占位数据，避免只填附表但没勾选详情时丢失“详见附表”信息。
      if (floorReferenceMap && floorReferenceMap.size > 0) {
        const existedCodeSet = new Set(infoList.map(i => i && i.configTestItemsContentCode).filter(Boolean));
        floorReferenceMap.forEach((floorReference, code) => {
          if (!code) return;
          if (!isCurrentUnqualified(code)) return;
          if (!floorReference || !floorReference.appendixNo) return;
          const floorReferenceDetail = buildFloorReferenceDetail(code, floorReference.appendixNo);

          // 已存在该 code：保留勾选详情，并确保最终附加一条“详见附表”；
          // 若仅有空白占位，则替换为“详见附表”单条。
          if (existedCodeSet.has(code)) {
            const target = infoList.find(i => i && i.configTestItemsContentCode === code);
            if (!target) return;
            let detailList = [];
            try {
              const parsed = JSON.parse(target.unqualifiedDetail);
              if (Array.isArray(parsed)) detailList = parsed;
            } catch (e) {
              detailList = [];
            }
            const withoutFloor = detailList.filter(detail => {
              const txt = detail && typeof detail.detailContent === 'string' ? detail.detailContent.trim() : '';
              return !txt.startsWith('详见附表');
            });
            const hasOnlyBlankPlaceholder = withoutFloor.length === 1 &&
              withoutFloor[0] &&
              !withoutFloor[0].contentDetailPid &&
              (withoutFloor[0].detailContent == null || String(withoutFloor[0].detailContent).trim() === '');
            const mergedList = hasOnlyBlankPlaceholder
              ? [floorReferenceDetail]
              : [...withoutFloor, floorReferenceDetail];
            target.unqualifiedDetail = JSON.stringify(mergedList);
            return;
          }

          infoList.push({
            testItemChildName: this.getTestItemChildName(code),
            configTestItemsContentCode: code,
            unqualifiedDetail: JSON.stringify([floorReferenceDetail])
          });
          existedCodeSet.add(code);
        });
      }

      return infoList;
    },

    reference () {
      if (this.referenceFilling || this.pageLoading) return;
      this.referenceDialogVisible = true;
    },

    // 处理参照数据确认
    async handleReferenceConfirm (payload) {
      if (this.referenceFilling) return;

      console.log('=== 开始回填参照数据 ===');
      console.log('接收到的数据:', payload);

      this.referenceFilling = true;
      this.referenceDialogVisible = false;

      try {
        const elevSettingData = payload && payload.elevSettingData ? payload.elevSettingData : null;
        const rawDatas = payload && Array.isArray(payload.datas)
          ? payload.datas
          : (Array.isArray(payload) ? payload : []);
        const data = this.stripToolboxFromReferenceData({
          ...(payload && !Array.isArray(payload) ? payload : {}),
          datas: rawDatas
        });
        delete data.elevSettingData;

        if (!data || typeof data !== 'object') {
          this.$message.warning('返回数据格式不正确');
          return;
        }

        // 1. 先同步参照单的层站配置（本地 + 后台），附表 columns 依赖层站数据渲染
        if (elevSettingData && typeof elevSettingData === 'object') {
          await this.syncReferenceElevatorSetting(elevSettingData);
        } else {
          this.$message.warning('参照数据缺少层站设置，附表可能无法正确回填');
        }

        // 2. 层站同步后再裁剪附表 datas，避免列数不一致时多出隐藏层数据
        data.datas = this.trimReferenceDatasToCurrentFloorSetting(data.datas || rawDatas);

        // 3. 参照不回填工具箱/仪器设备，仅回填检测项、附表、封面等
        this.additionalDataList = data;
        this.initPreviousSelectedDetailPids();
        this.initDetailSelectedCacheFromDatas();

        // 统一回填（fillFormData -> fillLegacyData -> fillPageTwoData 写入各附表单元格）
        this.fillFormData(data, { skipToolbox: true });

        // 用当前 UI 附表数据回写 additionalDataList，剔除超出当前层站列数的隐藏数据
        this.syncAdditionalDataListPageTwoFromUI();

        this.$message.success('参照数据回填成功');
      } catch (error) {
        console.error('回填数据失败:', error);
        this.$message.error('回填数据失败，请查看控制台');
      } finally {
        this.referenceFilling = false;
        console.log('=== 回填完成 ===');
      }
    },

    // 回填检测结果数据
    fillTestResults (datas) {
      console.log('开始回填检测结果数据:', datas);

      let successCount = 0;

      // 遍历返回的数据，匹配并回填到 pageOneData
      datas.forEach(item => {
        const dataKey = item.dataKey;
        const dataValue = item.dataValue;

        // 去掉可能的*前缀
        const cleanDataKey = dataKey.startsWith('*') ? dataKey.substring(1) : dataKey;

        // 在 pageOneData 中查找对应的项目
        const targetRow = this.pageOneData.find(row => row.itemNumber === cleanDataKey);

        if (targetRow && targetRow.level === 3) {
          // 将文本结果转换为内部值
          let resultValue = '';
          if (dataValue === '符合' || dataValue === '合格') {
            resultValue = 'qualified';
          } else if (dataValue === '不符合' || dataValue === '不合格') {
            resultValue = 'unqualified';
          } else if (dataValue === '无此项') {
            resultValue = 'notApplicable';
          } else {
            // 如果是其他值，尝试直接使用
            resultValue = dataValue;
          }

          targetRow.result = resultValue;
          successCount++;
          console.log(`回填 ${cleanDataKey}: ${dataValue} -> ${resultValue}`);
        }
      });

      console.log(`成功回填 ${successCount} 条数据`);

      // 重新计算综合检验结果 - 遍历所有 level 3 项目并更新父级
      const level3Items = this.pageOneData.filter(item => item.level === 3 && item.result);
      level3Items.forEach(item => {
        this.updateParentAutoResult(item);
      });

      // 强制刷新表格以更新样式
      this.$nextTick(() => {
        if (this.$refs.pageOneTable) {
          this.$refs.pageOneTable.doLayout();
        }
      });
    },

    // 提交表单
    handleSubmit (type) {
      // 提交中禁止重复点击；完成后关页前也保持 loading，避免再点保存冲掉 OperatorDate
      if (this.loading) return;

      console.log('下次检测日期:', this.equipmentInfo.nextTestDate);
      console.log('下次检验日期:', this.equipmentInfo.nextCheckDate);

      // [已停用] 保存前曾根据详情向备注追加文本；备注改由后台计算
      // // 先收集新勾选详情文本，添加到备注中（不符合和无此项的详情可以添加；符合的详情不添加，除了configTestItemsContentCode为"A1.3.12.1"的符合项）
      // this.collectAndAppendDetailTextsToRemarks();

      // 提交前统一清洗附表数据，并按当前层门编号/检查层站规则校验列数后再写入提交体
      ['table1', 'table2', 'table11', 'table14'].forEach(tid => this.sanitizeAttachmentFloorResultData(tid));

      this.loading = true;
      // 构建API数据（备注 equipmentInfo.remarks 由后台回填或用户在此编辑）
      const apiData = this.buildApiData();
      // 合并第一页和第二页的数据（附表列数以层站规则为准，避免参照后 UI 仍保留多余列）
      const pageOneData = this.savePageOneData().datas;
      const pageTwoData = this.trimReferenceDatasToCurrentFloorSetting(this.savePageTwoData());
      // 新增：提交参数 infoList（勾选的不符合明细）
      // 传入 pageTwoData，确保本次提交时最新的 CheckFloorX 值能参与“详见附表”拼装。
      apiData.infoList = this.buildInfoList(pageTwoData);
      apiData.datas = [...pageOneData, ...pageTwoData];
      // 处理dataKey，去除开头的*号（后端识别不了*）
      apiData.datas = apiData.datas.map(item => ({
        ...item,
        dataKey: item.dataKey.startsWith('*') ? item.dataKey.substring(1) : item.dataKey
      }));

      // 提交工具箱号（用于下次打开回填）
      // 先剔除同 key 的旧值，避免重复导致取值不确定
      const toolboxKey = this.getToolboxDataKey();
      apiData.datas = apiData.datas.filter(d => !(d && d.dataKey === toolboxKey));
      if (this.selectedToolboxNum) {
        apiData.datas.push({
          dataKey: toolboxKey,
          dataValue: this.selectedToolboxNum
        });
      }

      // 将设备仪器数据添加到datas数组中(包含名称、管理编号、使用记录)
      const equipmentData = [
        {
          index: 0,
          key: 'EquipmentName01',
          name: this.getEquipmentNameById(this.instrumentTableData[0]?.name),
          mgmtNo: this.instrumentTableData[0]?.managementNumber,
          usage: this.instrumentTableData[0]?.usageRecord
        },
        {
          index: 1,
          key: 'EquipmentName02',
          name: this.getEquipmentNameById(this.instrumentTableData[1]?.name),
          mgmtNo: this.instrumentTableData[1]?.managementNumber,
          usage: this.instrumentTableData[1]?.usageRecord
        },
        {
          index: 2,
          key: 'EquipmentName03',
          name: this.getEquipmentNameById(this.instrumentTableData[2]?.name),
          mgmtNo: this.instrumentTableData[2]?.managementNumber,
          usage: this.instrumentTableData[2]?.usageRecord
        },
        {
          index: 3,
          key: 'EquipmentName04',
          name: this.getEquipmentNameById(this.instrumentTableData[3]?.name),
          mgmtNo: this.instrumentTableData[3]?.managementNumber,
          usage: this.instrumentTableData[3]?.usageRecord
        },
        {
          index: 4,
          key: 'EquipmentName05',
          name: this.getEquipmentNameById(this.instrumentTableData[4]?.name),
          mgmtNo: this.instrumentTableData[4]?.managementNumber,
          usage: this.instrumentTableData[4]?.usageRecord
        },
        {
          index: 5,
          key: 'EquipmentName06',
          name: this.getEquipmentNameById(this.instrumentTableData[5]?.name),
          mgmtNo: this.instrumentTableData[5]?.managementNumber,
          usage: this.instrumentTableData[5]?.usageRecord
        },
        {
          index: 6,
          key: 'EquipmentName07',
          name: this.getEquipmentNameById(this.instrumentTableData[6]?.name),
          mgmtNo: this.instrumentTableData[6]?.managementNumber,
          usage: this.instrumentTableData[6]?.usageRecord
        },
        {
          index: 7,
          key: 'EquipmentName08',
          name: this.getEquipmentNameById(this.instrumentTableData[7]?.name),
          mgmtNo: this.instrumentTableData[7]?.managementNumber,
          usage: this.instrumentTableData[7]?.usageRecord
        },
        {
          index: 8,
          key: 'EquipmentName09',
          name: this.getEquipmentNameById(this.instrumentTableData[8]?.name),
          mgmtNo: this.instrumentTableData[8]?.managementNumber,
          usage: this.instrumentTableData[8]?.usageRecord
        },
        {
          index: 9,
          key: 'EquipmentName10',
          name: this.getEquipmentNameById(this.instrumentTableData[9]?.name),
          mgmtNo: this.instrumentTableData[9]?.managementNumber,
          usage: this.instrumentTableData[9]?.usageRecord
        },
        {
          index: 0,
          key: 'EquipmentName11',
          name: this.getEquipmentNameById(this.instrumentTableData[0]?.name2),
          mgmtNo: this.instrumentTableData[0]?.managementNumber2,
          usage: this.instrumentTableData[0]?.usageRecord2
        },
        {
          index: 1,
          key: 'EquipmentName12',
          name: this.getEquipmentNameById(this.instrumentTableData[1]?.name2),
          mgmtNo: this.instrumentTableData[1]?.managementNumber2,
          usage: this.instrumentTableData[1]?.usageRecord2
        },
        {
          index: 2,
          key: 'EquipmentName13',
          name: this.getEquipmentNameById(this.instrumentTableData[2]?.name2),
          mgmtNo: this.instrumentTableData[2]?.managementNumber2,
          usage: this.instrumentTableData[2]?.usageRecord2
        },
        {
          index: 3,
          key: 'EquipmentName14',
          name: this.getEquipmentNameById(this.instrumentTableData[3]?.name2),
          mgmtNo: this.instrumentTableData[3]?.managementNumber2,
          usage: this.instrumentTableData[3]?.usageRecord2
        },
        {
          index: 4,
          key: 'EquipmentName15',
          name: this.getEquipmentNameById(this.instrumentTableData[4]?.name2),
          mgmtNo: this.instrumentTableData[4]?.managementNumber2,
          usage: this.instrumentTableData[4]?.usageRecord2
        },
        {
          index: 5,
          key: 'EquipmentName16',
          name: this.getEquipmentNameById(this.instrumentTableData[5]?.name2),
          mgmtNo: this.instrumentTableData[5]?.managementNumber2,
          usage: this.instrumentTableData[5]?.usageRecord2
        },
        {
          index: 6,
          key: 'EquipmentName17',
          name: this.getEquipmentNameById(this.instrumentTableData[6]?.name2),
          mgmtNo: this.instrumentTableData[6]?.managementNumber2,
          usage: this.instrumentTableData[6]?.usageRecord2
        },
        {
          index: 7,
          key: 'EquipmentName18',
          name: this.getEquipmentNameById(this.instrumentTableData[7]?.name2),
          mgmtNo: this.instrumentTableData[7]?.managementNumber2,
          usage: this.instrumentTableData[7]?.usageRecord2
        },
        {
          index: 8,
          key: 'EquipmentName19',
          name: this.getEquipmentNameById(this.instrumentTableData[8]?.name2),
          mgmtNo: this.instrumentTableData[8]?.managementNumber2,
          usage: this.instrumentTableData[8]?.usageRecord2
        },
        {
          index: 9,
          key: 'EquipmentName20',
          name: this.getEquipmentNameById(this.instrumentTableData[9]?.name2),
          mgmtNo: this.instrumentTableData[9]?.managementNumber2,
          usage: this.instrumentTableData[9]?.usageRecord2
        },
      ];

      // 单独添加 Result01-07 数据到 datas（第1-7条独立确认）
      apiData.datas.push({
        dataKey: 'Result01',
        dataValue: this.environmentConditionsData[0]?.confirmResult == 'qualified' ? '是' : '否',// «Result1» - 第1条结果
      });
      apiData.datas.push({
        dataKey: 'Result02',
        dataValue: this.environmentConditionsData[1]?.confirmResult == 'qualified' ? '是' : '否',// «Result2» - 第2条结果
      });
      apiData.datas.push({
        dataKey: 'Result03',
        dataValue: this.environmentConditionsData[2]?.confirmResult == 'qualified' ? '是' : '否',// «Result3» - 第3条结果
      });
      apiData.datas.push({
        dataKey: 'Result04',
        dataValue: this.environmentConditionsData[3]?.confirmResult == 'qualified' ? '是' : '否',// «Result4» - 第4条结果
      });
      apiData.datas.push({
        dataKey: 'Result05',
        dataValue: this.environmentConditionsData[4]?.confirmResult == 'qualified' ? '是' : '否',// «Result5» - 第5条结果
      });
      apiData.datas.push({
        dataKey: 'Result06',
        dataValue: this.environmentConditionsData[5]?.confirmResult == 'qualified' ? '是' : '否',// «Result6» - 第6条结果
      });
      apiData.datas.push({
        dataKey: 'Result07',
        dataValue: this.environmentConditionsData[6]?.confirmResult == 'qualified' ? '是' : '否',// «Result7» - 第7条结果
      });

      // 只添加有名称的设备数据，分别保存名称、管理编号、使用记录
      equipmentData.forEach(item => {
        if (item.name) {
          // 保存设备名称
          apiData.datas.push({
            dataKey: item.key,
            dataValue: item.name
          });

          // 保存管理编号
          const mgmtKey = item.key.replace('EquipmentName', 'MgmtNo');
          if (item.mgmtNo) {
            apiData.datas.push({
              dataKey: mgmtKey,
              dataValue: item.mgmtNo
            });
          }

          // 保存使用记录
          const usageKey = item.key.replace('EquipmentName', 'V');
          if (item.usage) {
            apiData.datas.push({
              dataKey: usageKey,
              dataValue: item.usage
            });
          }
        }
      });

      // 添加详情数据（从additionalDataList.datas中获取）
      if (this.additionalDataList && this.additionalDataList.datas && Array.isArray(this.additionalDataList.datas)) {
        // 先筛选出"看起来是详情数据"的项，并解析出第一条明细，方便后续去重 / 选优
        const rawDetailItems = this.additionalDataList.datas
          .map(item => {
            if (!item.dataKey || !item.dataValue) return null;
            // 自定义占位数据已迁移至 infoList，不再以 datas 明细提交
            if (item.dataKey.startsWith('__UNQUALIFIED_CUSTOM__')) return null;
            try {
              const parsed = JSON.parse(item.dataValue);
              if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].contentDetailPid) {
                return { item, firstDetail: parsed[0] };
              }
            } catch (e) {
              return null;
            }
            return null;
          })
          .filter(v => v);

        // 按同一个 configTestItemsContentCode 去重：
        // - 如果有老数据（没有 detailCode）和新数据（有 detailCode），优先保留"有 detailCode 的"
        const mergedDetailMap = {};
        rawDetailItems.forEach(({ item, firstDetail }) => {
          const code = firstDetail.configTestItemsContentCode || item.dataKey;
          const existed = mergedDetailMap[code];
          if (!existed) {
            mergedDetailMap[code] = { item, firstDetail };
          } else {
            const existedHasDetailCode = !!(existed.firstDetail && existed.firstDetail.detailCode);
            const currentHasDetailCode = !!firstDetail.detailCode;
            // 当前这条有 detailCode，而已有那条没有，则用当前的覆盖
            if (!existedHasDetailCode && currentHasDetailCode) {
              mergedDetailMap[code] = { item, firstDetail };
            }
          }
        });

        // 将去重后的详情数据添加到提交数据中
        Object.values(mergedDetailMap).forEach(({ item, firstDetail }) => {
          // 先去掉*号
          let detailKey = item.dataKey.startsWith('*') ? item.dataKey.substring(1) : item.dataKey;

          // 如果明细里已经带有 detailCode（如 A1.1.1.1.1-4），则优先使用它作为 dataKey
          if (firstDetail && firstDetail.detailCode) {
            detailKey = firstDetail.detailCode;
          }

          // 如果与检验结果或其他数据使用同一个 dataKey（例如 A1.1.1.1.1），
          // 则在提交详情数据时追加后缀 "-4"，避免覆盖检验结果数据
          if (apiData.datas.some(d => d.dataKey === detailKey)) {
            // 如果本身已经是 detailCode（如 A1.1.1.1.1-4），则不重复追加
            if (!/-\d+$/.test(detailKey)) {
              detailKey = `${detailKey}-4`;
            }
          }

          apiData.datas.push({
            dataKey: detailKey,
            dataValue: item.dataValue
          });
        });
      }

      apiData.type = type
      // 修改合并顺序:让apiData覆盖additionalDataList,确保用户修改的值不会被覆盖
      // 去掉 apiData 中值为 undefined 的键，避免 JSON 序列化丢键后覆盖掉 additionalDataList 里接口已带回的字段
      const apiPayload = this.omitUndefinedTopLevel(apiData);
      let data = { ...this.additionalDataList, ...apiPayload, configReportPid: this.recordInfo.configReportPid }
      saveTestData(data).then(response => {
        console.log(response);
        // this.$message.success('原始记录录入成功');
        if (response.retCode == "ok") {
          this.$message.success('原始记录录入成功');
          if (type == 3 || type === '3') {
            // 完成后保持禁用直到关页，防止延迟关闭期间再点保存删除 OperatorDate
            setTimeout(() => {
              this.goBack();
            }, 1500); // 延迟1.5秒让用户看到成功消息
            return;
          }
        } else {
          this.$message.error(response.retMsg || '录入失败');
        }
        this.loading = false;
        // 保存成功后关闭当前标签页

      }).catch(error => {
        this.$message.error('录入失败：' + error.message);
        this.loading = false;
      });

      // 模拟提交处理
      console.log('完整的API数据：', apiData);

      // setTimeout(() => {
      //   this.$message.success('原始记录录入成功');
      //   this.handleClose();
      //   this.$emit('refresh');
      //   this.loading = false;
      // }, 1000);
    },

    // 初始化 initialSelectedDetailPids，从 additionalDataList 中读取页面加载时的初始状态（用于判断新勾选的项）
    initPreviousSelectedDetailPids () {
      this.initialSelectedDetailPids = {};

      if (!this.additionalDataList || !this.additionalDataList.datas || !Array.isArray(this.additionalDataList.datas)) {
        return;
      }

      // 遍历所有详情数据，记录每个检验项的已保存详情PID列表（这是页面加载时的初始状态）
      this.additionalDataList.datas.forEach(item => {
        if (!item || !item.dataValue) return;

        try {
          const parsed = JSON.parse(item.dataValue);
          if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].contentDetailPid) {
            const configTestItemsContentCode = parsed[0].configTestItemsContentCode;
            if (configTestItemsContentCode) {
              // 记录该检验项的所有已保存详情PID（页面加载时的初始状态）
              this.$set(this.initialSelectedDetailPids, configTestItemsContentCode,
                parsed.map(detail => detail.contentDetailPid).filter(pid => pid));
            }
          }
        } catch (e) {
          // 忽略解析错误
        }
      });

      console.log('初始化 initialSelectedDetailPids (页面加载时的初始状态):', this.initialSelectedDetailPids);
    },

    // 格式化详情文本，处理${}占位符的情况
    formatDetailContent (detailItem) {
      if (!detailItem || !detailItem.detailContent) {
        return '';
      }

      let content = String(detailItem.detailContent);

      // 如果包含${}占位符，需要替换为实际值
      // 详情数据在保存时，${}已经被替换为${值}的格式
      // 例如：'允许值${var1}mm' 保存后变成 '允许值${333}mm'
      // 我们需要提取${}中的值并替换，只保留值，不保留${}符号
      if (this.hasDetailPlaceholders(content)) {
        const reg = /\$\{([^}]*)\}/g;
        content = content.replace(reg, (match, value) => {
          // 如果${}中有值，就使用这个值；如果没有值，保持空字符串
          return value != null && value !== '' ? value : '';
        });
      }

      return content;
    },

    // 收集新勾选详情文本，添加到备注中
    // 注意：现在只对检验项 "A1.3.12.1" 生效，避免对其它项目的备注进行全局修改
    collectAndAppendDetailTextsToRemarks () {
      if (!this.additionalDataList || !this.additionalDataList.datas || !Array.isArray(this.additionalDataList.datas)) {
        console.log('collectAndAppendDetailTextsToRemarks: additionalDataList 不存在或为空');
        return;
      }

      // 仅“曳引式客梯”才进行保存前的备注汇总追加
      if (this.recordInfo.equipmentName !== '曳引式客梯') {
        console.log(`设备 ${this.recordInfo.equipmentName}: 不参与保存前备注汇总追加（仅 曳引式客梯 生效）`)
        return
      }

      const detailTexts = [];

      // 先遍历additionalDataList.datas，找出所有详情数据
      this.additionalDataList.datas.forEach(detailDataItem => {
        if (!detailDataItem || !detailDataItem.dataValue) return;

        try {
          const parsed = JSON.parse(detailDataItem.dataValue);
          if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].contentDetailPid) {
            const configTestItemsContentCode = parsed[0].configTestItemsContentCode;

            // 现在整体备注追加只处理 "A1.3.12.1"，其它检验项不再参与
            // 注意：不要再根据设备名称放开限制，否则会把其它检验项的详情也追加进备注
            if (configTestItemsContentCode !== 'A1.3.12.1') {
              return;
            }

            // 在pageOneData中查找对应的检验项
            const matchedItem = this.pageOneData.find(item =>
              item.level === 3 &&
              item.result &&
              item.itemNumber === configTestItemsContentCode &&
              (item.result === 'qualified' || item.result === 'unqualified' || item.result === 'notApplicable')
            );

            if (matchedItem) {
              // 仅在三种有效状态下处理（符合/不符合/无此项）
              if (!['qualified', 'unqualified', 'notApplicable'].includes(matchedItem.result)) {
                console.log(`检验项 ${configTestItemsContentCode} (${matchedItem.result}): 状态不参与整体备注联动`);
                return;
              }

              // 获取页面加载时的初始详情PID列表（用于判断哪些是新勾选的）
              const initialPids = this.initialSelectedDetailPids[configTestItemsContentCode] || [];

              console.log(`检验项 ${configTestItemsContentCode} (${matchedItem.result}): 页面加载时的初始详情PID:`, initialPids);
              console.log(`检验项 ${configTestItemsContentCode}: 当前选中的详情数量:`, parsed.length);

              // 遍历所有选中的详情项，只处理新勾选的项（不在页面加载时的初始列表中）
              parsed.forEach(detail => {
                if (detail && detail.contentDetailPid && detail.detailContent) {
                  // 判断是否是新勾选的（不在页面加载时的初始列表中）
                  const isNewlySelected = !initialPids.includes(detail.contentDetailPid);

                  console.log(`详情 ${detail.contentDetailPid}: 是否新勾选=${isNewlySelected}, 初始PID列表包含=${initialPids.includes(detail.contentDetailPid)}`);

                  if (isNewlySelected) {
                    const formattedText = this.formatDetailContent(detail);
                    console.log(`新勾选的详情: ${detail.contentDetailPid}, 原始内容: ${detail.detailContent}, 格式化后的文本:`, formattedText);
                    if (formattedText) {
                      // 构建要添加的文本：只添加"问题描述"，不加检验项编号前缀
                      const textToAdd = `${formattedText}`;

                      // 检查备注中是否已经包含该文本，避免重复添加
                      const remarksText = this.equipmentInfo.remarks || '';
                      const isAlreadyInRemarks = remarksText.includes(textToAdd);

                      console.log(`文本 "${textToAdd}" 是否已在备注中: ${isAlreadyInRemarks}`);

                      if (!isAlreadyInRemarks) {
                        // 添加详情文本（不含编号前缀）
                        detailTexts.push(textToAdd);
                      } else {
                        console.log(`跳过重复的详情文本: ${textToAdd}`);
                      }
                    }
                  }
                }
              });
            } else {
              console.log(`未找到匹配的检验项: configTestItemsContentCode=${configTestItemsContentCode}`);
            }
          }
        } catch (e) {
          console.error('解析详情数据失败:', e, detailDataItem);
        }
      });

      console.log('收集到的详情文本数量:', detailTexts.length);
      console.log('收集到的详情文本:', detailTexts);

      // 如果有新的详情文本，添加到备注中
      if (detailTexts.length > 0) {
        const newText = detailTexts.join('\n');
        console.log('准备添加到备注的文本:', newText);
        console.log('当前备注内容:', this.equipmentInfo.remarks);

        if (this.equipmentInfo.remarks) {
          // 如果备注已有内容，追加新内容
          this.equipmentInfo.remarks = this.equipmentInfo.remarks + '\n' + newText;
        } else {
          // 如果备注为空，直接设置
          this.equipmentInfo.remarks = newText;
        }

        console.log('更新后的备注内容:', this.equipmentInfo.remarks);
      } else {
        console.log('没有新的详情文本需要添加到备注');
      }
    }
  }
};
</script>

<style scoped>
/* 页面容器样式 */
.record-page {
  height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 页面头部样式 */
.page-header {
  background-color: #fff;
  padding: 5px 24px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
}

.back-button {
  font-size: 16px;
  margin-right: 16px;
  color: #409eff;
}

.back-button:hover {
  color: #66b1ff;
}

.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.header-right {
  display: flex;
  gap: 12px;
}

/* 主要内容区域 */
.page-content {
  flex: 1;
  padding: 24px 24px 96px;
  overflow-y: auto;
  height: 0; /* 这个很重要，让flex子元素能够正确计算高度 */
}

/* 页面加载遮罩层样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 基本信息卡片样式 */
.info-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
  color: #303133;
}

.card-header-qrcode {
  width: 50px;
  height: 50px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}

.header-qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.equipment-params-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.params-title-wrapper {
  flex: 1;
}

.params-title-text {
  font-weight: bold;
  font-size: 14px;
  color: #303133;
  padding: 8px 12px;
  background-color: #f5f7fa;
  border-left: 4px solid #409eff;
}

.params-qrcode {
  width: 50px;
  height: 50px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  margin-left: 10px;
}

.params-qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.info-item {
  margin-bottom: 15px;
  padding: 8px 0;
}

.info-item .label {
  font-weight: bold;
  color: #606266;
  display: inline-block;
  min-width: 80px;
}

.info-item .value {
  color: #303133;
  margin-left: 8px;
}

/* 页面内容滚动样式 */
.page-content::-webkit-scrollbar {
  width: 8px;
}

.page-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.page-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.page-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 页面卡片样式 */
.page-card {
  margin-bottom: 24px;
  border: 1px solid #e4e7ed;
  transition: all 0.3s ease;
  border-radius: 8px;
  background-color: #fff;
}

.page-card:hover {
  border-color: #409eff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-content {
  min-height: 200px;
  padding: 24px;
}

/* 第一页左右两栏布局样式 */
.page-one-layout {
  display: flex;
  height: 700px;
  gap: 16px;
  min-height: 700px;
  max-height: 700px; /* 确保不会超出高度 */
  /* 正文主色：子级 el-table 默认 #606266，在此设主色并由表格 inherit 覆盖组件库默认 */
  color: #303133;
}

.page-one-layout ::v-deep .el-table {
  color: inherit;
}

/* 左侧导航面板样式 */
.navigation-panel {
  width: 15%;
  background-color: #f8f9fa;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.nav-title {
  background-color: #409eff;
  color: white;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
}

.nav-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}

.nav-item {
  padding: 8px 16px;
  cursor: pointer;
  border-bottom: 1px solid #ebeef5;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nav-item:hover {
  background-color: #ecf5ff;
  border-left: 3px solid #409eff;
}

.nav-item.active {
  background-color: #409eff;
  color: white;
  border-left: 3px solid #1890ff;
}

.nav-item.active:hover {
  background-color: #337ecc;
}

.nav-item-level-2 {
  padding-left: 24px;
}

.nav-number {
  font-weight: 600;
  font-size: 12px;
  color: #409eff;
}

.nav-item.active .nav-number {
  color: white;
}

.nav-description {
  font-size: 11px;
  color: #606266;
  line-height: 1.3;
  word-break: break-all;
}

.nav-item.active .nav-description {
  color: rgba(255, 255, 255, 0.9);
}

/* 右侧表格面板样式 */
.table-panel {
  width: 85%;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  height: 100%;
  position: relative;
}

/* 强制表格显示滚动条 */
.table-panel .el-table {
  height: 100% !important;
}

.table-panel .el-table .el-table__body-wrapper {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

/* 强制显示滚动条 */
.table-panel .el-table .el-table__body-wrapper::-webkit-scrollbar {
  width: 8px !important;
  display: block !important;
}

.table-panel .el-table .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1 !important;
  border-radius: 4px !important;
}

.table-panel .el-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1 !important;
  border-radius: 4px !important;
}

.table-panel .el-table .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8 !important;
}

/* 确保表格内容可以滚动 */
.table-panel .el-table__body {
  overflow: visible !important;
}

/* 为Firefox浏览器添加滚动条样式 */
.table-panel .el-table .el-table__body-wrapper {
  scrollbar-width: thin !important;
  scrollbar-color: #c1c1c1 #f1f1f1 !important;
}

/* 高亮行样式 */
.highlight-row {
  background-color: #fff7e6 !important;
  animation: highlight-fade 3s ease-out;
}

@keyframes highlight-fade {
  0% {
    background-color: #ffd591 !important;
  }
  100% {
    background-color: #fff7e6 !important;
  }
}

.placeholder-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
  background-color: #fafafa;
  border: 2px dashed #dcdfe6;
  border-radius: 4px;
  color: #909399;
  font-size: 14px;
}

.placeholder-content p {
  margin: 0;
  text-align: center;
}

/* 底部按钮样式 */
.dialog-footer {
  text-align: right;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
  margin-top: 20px;
}

/* 表格内容样式 */
.item-content {
  padding: 6px 8px;
  line-height: 1.5;
}

.item-visited-icon {
  color: #f56c6c;
  width: 24px;
  display: inline-block;
  text-align: center;
  margin-right: 4px;
  font-size: 20px;
  visibility: hidden;
}

.item-visited-icon.is-visible {
  visibility: visible;
}

.item-content-a13141 {
  align-items: flex-start;
}

.item-a13141-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  padding-left: 10px;
}

/* 第一层级样式 - 主要分类 */
.level-1 {
  font-weight: bold;
}

.level-1-number {
  font-weight: bold;
  color: #409eff;
  font-size: 18px;
  margin-right: 8px;
}

.level-1-desc {
  font-weight: bold;
  color: #303133;
  font-size: 18px;
  text-align: left;
}

/* 第二层级样式 - 子分类 */
.level-2 {
  padding-left: 20px;
}

.level-2-number {
  font-weight: bold;
  color: #409eff;
  font-size: 16px;
  margin-right: 8px;
}

.level-2-desc {
  font-weight: 600;
  /* color: #606266; */
  font-size: 16px;
  text-align: left;
}

/* 第三层级样式 - 具体检测项 */
.level-3 {
  padding-left: 40px;
}

.level-3-number {
  font-weight: normal;
  color: #909399;
  font-size: 16px;
  margin-right: 6px;
}

.level-3-desc {
  /* color: #606266; */
  font-size: 16px;
  line-height: 1.6;
  text-align: left;
}

/* 表格行样式 */
.el-table .el-table__row {
  height: auto;
}

.el-table .el-table__cell {
  padding: 8px 0 ;
}

/* 下拉框样式 */
.el-select {
  width: 100%;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-header {
    padding: 5px 16px;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .header-left {
    justify-content: flex-start;
  }

  .header-right {
    justify-content: center;
  }

  .page-content {
    padding: 16px;
  }

  .card-content {
    min-height: 150px;
    padding: 16px;
  }

  .placeholder-content {
    height: 120px;
  }

  .item-description {
    font-size: 12px;
  }

  .page-title {
    font-size: 18px;
  }
}

/* 第二页表格样式 */
.page-two-content {
  padding: 20px;
}

.table-section {
  margin-bottom: 30px;
}

.table-title {
  font-weight: bold;
  font-size: 14px;
  color: #303133;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-left: 4px solid #409eff;
}

/* 表格滚动容器 */
.table-scroll-wrapper {
  overflow-x: auto;
  overflow-y: visible;
}

/* 自定义水平滚动条样式 */
.table-scroll-wrapper::-webkit-scrollbar {
  height: 10px;
}

.table-scroll-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
}

.table-scroll-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 5px;
}

.table-scroll-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 分割单元格样式 */
.split-cell {
  position: relative;
  min-height: 80px;
  padding: 8px;
}

.cell-top-left {
  position: absolute;
  top: 8px;
  left: 8px;
  width: calc(50% - 12px);
}

.cell-bottom-right {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: calc(50% - 12px);
}

.split-cell::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom right, transparent 0%, transparent calc(50% - 1px), #dcdfe6 calc(50% - 1px), #dcdfe6 calc(50% + 1px), transparent calc(50% + 1px), transparent 100%);
  pointer-events: none;
}

.empty-cell {
  text-align: center;
  color: #909399;
}

.header-cell {
  text-align: center;
  font-weight: bold;
  color: #303133;
}

/* 表格内输入框样式 */
.split-cell .el-input__inner {
  padding: 5px 8px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
}

/* 行标签样式 */
.row-label {
  font-weight: bold;
  color: #303133;
  padding: 8px;
  text-align: center;
}

/* 表格信息行样式 */
.table-info-row {
  margin-bottom: 15px;
  padding: 15px;
  background-color: #f9f9f9;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.info-item-inline {
  display: flex;
  align-items: center;
}

.info-item-inline .label {
  font-weight: bold;
  color: #606266;
  white-space: nowrap;
  margin-right: 8px;
  min-width: 80px;
}

.info-item-inline .el-input {
  flex: 1;
}

/* 填写说明样式 */
.instructions-content {
  padding: 20px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
}

.instructions-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  margin: 0 0 20px 0;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 2px solid #409eff;
}

.instructions-list {
  line-height: 1.8;
}

.instruction-item {
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
}

.instruction-number {
  font-weight: bold;
  color: #409eff;
  min-width: 40px;
  flex-shrink: 0;
  font-size: 14px;
}

.instruction-text {
  color: #303133;
  font-size: 14px;
  line-height: 1.6;
  flex: 1;
}

/* 封面页样式 */
.cover-content {
  padding: 40px 60px;
  min-height: 600px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cover-top-row {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 40px;
  margin-bottom: 20px;
}

.cover-record-number {
  display: flex;
  align-items: center;
}

.cover-label {
  font-weight: bold;
  color: #303133;
  font-size: 16px;
  margin-right: 10px;
  white-space: nowrap;
}

.cover-input {
  width: 300px;
}

.cover-spacer {
  height: 60px;
}

.cover-spacer-large {
  height: 80px;
}

.cover-title-section {
  text-align: center;
  margin: 40px 0;
}

.cover-main-title {
  font-size: 28px;
  font-weight: bold;
  color: #303133;
  margin: 0 0 20px 0;
  line-height: 1.4;
}

.cover-sub-title {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin: 0;
  line-height: 1.4;
}

.cover-info-section {
  margin: 40px auto;
  max-width: 500px;
  text-align: center;
}

.cover-info-row {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  padding: 0 20px;
}

.cover-info-label {
  font-weight: bold;
  color: #303133;
  font-size: 16px;
  min-width: 140px;
  white-space: nowrap;
}

.cover-info-input {
  width: 300px;
  margin-left: 20px;
}

.cover-info-value {
  color: #303133;
  font-size: 16px;
  margin-left: 20px;
}

.cover-company {
  text-align: center;
  margin-top: 40px;
}

.cover-company-name {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin: 0;
}

/* 二维码上传样式 */
.cover-qrcode-section {
  margin-bottom: 0;
}

.cover-qrcode-upload {
  display: flex;
  align-items: flex-start;
}

.qrcode-upload-area {
  margin-left: 10px;
}

.qrcode-uploader {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.qrcode-uploader:hover {
  border-color: #409eff;
}

.qrcode-upload-placeholder {
  width: 120px;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
}

.qrcode-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  margin-bottom: 8px;
}

.qrcode-uploader-text {
  color: #606266;
  font-size: 14px;
}

.qrcode-preview {
  position: relative;
  width: 120px;
  height: 120px;
}

.qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.qrcode-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 4px;
  color: white;
  font-size: 12px;
}

.qrcode-preview:hover .qrcode-overlay {
  opacity: 1;
}

.qrcode-overlay i {
  font-size: 20px;
  margin-bottom: 4px;
}

/* 二维码显示样式（仅显示，不可上传） */
.qrcode-display {
  width: 120px;
  height: 120px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
  overflow: hidden;
}

.qrcode-display .qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.qrcode-empty-placeholder {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
}

/* 人员签名上传样式 */
.personnel-upload-area {
  margin-left: 10px;
}

.personnel-uploader {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.personnel-uploader:hover {
  border-color: #409eff;
}

.personnel-upload-placeholder {
  width: 150px;
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
}

.personnel-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  margin-bottom: 6px;
}

.personnel-uploader-text {
  color: #606266;
  font-size: 12px;
  text-align: center;
}

.personnel-preview {
  position: relative;
  width: 150px;
  height: 80px;
}

.personnel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.personnel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 4px;
  color: white;
  font-size: 11px;
}

.personnel-preview:hover .personnel-overlay {
  opacity: 1;
}

.personnel-overlay i {
  font-size: 16px;
  margin-bottom: 3px;
}

/* 响应式设计 - 封面页 */
@media (max-width: 768px) {
  .cover-content {
    padding: 20px 30px;
    min-height: 500px;
  }

  .cover-main-title {
    font-size: 22px;
  }

  .cover-sub-title {
    font-size: 18px;
  }

  .cover-info-row {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .cover-info-input {
    width: 100%;
    margin-left: 0;
    margin-top: 8px;
  }

  .cover-info-value {
    margin-left: 0;
    margin-top: 8px;
  }

  .cover-input {
    width: 100%;
  }

  .cover-spacer,
  .cover-spacer-large {
    height: 30px;
  }

  .cover-top-row {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .cover-qrcode-upload {
    flex-direction: column;
    align-items: flex-start;
  }

  .qrcode-upload-area {
    margin-left: 0;
    margin-top: 8px;
  }

  .qrcode-upload-placeholder,
  .qrcode-preview {
    width: 100px;
    height: 100px;
  }
}

/* 设备信息卡片样式 */
.equipment-info-content {
  padding: 20px;
}

.equipment-basic-info,
.equipment-params,
.detection-basis {
  margin-bottom: 20px;
}

.info-table-row {
  border: 1px solid #e4e7ed;
  margin-bottom: 0;
}

.info-label-col {
  background-color: #f5f7fa;
  border-right: 1px solid #e4e7ed;
  padding: 8px 12px;
  font-weight: bold;
  color: #303133;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
}

.info-label-col-vertical {
  background-color: #f5f7fa;
  border-right: 1px solid #e4e7ed;
  padding: 8px 12px;
  font-weight: bold;
  color: #303133;
  display: flex;
  align-items: center;
  justify-content: center;
  writing-mode: vertical-rl;
  text-orientation: upright;
  min-height: 80px;
}

.info-label-col-empty {
  background-color: #f5f7fa;
  border-right: 1px solid #e4e7ed;
  min-height: 40px;
}

.info-input-col {
  border-right: 1px solid #e4e7ed;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  min-height: 40px;
}

.info-input-col:last-child {
  border-right: none;
}

.instrument-table-section,
.environment-conditions-section {
  margin-bottom: 20px;
}

.section-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.section-title {
  font-weight: bold;
  font-size: 16px;
  color: #303133;
  padding: 10px;
  background-color: #f5f7fa;
  border-left: 4px solid #409eff;
  flex: 1;
}

.toolbox-selector {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.summary-section {
  margin-bottom: 20px;
}

.summary-item {
  margin-bottom: 15px;
}

.summary-label {
  font-weight: bold;
  color: #303133;
  margin-bottom: 8px;
}

.signature-section {
  border-top: 1px solid #e4e7ed;
  padding-top: 20px;
}

.signature-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.signature-label {
  font-weight: bold;
  color: #303133;
  margin-right: 10px;
  white-space: nowrap;
}

/* 响应式设计 - 设备信息 */
@media (max-width: 768px) {
  .equipment-info-content {
    padding: 15px;
  }

  .info-label-col-vertical {
    writing-mode: horizontal-tb;
    text-orientation: mixed;
    min-height: 40px;
  }

  .signature-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .signature-label {
    margin-bottom: 8px;
  }
}

/* 响应式设计 - 填写说明 */
@media (max-width: 768px) {
  .instructions-content {
    padding: 15px;
  }

  .instructions-title {
    font-size: 16px;
  }

  .instruction-text {
    font-size: 13px;
  }

  .instruction-number {
    min-width: 35px;
    font-size: 13px;
  }
}

/* 检验结果样式 */
.result-pass {
  color: #67c23a;
  font-weight: bold;
}

.result-fail {
  color: #f56c6c;
  font-weight: bold;
}

.item-content {
  display: flex;
  align-items: center;
  text-align: left;
}

.item-image-wrapper {
  margin-top: 8px;
}

.item-image {
  max-width: 100%;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.item-number {
  margin-right: 8px;
  font-weight: bold;
  white-space: nowrap;
  flex-shrink: 0;
}

.level-1-number {
  color: #409eff;
}

.level-2-number {
  color: #67c23a;
}

.level-3-number {
  color: #e6a23c;
}

/* 禁用的综合检验结果下拉框样式 */
.el-select.is-disabled .el-input__inner {
  background-color: #f5f7fa !important;
  border-color: #e4e7ed !important;
  color: #606266 !important;
}

.el-select.is-disabled .el-input__inner[aria-expanded='false'] {
  background-color: #f5f7fa !important;
}

/* 合格状态的下拉框 */
.auto-result-qualified .el-input__inner {
  color: #67c23a !important;
  font-weight: bold !important;
}

/* 不合格状态的下拉框 */
.auto-result-unqualified .el-input__inner {
  color: #f56c6c !important;
  font-weight: bold !important;
}

/* 检验结果颜色块样式 */
.result-color-block {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  min-width: 90px;
  max-width: 90px;
  min-height: 50px; /* 增加高度以容纳两行 */
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  box-sizing: border-box;
}

.result-color-block:hover {
  opacity: 0.8;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.result-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.result-text {
  color: #fff;
  font-weight: 500;
  line-height: 1.5;
}

.attachment-info {
  color: #fff;
  font-size: 11px;
  margin-top: 4px;
  line-height: 1.3;
  opacity: 0.95;
  font-style: italic;
  text-align: center;
  max-width: 66px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-all;
}

/* 检验结果单元格：左按钮 + 右详情列表 */
.result-cell {
  display: flex;
  align-items: stretch;
  gap: 10px;
  justify-content: center;
}

.result-cell-left {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.result-cell-right {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
  color: #606266;
  font-size: 12px;
  line-height: 1.4;
  padding: 6px 0;
  white-space: normal;
  word-break: break-all;
}

.result-detail-line {
  width: 100%;
}

/* 未选择状态 */
.result-none {
  background-color: #dcdfe6;
  border: 1px dashed #909399;
}

.result-none .result-text {
  color: #909399;
}

/* 不符合 - 灰色 */
.result-gray {
  background-color: #909399;
}

/* 合格无附表 - 绿色 */
.result-green {
  background-color: #67c23a;
}

/* 合格有附表 - 黄色 */
.result-yellow {
  background-color: #e6a23c;
}

/* 无此项 - 蓝色 */
.result-blue {
  background-color: #409eff;
}

/* 表格行高增加 */
.page-one-layout ::v-deep .el-table__row {
  height: 80px !important; /* 原来大约40px，现在增加到80px */
}

.page-one-layout ::v-deep .el-table__row.row-level-1,
.page-one-layout ::v-deep .el-table__row.row-level-2 {
  height: 30px !important;
}

.page-one-layout ::v-deep .el-table__row td {
  padding: 5px 0 !important; /* 增加上下padding */
}

.page-one-layout ::v-deep .el-table__row.row-level-1 td,
.page-one-layout ::v-deep .el-table__row.row-level-2 td {
  padding: 0 !important;
}

.page-one-layout ::v-deep .el-table__row.group-start-row td {
  border-top: 4px solid #409eff !important;
}

.page-one-layout ::v-deep .el-table__row.group-end-row td {
  border-bottom: 4px solid #409eff !important;
}

.page-one-layout ::v-deep .el-table__row.level-3-group-start-row td {
  border-top: 2px solid #409eff !important;
}

.page-one-layout ::v-deep .el-table__row.level-3-group-end-row td {
  border-bottom: 2px solid #409eff !important;
}

.page-one-layout ::v-deep .el-table__row .cell {
  line-height: 1.5 !important;
  display: flex;
  align-items: center;
  justify-content: left;
  min-height: 60px;
  color: inherit;
}

.page-one-layout ::v-deep .el-table__row.row-level-1 .cell,
.page-one-layout ::v-deep .el-table__row.row-level-2 .cell {
  min-height: 30px !important;
}

/* 检验结果编辑弹窗样式 */
.result-dialog-content {
  padding: 20px 10px;
}

.result-item-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.info-label {
  font-weight: bold;
  color: #606266;
  margin-bottom: 8px;
}

.info-value {
  color: #303133;
  line-height: 1.6;
}

.result-selection {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.selection-label {
  font-weight: bold;
  color: #606266;
  margin-bottom: 12px;
}

.attachment-section {
  padding: 15px;
  background-color: #ecf5ff;
  border-radius: 4px;
  border-left: 4px solid #409eff;
}

.attachment-label {
  font-weight: bold;
  color: #606266;
  margin-bottom: 10px;
}

/* 详情列表样式 */
.detail-list-section .detail-item ::v-deep .el-checkbox__label {
  display: none !important;
}

.detail-list-section .detail-item .el-checkbox {
  margin-right: 10px;
}

/* 附表弹窗样式 */
.attachment-dialog-content {
  max-height: 75vh;
  overflow-y: auto;
}

.no-attachment {
  text-align: center;
  padding: 40px;
  color: #909399;
}
</style>
